import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type ConversationInformation = {
  __typename?: 'ConversationInformation';
  conversationId: Scalars['String'];
  encodedAlias: Scalars['String'];
  listingAlias: Scalars['String'];
  referenceId: Scalars['String'];
  referenceIdType: Scalars['String'];
  renterBrand: Scalars['String'];
  renterEmailAddress: Scalars['String'];
  renterName?: Maybe<Scalars['String']>;
};

export type FeatureFlagResponse = {
  __typename?: 'FeatureFlagResponse';
  canAccessBlockedUserModalFromRJSModule?: Maybe<Scalars['Boolean']>;
  enableExternalLinkWarningModal?: Maybe<Scalars['Boolean']>;
  enableGlobalLeadManagement?: Maybe<Scalars['Boolean']>;
  enableInboxIA?: Maybe<Scalars['Boolean']>;
  enableLeadMessaging?: Maybe<Scalars['Boolean']>;
  enableMessageLink?: Maybe<Scalars['Boolean']>;
  enableMessageLinkInSLW?: Maybe<Scalars['Boolean']>;
  enableMessageToolbar?: Maybe<Scalars['Boolean']>;
  enablePersonalInfoWarningModal?: Maybe<Scalars['Boolean']>;
  enableQuickResponse?: Maybe<Scalars['Boolean']>;
  enableRentingBuyingPills?: Maybe<Scalars['Boolean']>;
  enableRescheduleTour?: Maybe<Scalars['Boolean']>;
  enableTMP?: Maybe<Scalars['Boolean']>;
  enableTourScheduling?: Maybe<Scalars['Boolean']>;
  enableUserObjectOptimization?: Maybe<Scalars['Boolean']>;
  enableWebsocketForRachelInbox?: Maybe<Scalars['Boolean']>;
  enableWebsocketIntegration?: Maybe<Scalars['Boolean']>;
};

export type FeatureFlagsAndSettingsResponse = {
  __typename?: 'FeatureFlagsAndSettingsResponse';
  features?: Maybe<FeatureFlagResponse>;
  settings?: Maybe<SettingsResponse>;
};

export enum Folder {
  Archived = 'ARCHIVED',
  Favorite = 'FAVORITE',
  Inbox = 'INBOX',
  ShowAll = 'SHOW_ALL',
  Spam = 'SPAM',
}

export type ListingAnalytics = {
  __typename?: 'ListingAnalytics';
  clickCount: Scalars['Int'];
  feedId: Scalars['String'];
  feedListingId: Scalars['String'];
  impressionCount: Scalars['Int'];
  leadCount: Scalars['Int'];
  listingAliases: Array<Scalars['String']>;
  listingName: Scalars['String'];
  viewCount: Scalars['Int'];
};

export type MarketInsights = {
  __typename?: 'MarketInsights';
  clickAverage: Scalars['Float'];
  daysOnMarketAverage: Scalars['Float'];
  impressionsAverage: Scalars['Float'];
  leadsAverage: Scalars['Float'];
  leadsRate: Scalars['Float'];
  reviewAverage: Scalars['Float'];
  viewsAverage: Scalars['Float'];
  weight: Scalars['Float'];
};

export type Mutation = {
  __typename?: 'Mutation';
  RH_addMessageToConversation: Rh_Message;
  RH_addMessageToConversationV2: Rh_Message;
  /** @deprecated Use the useSatelliteWebConversationHandler_deleteAttachments React Query hook from ts-clients instead. */
  RH_deleteAttachments?: Maybe<Rh_SuccessStatusResponse>;
  RH_RequestToApply: Rh_RequestToApplyResponse;
  RH_updateConversationStatus?: Maybe<Rh_SuccessStatusResponse>;
  RH_updateConversationStatusV2: Rh_SuccessStatusResponse;
  ZRM_addMessageToConversationV2: Zrm_Message;
  ZRM_addSavedReplies: Zrm_GetOrAddSavedRepliesResponse;
  ZRM_addSystemMessageToConversation: Zrm_AddSystemMessageToConversationResponse;
  ZRM_applicationsAccepted?: Maybe<Zrm_SuccessStatusResponse>;
  ZRM_deleteAttachments: Zrm_SuccessStatusResponse;
  ZRM_deleteSavedReplies: Zrm_SuccessStatusResponse;
  ZRM_editSavedReply: Zrm_SuccessStatusResponse;
  ZRM_enableApplications?: Maybe<Zrm_SuccessStatusResponse>;
  ZRM_inviteToApply: Zrm_InviteResponse;
  ZRM_markConversationAsUnread: Zrm_SuccessStatusResponse;
  ZRM_updateConversationAttributes: Zrm_SuccessStatusResponse;
  ZRM_updateConversationStatus: Zrm_SuccessStatusResponse;
  ZRM_updateConversationStatusV2: Zrm_SuccessStatusResponse;
  ZRM_updateNote: Zrm_SuccessStatusResponse;
};

export type MutationRh_AddMessageToConversationArgs = {
  conversationId: Scalars['String'];
  isMessageOwner?: Maybe<Scalars['Boolean']>;
  message: Scalars['String'];
};

export type MutationRh_AddMessageToConversationV2Args = {
  conversationId: Scalars['String'];
  message: Scalars['String'];
  zDocIds: Array<Scalars['String']>;
};

export type MutationRh_DeleteAttachmentsArgs = {
  attachmentsToBeDeleted: Array<Rh_AttachmentToBeDeletedArg>;
  conversationId: Scalars['String'];
  listingAlias: Scalars['String'];
};

export type MutationRh_RequestToApplyArgs = {
  alias?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  requestToApply?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
};

export type MutationRh_UpdateConversationStatusArgs = {
  conversationId: Scalars['String'];
  isArchived?: Maybe<Scalars['Boolean']>;
  isSpam?: Maybe<Scalars['Boolean']>;
  lastReadMs?: Maybe<Scalars['String']>;
};

export type MutationRh_UpdateConversationStatusV2Args = {
  conversationId: Scalars['String'];
  isArchived?: Maybe<Scalars['Boolean']>;
  lastReadMs?: Maybe<Scalars['String']>;
  reportReasonType?: Maybe<ReportConversationReason>;
  userReportComment?: Maybe<Scalars['String']>;
};

export type MutationZrm_AddMessageToConversationV2Args = {
  conversationId: Scalars['String'];
  listingAlias?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  quickResponseSuggestionId?: Maybe<Scalars['String']>;
  zDocIds: Array<Scalars['String']>;
};

export type MutationZrm_AddSavedRepliesArgs = {
  savedReplies: Array<SavedReplyArg>;
};

export type MutationZrm_AddSystemMessageToConversationArgs = {
  conversationId: Scalars['String'];
  messageType: Scalars['String'];
};

export type MutationZrm_ApplicationsAcceptedArgs = {
  applicationsAccepted?: Maybe<Scalars['Boolean']>;
  listingAlias: Scalars['String'];
  requireUserName?: Maybe<Scalars['Boolean']>;
};

export type MutationZrm_DeleteAttachmentsArgs = {
  attachmentsToBeDeleted: Array<Zrm_AttachmentToBeDeletedArg>;
  conversationId: Scalars['String'];
  listingAlias: Scalars['String'];
};

export type MutationZrm_DeleteSavedRepliesArgs = {
  savedReplyIndices: Array<Scalars['Int']>;
};

export type MutationZrm_EditSavedReplyArgs = {
  savedReply: SavedReplyArg;
};

export type MutationZrm_InviteToApplyArgs = {
  listingId: Scalars['String'];
  renterFirstName: Scalars['String'];
  renterLastName: Scalars['String'];
  resendEmail?: Maybe<Scalars['Boolean']>;
  toEmail: Scalars['String'];
};

export type MutationZrm_MarkConversationAsUnreadArgs = {
  conversationId: Scalars['String'];
};

export type MutationZrm_UpdateConversationAttributesArgs = {
  applicationMarkedSent?: Maybe<Scalars['Boolean']>;
  conversationId: Scalars['String'];
  isFavorite?: Maybe<Scalars['Boolean']>;
  listingAlias?: Maybe<Scalars['String']>;
  listingId?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  tourScheduledTimestampMs?: Maybe<Scalars['String']>;
};

export type MutationZrm_UpdateConversationStatusArgs = {
  conversationId: Scalars['String'];
  isArchived?: Maybe<Scalars['Boolean']>;
  isSpam?: Maybe<Scalars['Boolean']>;
  lastReadMs?: Maybe<Scalars['String']>;
  listingAlias?: Maybe<Scalars['String']>;
  listingId?: Maybe<Scalars['String']>;
};

export type MutationZrm_UpdateConversationStatusV2Args = {
  conversationId: Scalars['String'];
  isArchived?: Maybe<Scalars['Boolean']>;
  lastReadMs?: Maybe<Scalars['String']>;
  reportReasonType?: Maybe<ReportConversationReason>;
  userReportComment?: Maybe<Scalars['String']>;
};

export type MutationZrm_UpdateNoteArgs = {
  conversationId: Scalars['String'];
  note: Scalars['String'];
};

export type PortfolioInsights = {
  __typename?: 'PortfolioInsights';
  clickAverage: Scalars['Float'];
  daysOnMarketAverage: Scalars['Float'];
  impressionsAverage: Scalars['Float'];
  leadsAverage: Scalars['Float'];
  leadsRate: Scalars['Float'];
  reviewAverage: Scalars['Float'];
  viewsAverage: Scalars['Float'];
  weight: Scalars['Float'];
};

export type Query = {
  __typename?: 'Query';
  getFeatureFlags?: Maybe<FeatureFlagResponse>;
  getFeatureFlagsAndSettings?: Maybe<FeatureFlagsAndSettingsResponse>;
  RH_getAllForInquiryId: Rh_Conversation;
  RH_getConversationById: Rh_Conversation;
  RH_getDocumentUploadToken?: Maybe<Scalars['String']>;
  RH_getHotpadsUser: User;
  RH_getLatestConversations: Rh_ConversationResponse;
  RH_getSyndicationUrls?: Maybe<Rh_SyndicationUrls>;
  RH_getTruliaUser: User;
  RH_getZdocIdsForMessageTokens: Array<Scalars['String']>;
  RH_getZillowUser: User;
  ZRM_getAbTestVersions: Zrm_AbTestVersionsResponse;
  ZRM_getAggregateConversationCount?: Maybe<Zrm_AggregateConversationCount>;
  ZRM_getAttachmentsByConversationId: Zrm_GetAttachmentsByConversationIdResponse;
  ZRM_getConnectedExperience: Zrm_ConnectedExperience;
  ZRM_getConversationById: Zrm_Conversation;
  ZRM_getConversationCountsForListings?: Maybe<Array<Maybe<Zrm_ListingStats>>>;
  ZRM_getConversationInformationByInquiryId: ConversationInformation;
  ZRM_getConversationSearchResult: Zrm_GetConversationSearchResultResponse;
  ZRM_getDocumentUploadToken?: Maybe<Scalars['String']>;
  ZRM_getExperimentTreatment: Zrm_GetExperimentTreatmentResponse;
  ZRM_getLatestConversationsV2: Zrm_ConversationResponse;
  ZRM_getLeadManagementCounts: Zrm_GetLeadManagementCountsResponse;
  ZRM_getLeadManagementLeads: Zrm_GetLeadManagementLeadsResponse;
  ZRM_getLeadManagementSearchResult: Zrm_GetLeadManagementSearchResultResponse;
  ZRM_getLeadManagementStats: Zrm_GetLeadManagementStatsResponse;
  ZRM_getListingPerformance: Zrm_GetListingPerformanceResponse;
  ZRM_getPropertiesList: Zrm_GetPropertiesListResponse;
  ZRM_getPropertyAddress: Zrm_GetPropertyAddressResponse;
  ZRM_getPropertySearchResult: Zrm_GetPropertySearchResultResponse;
  ZRM_getPropertyWebAnalytics: Zrm_GetPropertyWebAnalyticsResponse;
  ZRM_getSavedReplies: Zrm_GetOrAddSavedRepliesResponse;
  ZRM_getUser: User;
  ZRM_getZdocIdsForMessageTokens: Array<Scalars['String']>;
};

export type QueryGetFeatureFlagsArgs = {
  appName: Scalars['String'];
};

export type QueryGetFeatureFlagsAndSettingsArgs = {
  appName: Scalars['String'];
};

export type QueryRh_GetAllForInquiryIdArgs = {
  includeAttachmentsMetadata?: Maybe<Scalars['Boolean']>;
  inquiryId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  paginationStartIndex?: Maybe<Scalars['String']>;
  startIndex?: Maybe<Scalars['Int']>;
};

export type QueryRh_GetConversationByIdArgs = {
  conversationId: Scalars['String'];
  includeAttachmentsMetadata?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  paginationStartIndex?: Maybe<Scalars['String']>;
  startIndex?: Maybe<Scalars['String']>;
};

export type QueryRh_GetLatestConversationsArgs = {
  archivedOnly?: Maybe<Scalars['Boolean']>;
  daysBack?: Maybe<Scalars['Int']>;
  folder?: Maybe<Folder>;
  limit?: Maybe<Scalars['Int']>;
  notRepliedToOnly?: Maybe<Scalars['Boolean']>;
  paginationStartIndex?: Maybe<Scalars['String']>;
  spamOnly?: Maybe<Scalars['Boolean']>;
  startIndex?: Maybe<Scalars['String']>;
  unreadOnly?: Maybe<Scalars['Boolean']>;
};

export type QueryRh_GetSyndicationUrlsArgs = {
  listingAlias: Scalars['String'];
};

export type QueryRh_GetZdocIdsForMessageTokensArgs = {
  messageTokens: Array<Scalars['String']>;
};

export type QueryZrm_GetAbTestVersionsArgs = {
  enrollInExperiment?: Maybe<Scalars['Boolean']>;
  experimentPercent?: Maybe<Scalars['Int']>;
  tests: Scalars['String'];
};

export type QueryZrm_GetAttachmentsByConversationIdArgs = {
  conversationId: Scalars['String'];
};

export type QueryZrm_GetConnectedExperienceArgs = {
  propertyId: Scalars['String'];
};

export type QueryZrm_GetConversationByIdArgs = {
  clientTimeZone?: Maybe<Scalars['String']>;
  conversationId: Scalars['String'];
  includeAttachmentsMetadata?: Maybe<Scalars['Boolean']>;
  includeInquiryInfo?: Maybe<Scalars['Boolean']>;
  includeRenterProfile?: Maybe<Scalars['Boolean']>;
  includeStatusLabels?: Maybe<Scalars['Boolean']>;
  includeSystemMessages?: Maybe<Scalars['Boolean']>;
  includeUserLeadAttributes?: Maybe<Scalars['Boolean']>;
  listingAlias?: Maybe<Scalars['String']>;
  listingId?: Maybe<Scalars['String']>;
  paginationStartIndex?: Maybe<Scalars['String']>;
  startIndex?: Maybe<Scalars['Int']>;
};

export type QueryZrm_GetConversationInformationByInquiryIdArgs = {
  inquiryId: Scalars['String'];
};

export type QueryZrm_GetConversationSearchResultArgs = {
  endTimestampMs: Scalars['String'];
  limit: Scalars['Int'];
  listingAlias?: Maybe<Scalars['String']>;
  offset: Scalars['Int'];
  searchText: Scalars['String'];
  startTimestampMs: Scalars['String'];
};

export type QueryZrm_GetExperimentTreatmentArgs = {
  featureName: Scalars['String'];
  listingAlias?: Maybe<Scalars['String']>;
};

export type QueryZrm_GetLatestConversationsV2Args = {
  clientTimeZone?: Maybe<Scalars['String']>;
  conversationId?: Maybe<Scalars['String']>;
  daysBack?: Maybe<Scalars['Int']>;
  endDateYyyyMmDd?: Maybe<Scalars['String']>;
  excludeNote?: Maybe<Scalars['Boolean']>;
  folder?: Maybe<Folder>;
  includeRenterProfile?: Maybe<Scalars['Boolean']>;
  includeStatusLabels?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  listingAlias?: Maybe<Scalars['String']>;
  listingId?: Maybe<Scalars['String']>;
  paginationStartIndex?: Maybe<Scalars['String']>;
  readRepliedStatus?: Maybe<ReadRepliedStatus>;
  renterProgressStatus?: Maybe<RenterProgressStatus>;
  startDateYyyyMmDd?: Maybe<Scalars['String']>;
  startIndex?: Maybe<Scalars['Int']>;
};

export type QueryZrm_GetLeadManagementCountsArgs = {
  folder?: Maybe<Folder>;
  includePhoneLeads?: Maybe<Scalars['Boolean']>;
  listingAlias: Scalars['String'];
  minCriteriaMatches?: Maybe<Scalars['Int']>;
  readRepliedStatus?: Maybe<ReadRepliedStatus>;
  renterProgressStatus?: Maybe<RenterProgressStatus>;
};

export type QueryZrm_GetLeadManagementLeadsArgs = {
  clientTimeZone: Scalars['String'];
  conversationId?: Maybe<Scalars['String']>;
  folder?: Maybe<Folder>;
  includePhoneLeads?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  listingAlias?: Maybe<Scalars['String']>;
  minCriteriaMatches?: Maybe<Scalars['Int']>;
  readRepliedStatus?: Maybe<ReadRepliedStatus>;
  renterProgressStatus?: Maybe<RenterProgressStatus>;
  start?: Maybe<Scalars['Int']>;
};

export type QueryZrm_GetLeadManagementSearchResultArgs = {
  endTimestampMs: Scalars['String'];
  limit: Scalars['Int'];
  listingAlias: Scalars['String'];
  offset: Scalars['Int'];
  searchText: Scalars['String'];
  startTimestampMs: Scalars['String'];
};

export type QueryZrm_GetLeadManagementStatsArgs = {
  listingAlias: Scalars['String'];
};

export type QueryZrm_GetListingPerformanceArgs = {
  endDayYyyyMmDd: Scalars['String'];
  includeFreeStats?: Maybe<Scalars['Boolean']>;
  includeMarketInsights: Scalars['Boolean'];
  includeOlympus?: Maybe<Scalars['Boolean']>;
  listingAlias?: Maybe<Scalars['String']>;
  startDayYyyyMmDd: Scalars['String'];
};

export type QueryZrm_GetPropertiesListArgs = {
  includeActive?: Maybe<Scalars['Boolean']>;
  includeArchived?: Maybe<Scalars['Boolean']>;
  includeAtRisk?: Maybe<Scalars['Boolean']>;
  includeFeedClaimAndConvertUpdate?: Maybe<Scalars['Boolean']>;
  includeInactive?: Maybe<Scalars['Boolean']>;
  includeMaintenancePartner?: Maybe<Scalars['Boolean']>;
  includeUnarchived?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  searchText?: Maybe<Scalars['String']>;
  startKeyExclusive?: Maybe<Scalars['String']>;
};

export type QueryZrm_GetPropertyAddressArgs = {
  propertyId: Scalars['String'];
};

export type QueryZrm_GetPropertySearchResultArgs = {
  includeMultifamily?: Maybe<Scalars['Boolean']>;
  includeSingleFamily?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  searchText?: Maybe<Scalars['String']>;
  startKeyExclusive?: Maybe<Scalars['String']>;
};

export type QueryZrm_GetPropertyWebAnalyticsArgs = {
  propertyId: Scalars['String'];
};

export type QueryZrm_GetZdocIdsForMessageTokensArgs = {
  messageTokens: Array<Scalars['String']>;
};

export enum ReadRepliedStatus {
  NotRepliedTo = 'NOT_REPLIED_TO',
  ShowAll = 'SHOW_ALL',
  Unread = 'UNREAD',
}

export enum RenterHubApiTotalMonthlyPriceDisplayType {
  FeesMayApply = 'FEES_MAY_APPLY',
  Legacy = 'LEGACY',
  TotalPrice = 'TOTAL_PRICE',
}

export enum RenterProgressStatus {
  Applicants = 'APPLICANTS',
  Inquiries = 'INQUIRIES',
  ShowAll = 'SHOW_ALL',
  Tenants = 'TENANTS',
  Tours = 'TOURS',
}

export enum ReportConversationReason {
  DiscriminatoryOrAbusive = 'DISCRIMINATORY_OR_ABUSIVE',
  NotReported = 'NOT_REPORTED',
  Other = 'OTHER',
  Spam = 'SPAM',
}

export type Rh_AddressDetails = {
  __typename?: 'RH_AddressDetails';
  stateAbbrev?: Maybe<Scalars['String']>;
};

export type Rh_Application = {
  __typename?: 'RH_Application';
  applicationAlreadySentToRenter?: Maybe<Scalars['Boolean']>;
  applicationId?: Maybe<Scalars['String']>;
  hasRequestedToApply?: Maybe<Scalars['Boolean']>;
  isApplicationEnabledByLandlord?: Maybe<Scalars['Boolean']>;
  isApplicationsAllowed?: Maybe<Scalars['Boolean']>;
};

export type Rh_Attachment = {
  __typename?: 'RH_Attachment';
  attachmentAddedMs?: Maybe<Scalars['String']>;
  attachmentExpirationMs?: Maybe<Scalars['String']>;
  attachmentMetadataStatus?: Maybe<Scalars['String']>;
  downloadUrl?: Maybe<Scalars['String']>;
  downloadUrlExpirationMs?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileSizeBytes?: Maybe<Scalars['Int']>;
  fileType?: Maybe<Scalars['String']>;
  isAttachmentDeleted?: Maybe<Scalars['Boolean']>;
  isAttachmentExpired?: Maybe<Scalars['Boolean']>;
  previewUrl?: Maybe<Scalars['String']>;
  previewUrlExpirationMs?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
  zDocId?: Maybe<Scalars['String']>;
};

export type Rh_AttachmentToBeDeletedArg = {
  messageId: Scalars['String'];
  zDocId: Scalars['String'];
};

export type Rh_Conversation = {
  __typename?: 'RH_Conversation';
  acceptsReplies?: Maybe<Scalars['Boolean']>;
  acceptsRepliesExplanation?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  addressDetails?: Maybe<Rh_AddressDetails>;
  application?: Maybe<Rh_Application>;
  applicationAlreadySent?: Maybe<Scalars['Boolean']>;
  beds?: Maybe<Scalars['String']>;
  conversation: Array<Rh_Message>;
  conversationId?: Maybe<Scalars['String']>;
  disclaimers?: Maybe<Rh_Disclaimers>;
  encodedAlias?: Maybe<Scalars['String']>;
  feedId: Scalars['String'];
  feedListingId: Scalars['String'];
  hasUnreadMessage: Scalars['Boolean'];
  inquiryId: Scalars['String'];
  isActive: Scalars['Boolean'];
  isApplicationEnabledByLandlord?: Maybe<Scalars['Boolean']>;
  isApplicationsAllowed?: Maybe<Scalars['Boolean']>;
  isConversationBlockedByZillow: Scalars['Boolean'];
  isMultifamily?: Maybe<Scalars['Boolean']>;
  landlordName?: Maybe<Scalars['String']>;
  lastReadTimestampMs?: Maybe<Scalars['String']>;
  listingAlias?: Maybe<Scalars['String']>;
  listingName?: Maybe<Scalars['String']>;
  numBathroomsHigh?: Maybe<Scalars['String']>;
  numBathroomsLow?: Maybe<Scalars['String']>;
  pagination?: Maybe<Rh_Pagination>;
  photoUrl?: Maybe<Scalars['String']>;
  pricing?: Maybe<Scalars['String']>;
  pricingDetails?: Maybe<Rh_PricingDetails>;
  pricingDisplay?: Maybe<RenterHubApiTotalMonthlyPriceDisplayType>;
  propertyTypeCode?: Maybe<Scalars['Int']>;
  referenceEmail?: Maybe<Scalars['String']>;
  referenceName?: Maybe<Scalars['String']>;
  referenceRelayEmail?: Maybe<Scalars['String']>;
  status: Rh_ConversationStatus;
};

export type Rh_ConversationResponse = {
  __typename?: 'RH_ConversationResponse';
  conversations: Array<Rh_Conversation>;
  pagination?: Maybe<Rh_Pagination>;
};

export type Rh_ConversationStatus = {
  __typename?: 'RH_ConversationStatus';
  isArchived: Scalars['Boolean'];
  isInvitedToApply: Scalars['Boolean'];
  isScheduled: Scalars['Boolean'];
  isSpam: Scalars['Boolean'];
};

export type Rh_Disclaimer = {
  __typename?: 'RH_Disclaimer';
  disclaimerText: Scalars['String'];
  emailLinks?: Maybe<Array<Maybe<Rh_DisclaimerEmailLink>>>;
  links?: Maybe<Array<Maybe<Rh_DisclaimerLink>>>;
};

export type Rh_DisclaimerEmailLink = {
  __typename?: 'RH_DisclaimerEmailLink';
  emailAddress: Scalars['String'];
  textToDisplay: Scalars['String'];
  textToReplace: Scalars['String'];
};

export type Rh_DisclaimerLink = {
  __typename?: 'RH_DisclaimerLink';
  textToDisplay: Scalars['String'];
  textToReplace: Scalars['String'];
  url: Scalars['String'];
};

export type Rh_Disclaimers = {
  __typename?: 'RH_Disclaimers';
  ai: Rh_Disclaimer;
};

export type Rh_Message = {
  __typename?: 'RH_Message';
  aiAutoResponseType?: Maybe<SatelliteAiAutoResponseType>;
  attachments: Array<Rh_Attachment>;
  conversationId?: Maybe<Scalars['String']>;
  isMessageOwner?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  messageDate?: Maybe<Scalars['String']>;
  messageDateMs: Scalars['String'];
  messageId?: Maybe<Scalars['String']>;
  messageLink?: Maybe<Zrm_Cta_Link>;
  messageType: Scalars['String'];
  senderEmail?: Maybe<Scalars['String']>;
  senderName?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  uiTreatmentType?: Maybe<Scalars['String']>;
};

export type Rh_Pagination = {
  __typename?: 'RH_Pagination';
  hasNextPage?: Maybe<Scalars['Boolean']>;
  pageConversationCount?: Maybe<Scalars['Int']>;
  pageStartIndex?: Maybe<Scalars['Int']>;
  queryFullConversationCount?: Maybe<Scalars['Int']>;
};

export type Rh_PricingDetails = {
  __typename?: 'RH_PricingDetails';
  baseRentMax?: Maybe<Scalars['Float']>;
  baseRentMin?: Maybe<Scalars['Float']>;
  isHasBaseRentAndFees: Scalars['Boolean'];
  totalRequiredMonthlyFeeMax?: Maybe<Scalars['Float']>;
  totalRequiredMonthlyFeeMin?: Maybe<Scalars['Float']>;
};

export type Rh_RequestToApplyResponse = {
  __typename?: 'RH_RequestToApplyResponse';
  status?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type Rh_SuccessStatusResponse = {
  __typename?: 'RH_SuccessStatusResponse';
  success: Scalars['Boolean'];
};

export type Rh_SyndicationUrls = {
  __typename?: 'RH_SyndicationUrls';
  hotpadsUrl?: Maybe<Scalars['String']>;
  truliaUrl?: Maybe<Scalars['String']>;
  zillowUrl?: Maybe<Scalars['String']>;
};

export enum SatelliteAiAutoResponseType {
  EliseAi = 'ELISE_AI',
}

export type SavedReply = {
  __typename?: 'SavedReply';
  dateUpdatedMs?: Maybe<Scalars['String']>;
  reply: Scalars['String'];
  replyIndex: Scalars['Int'];
  title: Scalars['String'];
};

export type SavedReplyArg = {
  reply: Scalars['String'];
  replyIndex: Scalars['Int'];
  title: Scalars['String'];
};

export type SettingsResponse = {
  __typename?: 'SettingsResponse';
  abTreatmentForTMP?: Maybe<Scalars['String']>;
  aiConversationPollIntervalInSeconds?: Maybe<Scalars['Int']>;
};

export type User = {
  __typename?: 'User';
  applicationsEnabled: Scalars['Boolean'];
  canUpdateListing: Scalars['Boolean'];
  csrfToken?: Maybe<Scalars['String']>;
  customers: Array<Zrm_CustomerSummary>;
  email?: Maybe<Scalars['String']>;
  encodedZuid?: Maybe<Scalars['String']>;
  features: Zrm_Features;
  firstName?: Maybe<Scalars['String']>;
  hasAcceptedZillowRentalUserTerms?: Maybe<Scalars['Boolean']>;
  hasPaidForListing?: Maybe<Scalars['Boolean']>;
  hasSeenNewPaymentsPage?: Maybe<Scalars['Boolean']>;
  hasSeenPaymentsAggregatedViewModal?: Maybe<Scalars['Boolean']>;
  hasSeenRentGuarantee?: Maybe<Scalars['Boolean']>;
  hasStrongAuthentication?: Maybe<Scalars['Boolean']>;
  impersonatorEmail?: Maybe<Scalars['String']>;
  impersonatorUserToken?: Maybe<Scalars['String']>;
  isAcceptingApplications?: Maybe<Scalars['Boolean']>;
  isEmailVerified?: Maybe<Scalars['Boolean']>;
  isEnterpriseCustomer?: Maybe<Scalars['Boolean']>;
  isHousingConnector?: Maybe<Scalars['Boolean']>;
  isIdVerified?: Maybe<Scalars['Boolean']>;
  isImpersonationAllowed?: Maybe<Scalars['Boolean']>;
  isLeasingBeta: Scalars['Boolean'];
  isMocked?: Maybe<Scalars['Boolean']>;
  isMultifamilyCustomer: Scalars['Boolean'];
  isPasswordlessAccount?: Maybe<Scalars['Boolean']>;
  isPostingPathAdmin?: Maybe<Scalars['Boolean']>;
  isPremiumCustomer?: Maybe<Scalars['Boolean']>;
  isPropertyManager?: Maybe<Scalars['Boolean']>;
  isPropertyManagerCompanyAdmin?: Maybe<Scalars['Boolean']>;
  isRocketshipCustomer?: Maybe<Scalars['Boolean']>;
  /** @deprecated Field no longer supported */
  isRocketshipCustomerOnly?: Maybe<Scalars['Boolean']>;
  isSelfServeCustomer?: Maybe<Scalars['Boolean']>;
  isSingleFamilyEnterpriseCustomer?: Maybe<Scalars['Boolean']>;
  isTwoFactorAuthEnabled?: Maybe<Scalars['Boolean']>;
  isTwoFactorAuthenticated?: Maybe<Scalars['Boolean']>;
  isUserBlocked?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loggedIn: Scalars['Boolean'];
  paymentsAcceptedCount?: Maybe<Scalars['Int']>;
  paymentsAccessAllowed: Scalars['Boolean'];
  /** @deprecated Field no longer supported */
  phoneNumber?: Maybe<Scalars['String']>;
  profileImageUrl?: Maybe<Scalars['String']>;
  profiles?: Maybe<Zrm_Profiles>;
  restrictions?: Maybe<Zrm_Restrictions>;
  /** @deprecated Field no longer supported */
  roles?: Maybe<Array<Scalars['String']>>;
  sessionSecondsRemaining?: Maybe<Scalars['Int']>;
  setCookies?: Maybe<Array<Scalars['String']>>;
  summary?: Maybe<Zrm_Summary>;
  userManagementCompanyId?: Maybe<Scalars['String']>;
  userToken?: Maybe<Scalars['String']>;
};

export type Zrm_AbTestVersionsResponse = {
  __typename?: 'ZRM_AbTestVersionsResponse';
  experimentDtos: Array<Zrm_Experiment>;
};

export type Zrm_AddSystemMessageToConversationResponse = {
  __typename?: 'ZRM_addSystemMessageToConversationResponse';
  brandName?: Maybe<Scalars['String']>;
  conversationId: Scalars['String'];
  dateSentMs: Scalars['String'];
  listingAlias: Scalars['String'];
  message: Scalars['String'];
  messageId: Scalars['String'];
  messageType?: Maybe<Scalars['String']>;
  referenceId?: Maybe<Scalars['String']>;
  referenceIdType?: Maybe<Scalars['String']>;
  senderName?: Maybe<Scalars['String']>;
};

export type Zrm_AggregateConversationCount = {
  __typename?: 'ZRM_AggregateConversationCount';
  notRepliedToCount?: Maybe<Scalars['Int']>;
  totalConversationsCount?: Maybe<Scalars['Int']>;
  unreadCount?: Maybe<Scalars['Int']>;
};

export type Zrm_Attachment = {
  __typename?: 'ZRM_Attachment';
  attachmentAddedMs?: Maybe<Scalars['String']>;
  attachmentExpirationMs?: Maybe<Scalars['String']>;
  attachmentMetadataStatus?: Maybe<Scalars['String']>;
  downloadUrl?: Maybe<Scalars['String']>;
  downloadUrlExpirationMs?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileSizeBytes?: Maybe<Scalars['Int']>;
  fileType?: Maybe<Scalars['String']>;
  isAttachmentDeleted?: Maybe<Scalars['Boolean']>;
  isAttachmentExpired?: Maybe<Scalars['Boolean']>;
  previewUrl?: Maybe<Scalars['String']>;
  previewUrlExpirationMs?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
  zDocId?: Maybe<Scalars['String']>;
};

export type Zrm_AttachmentToBeDeletedArg = {
  messageId: Scalars['String'];
  zDocId: Scalars['String'];
};

export type Zrm_ConnectedExperience = {
  __typename?: 'ZRM_connectedExperience';
  isConnectedExperience?: Maybe<Scalars['Boolean']>;
};

export type Zrm_Conversation = {
  __typename?: 'ZRM_Conversation';
  acceptsReplies?: Maybe<Scalars['Boolean']>;
  activeParticipantsInConversation: Array<Zrm_ConversationParticipant>;
  address?: Maybe<Scalars['String']>;
  applicationAlreadySent?: Maybe<Scalars['Boolean']>;
  applicationCompleted?: Maybe<Scalars['Boolean']>;
  attributes?: Maybe<Zrm_ConversationAttributes>;
  conversation: Array<Zrm_Message>;
  conversationId: Scalars['String'];
  feedId: Scalars['String'];
  feedListingId: Scalars['String'];
  hasQuickResponses?: Maybe<Scalars['Boolean']>;
  hasUnreadMessage: Scalars['Boolean'];
  inquiry?: Maybe<Zrm_Inquiry>;
  inquiryId: Scalars['String'];
  isActive: Scalars['Boolean'];
  isApplicationsAccepted: Scalars['Boolean'];
  isApplicationsAllowed: Scalars['Boolean'];
  isConversationBlockedByZillow: Scalars['Boolean'];
  isMultifamily: Scalars['Boolean'];
  lastReadTimestampMs?: Maybe<Scalars['String']>;
  listingAlias: Scalars['String'];
  listingId: Scalars['String'];
  note: Zrm_Note;
  notRepliedTo: Scalars['Boolean'];
  pagination?: Maybe<Zrm_Pagination>;
  propertyTypeCode?: Maybe<Scalars['Int']>;
  quickResponses?: Maybe<Zrm_QuickResponses>;
  referenceEmail?: Maybe<Scalars['String']>;
  referenceName?: Maybe<Scalars['String']>;
  referenceRelayEmail?: Maybe<Scalars['String']>;
  rentalProtection?: Maybe<Zrm_RentalProtection>;
  renterProfile?: Maybe<Zrm_RenterProfile>;
  status: Zrm_ConversationStatus;
  statusLabel?: Maybe<Zrm_StatusLabel>;
  touring: Zrm_Touring;
};

export type Zrm_ConversationAttributes = {
  __typename?: 'ZRM_ConversationAttributes';
  applicationMarkedSent?: Maybe<Scalars['Boolean']>;
  attributeUpdateDateMs?: Maybe<Scalars['String']>;
  tourScheduledTimestampMs?: Maybe<Scalars['String']>;
};

export type Zrm_ConversationCountsResponse = {
  __typename?: 'ZRM_ConversationCountsResponse';
  conversationCount?: Maybe<Scalars['Int']>;
  lastMessageDateMs?: Maybe<Scalars['String']>;
  listingConversationCount?: Maybe<Scalars['Int']>;
  listingCounts: Array<Zrm_ListingCount>;
  unreadConversationCount?: Maybe<Scalars['Int']>;
  unreadMessageCount?: Maybe<Scalars['Int']>;
};

export type Zrm_ConversationParticipant = {
  __typename?: 'ZRM_ConversationParticipant';
  name: Scalars['String'];
  relayAddress?: Maybe<Scalars['String']>;
};

export type Zrm_ConversationResponse = {
  __typename?: 'ZRM_ConversationResponse';
  conversations: Array<Zrm_Conversation>;
  listingId?: Maybe<Scalars['String']>;
  pagination?: Maybe<Zrm_Pagination>;
};

export type Zrm_ConversationSearchResult = {
  __typename?: 'ZRM_ConversationSearchResult';
  conversationId?: Maybe<Scalars['String']>;
  folder?: Maybe<Scalars['String']>;
  listingAlias?: Maybe<Scalars['String']>;
  renterName?: Maybe<Scalars['String']>;
  renterPhoneNumber?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
};

export type Zrm_ConversationStatus = {
  __typename?: 'ZRM_ConversationStatus';
  isArchived: Scalars['Boolean'];
  isFavorite: Scalars['Boolean'];
  isInvitedToApply: Scalars['Boolean'];
  isScheduled: Scalars['Boolean'];
  isSpam: Scalars['Boolean'];
};

export type Zrm_Cta_Link = {
  __typename?: 'ZRM_CTA_Link';
  linkData?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type Zrm_CustomerSummary = {
  __typename?: 'ZRM_CustomerSummary';
  active?: Maybe<Scalars['Boolean']>;
  customerType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  primaryUserAccount?: Maybe<Scalars['String']>;
  userManagementCompanyId?: Maybe<Scalars['String']>;
  zrnNumber?: Maybe<Scalars['String']>;
};

export type Zrm_Experiment = {
  __typename?: 'ZRM_Experiment';
  experimentName: Scalars['String'];
  experimentPercent?: Maybe<Scalars['Int']>;
  jira: Scalars['String'];
  shouldTrack: Scalars['Boolean'];
  version: Scalars['String'];
};

export type Zrm_Features = {
  __typename?: 'ZRM_Features';
  canAccessAnalytics?: Maybe<Scalars['Boolean']>;
  canAccessBilling?: Maybe<Scalars['Boolean']>;
  canAccessBusinessVerificationLite?: Maybe<Scalars['Boolean']>;
  canAccessConnectedExperience?: Maybe<Scalars['Boolean']>;
  /** @deprecated Field no longer supported */
  canAccessContacts?: Maybe<Scalars['Boolean']>;
  canAccessDeactivationWorkflow?: Maybe<Scalars['Boolean']>;
  canAccessFeatureLaunchNotifications?: Maybe<Scalars['Boolean']>;
  canAccessFeedClaimAndConvert?: Maybe<Scalars['Boolean']>;
  canAccessInvoicePayments?: Maybe<Scalars['Boolean']>;
  canAccessListingCriteria?: Maybe<Scalars['Boolean']>;
  canAccessMainAccountSettings?: Maybe<Scalars['Boolean']>;
  canAccessMainAnalytics?: Maybe<Scalars['Boolean']>;
  canAccessMainBilling?: Maybe<Scalars['Boolean']>;
  canAccessMainContacts?: Maybe<Scalars['Boolean']>;
  canAccessMainContactSupport?: Maybe<Scalars['Boolean']>;
  canAccessMainHelp?: Maybe<Scalars['Boolean']>;
  canAccessMainMaintenanceTracker?: Maybe<Scalars['Boolean']>;
  canAccessMainMessages?: Maybe<Scalars['Boolean']>;
  canAccessMainMyProperties?: Maybe<Scalars['Boolean']>;
  canAccessMainNotificationCenter?: Maybe<Scalars['Boolean']>;
  canAccessMainPayments?: Maybe<Scalars['Boolean']>;
  canAccessMainResources?: Maybe<Scalars['Boolean']>;
  canAccessMainSecuritySettings?: Maybe<Scalars['Boolean']>;
  canAccessMaintenanceTracker?: Maybe<Scalars['Boolean']>;
  canAccessMessages?: Maybe<Scalars['Boolean']>;
  canAccessMobileHub?: Maybe<Scalars['Boolean']>;
  canAccessModularListing?: Maybe<Scalars['Boolean']>;
  canAccessMultiFamilyResources?: Maybe<Scalars['Boolean']>;
  canAccessNewPhotoUpload?: Maybe<Scalars['Boolean']>;
  canAccessPostActivationFeedListingEdits?: Maybe<Scalars['Boolean']>;
  canAccessPostActivationListingEdits?: Maybe<Scalars['Boolean']>;
  canAccessUserManagement?: Maybe<Scalars['Boolean']>;
  canAccessUserManagementApplicationPermission?: Maybe<Scalars['Boolean']>;
  canAddListing?: Maybe<Scalars['Boolean']>;
  canDeleteListing?: Maybe<Scalars['Boolean']>;
  canEditMultifamilyFeedListingContactInformation?: Maybe<Scalars['Boolean']>;
  canRespondToReview?: Maybe<Scalars['Boolean']>;
  canSwitchListingSource?: Maybe<Scalars['Boolean']>;
  canUpdateListing?: Maybe<Scalars['Boolean']>;
  canViewClaimFeedListing?: Maybe<Scalars['Boolean']>;
  canViewContactEmailDeliverability?: Maybe<Scalars['Boolean']>;
  canViewOnboardingFlow?: Maybe<Scalars['Boolean']>;
  canViewSingleFamilyFeedListingDetails?: Maybe<Scalars['Boolean']>;
};

export type Zrm_FunnelReportAnalytics = {
  __typename?: 'ZRM_FunnelReportAnalytics';
  averageStarLevel?: Maybe<Scalars['Int']>;
  city?: Maybe<Scalars['String']>;
  clickCount?: Maybe<Scalars['Int']>;
  daysOnMarketCount?: Maybe<Scalars['Int']>;
  emailLeadCount?: Maybe<Scalars['Int']>;
  feedId?: Maybe<Scalars['String']>;
  feedListingId?: Maybe<Scalars['String']>;
  impressionCount?: Maybe<Scalars['Int']>;
  isSingleFamily?: Maybe<Scalars['Boolean']>;
  leadCount?: Maybe<Scalars['Int']>;
  leaseCount?: Maybe<Scalars['Int']>;
  listingName?: Maybe<Scalars['String']>;
  percentageResponse?: Maybe<Scalars['Float']>;
  phoneLeadCount?: Maybe<Scalars['Int']>;
  productType?: Maybe<Array<Maybe<Scalars['String']>>>;
  publishedStatus?: Maybe<Scalars['String']>;
  reviewCount?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  viewCount?: Maybe<Scalars['Int']>;
  zip?: Maybe<Scalars['String']>;
};

export type Zrm_FunnelReportInsights = {
  __typename?: 'ZRM_FunnelReportInsights';
  market?: Maybe<Zrm_FunnelReportMarketInsights>;
  portfolio?: Maybe<Zrm_FunnelReportPortfolioInsights>;
  portfolioLeadsTotal?: Maybe<Scalars['Int']>;
  portfolioTotalListings?: Maybe<Scalars['Int']>;
};

export type Zrm_FunnelReportMarketInsights = {
  __typename?: 'ZRM_FunnelReportMarketInsights';
  daysOnMarketAverage?: Maybe<Scalars['Float']>;
  impressionsAverage?: Maybe<Scalars['Float']>;
  leadsAverage?: Maybe<Scalars['Float']>;
  leadsRate?: Maybe<Scalars['Float']>;
  reviewAverage?: Maybe<Scalars['Float']>;
  viewsAverage?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

export type Zrm_FunnelReportPortfolioInsights = {
  __typename?: 'ZRM_FunnelReportPortfolioInsights';
  daysOnMarketAverage?: Maybe<Scalars['Float']>;
  impressionsAverage?: Maybe<Scalars['Float']>;
  leadsAverage?: Maybe<Scalars['Float']>;
  leadsRate?: Maybe<Scalars['Float']>;
  reviewAverage?: Maybe<Scalars['Float']>;
  viewsAverage?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

export type Zrm_FunnelReportProductTypeInsights = {
  __typename?: 'ZRM_FunnelReportProductTypeInsights';
  FLAT_FEE?: Maybe<Zrm_FunnelReportInsights>;
  PAY_PER_LEAD?: Maybe<Zrm_FunnelReportInsights>;
  PREMIUM_PLUS_PACKAGE?: Maybe<Zrm_FunnelReportInsights>;
};

export type Zrm_GetAttachmentsByConversationIdResponse = {
  __typename?: 'ZRM_getAttachmentsByConversationIdResponse';
  attachments: Array<Zrm_Attachment>;
};

export type Zrm_GetConversationSearchResultResponse = {
  __typename?: 'ZRM_getConversationSearchResultResponse';
  hasMore: Scalars['Boolean'];
  searchResult: Array<Maybe<Zrm_ConversationSearchResult>>;
};

export type Zrm_GetExperimentTreatmentResponse = {
  __typename?: 'ZRM_getExperimentTreatmentResponse';
  featureName?: Maybe<Scalars['String']>;
  treatment?: Maybe<Scalars['String']>;
};

export type Zrm_GetLeadManagementCountsResponse = {
  __typename?: 'ZRM_getLeadManagementCountsResponse';
  totalLeadCount: Scalars['Int'];
};

export type Zrm_GetLeadManagementLeadsResponse = {
  __typename?: 'ZRM_getLeadManagementLeadsResponse';
  earliestDateSearchedMs?: Maybe<Scalars['String']>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  leads: Array<Zrm_LeadManagementLead>;
  listingDetails?: Maybe<Zrm_LeadManagementListingDetail>;
  pageLeadCount?: Maybe<Scalars['Int']>;
  screeningCriteriaDetails?: Maybe<Zrm_LeadManagementScreeningCriteriaDetail>;
  tooMuchDataRequested?: Maybe<Scalars['Boolean']>;
  totalLeadCount?: Maybe<Scalars['Int']>;
};

export type Zrm_GetLeadManagementSearchResultResponse = {
  __typename?: 'ZRM_getLeadManagementSearchResultResponse';
  hasMore: Scalars['Boolean'];
  responseEntries: Array<Maybe<Zrm_GetLeadManagementSearchResultResponseEntry>>;
};

export type Zrm_GetLeadManagementSearchResultResponseEntry = {
  __typename?: 'ZRM_getLeadManagementSearchResultResponseEntry';
  conversationId: Scalars['String'];
  screeningCriteria: Zrm_LeadManagementSearchScreeningCriteria;
  searchEntry: Zrm_LeadManagementSearchEntry;
};

export type Zrm_GetLeadManagementStatsResponse = {
  __typename?: 'ZRM_getLeadManagementStatsResponse';
  hasCriteriaSet: Scalars['Boolean'];
  leadsQualifiedForCriteriaTotal: Scalars['Int'];
  listingAddress: Scalars['String'];
  stats: Array<Maybe<Zrm_LeadManagementStats>>;
};

export type Zrm_GetListingPerformanceResponse = {
  __typename?: 'ZRM_getListingPerformanceResponse';
  analytics: Array<Maybe<ListingAnalytics>>;
  insights: Zrm_Insights;
};

export type Zrm_GetOrAddSavedRepliesResponse = {
  __typename?: 'ZRM_getOrAddSavedRepliesResponse';
  customReplies: Array<Maybe<SavedReply>>;
  defaultSavedReplies: Array<SavedReply>;
  success: Scalars['Boolean'];
};

export type Zrm_GetPropertiesListPagination = {
  __typename?: 'ZRM_GetPropertiesListPagination';
  endKey?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  startKey?: Maybe<Scalars['String']>;
};

export type Zrm_GetPropertiesListResponse = {
  __typename?: 'ZRM_GetPropertiesListResponse';
  listingCount: Zrm_PropertyListingCount;
  listings: Array<Zrm_PropertyListing>;
  pager: Zrm_GetPropertiesListPagination;
};

export type Zrm_GetPropertyAddressResponse = {
  __typename?: 'ZRM_GetPropertyAddressResponse';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type Zrm_GetPropertySearchResultResponse = {
  __typename?: 'ZRM_GetPropertySearchResultResponse';
  listings: Array<Zrm_PropertyListing>;
  pager: Zrm_GetPropertiesListPagination;
};

export type Zrm_GetPropertyWebAnalyticsResponse = {
  __typename?: 'ZRM_GetPropertyWebAnalyticsResponse';
  eventProductType?: Maybe<Scalars['String']>;
  isApplicationsAccepted?: Maybe<Scalars['Boolean']>;
  listingAlias?: Maybe<Scalars['String']>;
  rentGuarantee?: Maybe<Zrm_RentGuarantee>;
};

export type Zrm_Inquiry = {
  __typename?: 'ZRM_Inquiry';
  attributes?: Maybe<Zrm_RenterResume>;
  contactEmail?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  feed?: Maybe<Scalars['String']>;
  feedListingId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  inquirerType?: Maybe<Scalars['String']>;
  isAttributesHidden?: Maybe<Scalars['Boolean']>;
  isPhoneLead?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['String']>;
};

export type Zrm_Insights = {
  __typename?: 'ZRM_Insights';
  market: MarketInsights;
  portfolio: PortfolioInsights;
  portfolioClickCount: Scalars['Int'];
  portfolioDaysOnMarketCount: Scalars['Int'];
  portfolioImpressionCount: Scalars['Int'];
  portfolioLeadsTotal: Scalars['Int'];
  portfolioTotalListings: Scalars['Int'];
  portfolioViewCount: Scalars['Int'];
};

export type Zrm_InviteResponse = {
  __typename?: 'ZRM_InviteResponse';
  response: Scalars['String'];
  success: Scalars['Boolean'];
};

export type Zrm_LeadManagementApplicationInfo = {
  __typename?: 'ZRM_LeadManagementApplicationInfo';
  isApplicationCompleted: Scalars['Boolean'];
  isApplicationsAccepted: Scalars['Boolean'];
  isApplicationSent: Scalars['Boolean'];
  numCoApplicants: Scalars['Int'];
};

export type Zrm_LeadManagementConversationAttributes = {
  __typename?: 'ZRM_LeadManagementConversationAttributes';
  applicationMarkedSent: Scalars['Boolean'];
  note?: Maybe<Scalars['String']>;
  tourScheduledTimestampMs?: Maybe<Scalars['String']>;
};

export type Zrm_LeadManagementConversationStatus = {
  __typename?: 'ZRM_LeadManagementConversationStatus';
  applicationMarkedSent: Scalars['Boolean'];
  isArchived: Scalars['Boolean'];
  isConversationBlockedByZillow: Scalars['Boolean'];
  isFavorite: Scalars['Boolean'];
  isScheduled: Scalars['Boolean'];
  isSpam: Scalars['Boolean'];
};

export type Zrm_LeadManagementCriterion = {
  __typename?: 'ZRM_LeadManagementCriterion';
  hasMatchingCriterion: Scalars['Boolean'];
  isCriterionSet: Scalars['Boolean'];
  isNegotiable: Scalars['Boolean'];
  renterDataToolTipText?: Maybe<Scalars['String']>;
  rentersCriterionSubmittedDisplay?: Maybe<Scalars['String']>;
  screeningCriteriaType: Scalars['String'];
  screeningCriterionDisplay?: Maybe<Scalars['String']>;
  screeningCriterionNameDisplay: Scalars['String'];
};

export type Zrm_LeadManagementLatestContact = {
  __typename?: 'ZRM_LeadManagementLatestContact';
  aiAutoResponseType?: Maybe<SatelliteAiAutoResponseType>;
  hasAttachments: Scalars['Boolean'];
  isMessageOwner: Scalars['Boolean'];
  isNew: Scalars['Boolean'];
  isPhoneLead: Scalars['Boolean'];
  isRead: Scalars['Boolean'];
  messageDateMs: Scalars['String'];
  messageText?: Maybe<Scalars['String']>;
  messageType: Scalars['String'];
  notRepliedTo: Scalars['Boolean'];
  senderName?: Maybe<Scalars['String']>;
};

export type Zrm_LeadManagementLead = {
  __typename?: 'ZRM_LeadManagementLead';
  applicationInfo: Zrm_LeadManagementApplicationInfo;
  attributes?: Maybe<Zrm_LeadManagementConversationAttributes>;
  conversationId: Scalars['String'];
  latestContact: Zrm_LeadManagementLatestContact;
  nextStep: Zrm_LeadManagementNextStep;
  renterInfo: Zrm_LeadManagementRenterInfo;
  renterProfile?: Maybe<Zrm_RenterProfile>;
  renterProgressBar: Zrm_LeadManagementRenterProgressBar;
  screeningCriteria: Zrm_LeadManagementScreeningCriteria;
  status: Zrm_LeadManagementConversationStatus;
  statusLabel?: Maybe<Zrm_StatusLabel>;
  touring: Zrm_Touring;
};

export type Zrm_LeadManagementListingDetail = {
  __typename?: 'ZRM_LeadManagementListingDetail';
  listingAddress: Scalars['String'];
  listingAlias: Scalars['String'];
};

export type Zrm_LeadManagementNextStep = {
  __typename?: 'ZRM_LeadManagementNextStep';
  link: Zrm_LeadManagementNextStepLink;
  nextStepType: Scalars['String'];
};

export type Zrm_LeadManagementNextStepLink = {
  __typename?: 'ZRM_LeadManagementNextStepLink';
  linkData?: Maybe<Scalars['String']>;
  linkId: Scalars['String'];
  text: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type Zrm_LeadManagementProgressBarStatus = {
  __typename?: 'ZRM_LeadManagementProgressBarStatus';
  hasStatusLabel: Scalars['Boolean'];
  statusType: Scalars['String'];
};

export type Zrm_LeadManagementRenterInfo = {
  __typename?: 'ZRM_LeadManagementRenterInfo';
  firstContactDateMs: Scalars['String'];
  renterName?: Maybe<Scalars['String']>;
  renterPhoneNumber?: Maybe<Scalars['String']>;
  renterRelayEmailAddress?: Maybe<Scalars['String']>;
};

export type Zrm_LeadManagementRenterProgressBar = {
  __typename?: 'ZRM_LeadManagementRenterProgressBar';
  application: Zrm_LeadManagementProgressBarStatus;
  inquiry: Zrm_LeadManagementProgressBarStatus;
  lease: Zrm_LeadManagementProgressBarStatus;
  tour: Zrm_LeadManagementProgressBarStatus;
};

export type Zrm_LeadManagementScreeningCriteria = {
  __typename?: 'ZRM_LeadManagementScreeningCriteria';
  criteria: Array<Zrm_LeadManagementCriterion>;
  criteriaMatchedDisplay: Scalars['String'];
  hasScreeningCriteria: Scalars['Boolean'];
  hasSubmittedProfile: Scalars['Boolean'];
  numCriteriaSelectedByLandlord?: Maybe<Scalars['Int']>;
  numRequiredCriteriaSelectedByLandlord: Scalars['Int'];
  numRequiredOrNegotiableCriteriaSelectedByLandlordThatMatch?: Maybe<Scalars['Int']>;
  shouldShowRequestRenterProfileCta: Scalars['Boolean'];
};

export type Zrm_LeadManagementScreeningCriteriaDetail = {
  __typename?: 'ZRM_LeadManagementScreeningCriteriaDetail';
  hasCriteriaSet: Scalars['Boolean'];
  isScreeningCriteriaIncomplete: Scalars['Boolean'];
};

export type Zrm_LeadManagementSearchEntry = {
  __typename?: 'ZRM_LeadManagementSearchEntry';
  conversationId?: Maybe<Scalars['String']>;
  folder?: Maybe<Scalars['String']>;
  listingAlias?: Maybe<Scalars['String']>;
  renterName?: Maybe<Scalars['String']>;
  renterPhoneNumber?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
};

export type Zrm_LeadManagementSearchScreeningCriteria = {
  __typename?: 'ZRM_LeadManagementSearchScreeningCriteria';
  criteriaMatchedDisplay?: Maybe<Scalars['String']>;
  numCriteriaSelectedByLandlord?: Maybe<Scalars['Int']>;
  numCriteriaSelectedByLandlordThatPossiblyMatch?: Maybe<Scalars['Int']>;
  numRequiredCriteriaSelectedByLandlord?: Maybe<Scalars['Int']>;
  numRequiredCriteriaSelectedByLandlordThatMatch?: Maybe<Scalars['Int']>;
  numRequiredOrNegotiableCriteriaSelectedByLandlordThatMatch?: Maybe<Scalars['Int']>;
  numSelectableCriteria?: Maybe<Scalars['Int']>;
};

export type Zrm_LeadManagementStats = {
  __typename?: 'ZRM_LeadManagementStats';
  criterionMatchedCount: Scalars['Int'];
  isCriterionSet: Scalars['Boolean'];
  isNegotiable: Scalars['Boolean'];
  percentageMatched: Scalars['String'];
  screeningCriteriaType: Scalars['String'];
  screeningCriterionDisplay?: Maybe<Scalars['String']>;
  screeningCriterionNameDisplay: Scalars['String'];
};

export type Zrm_Listing = {
  __typename?: 'ZRM_Listing';
  city?: Maybe<Scalars['String']>;
  listingAlias?: Maybe<Scalars['String']>;
  listingId?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type Zrm_ListingCount = {
  __typename?: 'ZRM_ListingCount';
  address: Scalars['String'];
  conversationCount?: Maybe<Scalars['Int']>;
  feedId: Scalars['String'];
  feedListingId: Scalars['String'];
  unreadConversationCount?: Maybe<Scalars['Int']>;
  unreadMessageCount?: Maybe<Scalars['Int']>;
};

export type Zrm_ListingStats = {
  __typename?: 'ZRM_ListingStats';
  aliasEncoded?: Maybe<Scalars['String']>;
  listingAlias?: Maybe<Scalars['String']>;
  listingId?: Maybe<Scalars['String']>;
  notRepliedToCount?: Maybe<Scalars['Int']>;
  totalConversationsCount?: Maybe<Scalars['Int']>;
  unreadCount?: Maybe<Scalars['Int']>;
};

export type Zrm_Message = {
  __typename?: 'ZRM_Message';
  aiAutoResponseType?: Maybe<SatelliteAiAutoResponseType>;
  attachments: Array<Zrm_Attachment>;
  conversationId?: Maybe<Scalars['String']>;
  ctaLink?: Maybe<Scalars['String']>;
  ctaText?: Maybe<Scalars['String']>;
  isMessageOwner?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  messageDate?: Maybe<Scalars['String']>;
  messageDateMs: Scalars['String'];
  messageId?: Maybe<Scalars['String']>;
  messageLink?: Maybe<Zrm_Cta_Link>;
  messagePreview?: Maybe<Scalars['String']>;
  messageType: Scalars['String'];
  senderEmail?: Maybe<Scalars['String']>;
  senderName?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  uiTreatmentType?: Maybe<Scalars['String']>;
};

export type Zrm_Note = {
  __typename?: 'ZRM_Note';
  conversationId?: Maybe<Scalars['String']>;
  lastUpdatedMs?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
};

export type Zrm_Pagination = {
  __typename?: 'ZRM_Pagination';
  hasNextPage?: Maybe<Scalars['Boolean']>;
  pageConversationCount?: Maybe<Scalars['Int']>;
  pageStartIndex?: Maybe<Scalars['Int']>;
  queryFullConversationCount?: Maybe<Scalars['Int']>;
  queryFullMessageCount?: Maybe<Scalars['Int']>;
};

export type Zrm_PartialMessages = {
  __typename?: 'ZRM_PartialMessages';
  className?: Maybe<Scalars['String']>;
  isBold?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type Zrm_Profiles = {
  __typename?: 'ZRM_Profiles';
  isLandlord?: Maybe<Scalars['Boolean']>;
  isPropertyManager?: Maybe<Scalars['Boolean']>;
};

export type Zrm_PropertyListing = {
  __typename?: 'ZRM_PropertyListing';
  address?: Maybe<Zrm_PropertyListingAddress>;
  isMultifamily?: Maybe<Scalars['Boolean']>;
  listingAlias?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Zrm_PropertyListingAddress = {
  __typename?: 'ZRM_PropertyListingAddress';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type Zrm_PropertyListingCount = {
  __typename?: 'ZRM_PropertyListingCount';
  active?: Maybe<Scalars['Int']>;
  archived?: Maybe<Scalars['Int']>;
  atRisk?: Maybe<Scalars['Int']>;
  inactive?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type Zrm_QuickResponses = {
  __typename?: 'ZRM_QuickResponses';
  prediction?: Maybe<Scalars['String']>;
  suggestions?: Maybe<Array<Maybe<Zrm_QuickResponses_Suggestions>>>;
};

export type Zrm_QuickResponses_Suggestions = {
  __typename?: 'ZRM_QuickResponses_Suggestions';
  id?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type Zrm_RentalProtection = {
  __typename?: 'ZRM_RentalProtection';
  isEligible?: Maybe<Scalars['Boolean']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  relativePath?: Maybe<Scalars['String']>;
};

export type Zrm_RenterProfile = {
  __typename?: 'ZRM_RenterProfile';
  attributes?: Maybe<Zrm_RenterProfile_Attributes>;
  isRenterProfileHidden?: Maybe<Scalars['Boolean']>;
  leadIntentValue?: Maybe<Scalars['String']>;
  renterProfileCompleteness?: Maybe<Scalars['String']>;
  shouldShowRequestRenterProfileCta?: Maybe<Scalars['Boolean']>;
};

export type Zrm_RenterProfile_Attributes = {
  __typename?: 'ZRM_RenterProfile_Attributes';
  credit?: Maybe<Scalars['String']>;
  desiredParking?: Maybe<Scalars['String']>;
  incomeYearly?: Maybe<Scalars['String']>;
  incomeYearlyRange?: Maybe<Scalars['String']>;
  introduction?: Maybe<Scalars['String']>;
  isSmoker?: Maybe<Scalars['String']>;
  isSmokerBoolean?: Maybe<Scalars['Boolean']>;
  jobTitle?: Maybe<Scalars['String']>;
  leaseLengthMonths?: Maybe<Scalars['String']>;
  moveInDate?: Maybe<Scalars['String']>;
  numBedrooms?: Maybe<Scalars['String']>;
  numOccupants?: Maybe<Scalars['String']>;
  petDetails?: Maybe<Array<Maybe<Zrm_RenterProfile_PetDetails>>>;
  reasonForMoving?: Maybe<Scalars['String']>;
  updatedAtMs?: Maybe<Scalars['String']>;
  voucherAmountMonthly?: Maybe<Scalars['String']>;
};

export type Zrm_RenterProfile_PetDetails = {
  __typename?: 'ZRM_RenterProfile_PetDetails';
  breed?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  weightPounds?: Maybe<Scalars['String']>;
};

export type Zrm_RenterResume = {
  __typename?: 'ZRM_RenterResume';
  credit?: Maybe<Scalars['String']>;
  desiredParking?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  income?: Maybe<Scalars['String']>;
  introduction?: Maybe<Scalars['String']>;
  isSmoker?: Maybe<Scalars['Boolean']>;
  jobTitle?: Maybe<Scalars['String']>;
  leaseLengthMonths?: Maybe<Scalars['String']>;
  moveInTimeframe?: Maybe<Scalars['String']>;
  numOccupants?: Maybe<Scalars['String']>;
  pets?: Maybe<Array<Maybe<Scalars['String']>>>;
  reasonForMoving?: Maybe<Scalars['String']>;
  updatedAtMs?: Maybe<Scalars['String']>;
};

export type Zrm_RentGuarantee = {
  __typename?: 'ZRM_RentGuarantee';
  isEligible?: Maybe<Scalars['Boolean']>;
};

export type Zrm_Restrictions = {
  __typename?: 'ZRM_Restrictions';
  ctaText?: Maybe<Scalars['String']>;
  ctaUrl?: Maybe<Scalars['String']>;
  isAllowed?: Maybe<Scalars['Boolean']>;
  messageCode?: Maybe<Scalars['String']>;
  partialMessages?: Maybe<Array<Maybe<Zrm_PartialMessages>>>;
  title?: Maybe<Scalars['String']>;
};

export type Zrm_SatelliteWebCheckInfo = {
  __typename?: 'ZRM_satelliteWebCheckInfo';
  buildNumber?: Maybe<Scalars['Int']>;
  host?: Maybe<Scalars['String']>;
  nodeEnv?: Maybe<Scalars['String']>;
  zgApi?: Maybe<Scalars['String']>;
};

export type Zrm_StatusLabel = {
  __typename?: 'ZRM_StatusLabel';
  linkData?: Maybe<Scalars['String']>;
  linkId: Scalars['String'];
  text: Scalars['String'];
};

export type Zrm_SuccessStatusResponse = {
  __typename?: 'ZRM_SuccessStatusResponse';
  success: Scalars['Boolean'];
};

export type Zrm_Summary = {
  __typename?: 'ZRM_Summary';
  activeListingCount?: Maybe<Scalars['Int']>;
  totalListingCount?: Maybe<Scalars['Int']>;
};

export type Zrm_Touring = {
  __typename?: 'ZRM_Touring';
  hasZrmToursEnabled: Scalars['Boolean'];
};

export type AddMessage_AddMessageToConversationV2MutationVariables = Exact<{
  conversationId: Scalars['String'];
  listingAlias?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  zDocIds: Array<Scalars['String']> | Scalars['String'];
  quickResponseSuggestionId?: Maybe<Scalars['String']>;
}>;

export type AddMessage_AddMessageToConversationV2Mutation = {
  __typename?: 'Mutation';
  ZRM_addMessageToConversationV2: {
    __typename?: 'ZRM_Message';
    aiAutoResponseType?: Maybe<SatelliteAiAutoResponseType>;
    conversationId?: Maybe<string>;
    isMessageOwner?: Maybe<boolean>;
    message?: Maybe<string>;
    messagePreview?: Maybe<string>;
    messageDateMs: string;
    messageId?: Maybe<string>;
    messageType: string;
    senderName?: Maybe<string>;
    uiTreatmentType?: Maybe<string>;
    title?: Maybe<string>;
    attachments: Array<{
      __typename?: 'ZRM_Attachment';
      attachmentMetadataStatus?: Maybe<string>;
      downloadUrl?: Maybe<string>;
      fileName?: Maybe<string>;
      fileSizeBytes?: Maybe<number>;
      fileType?: Maybe<string>;
      isAttachmentDeleted?: Maybe<boolean>;
      isAttachmentExpired?: Maybe<boolean>;
      previewUrl?: Maybe<string>;
      zDocId?: Maybe<string>;
    }>;
    messageLink?: Maybe<{ __typename?: 'ZRM_CTA_Link'; url?: Maybe<string>; text: string }>;
  };
};

export type AddMessage_GetCurrentConversationDataQueryVariables = Exact<{
  conversationId: Scalars['String'];
  listingAlias: Scalars['String'];
  clientTimeZone: Scalars['String'];
}>;

export type AddMessage_GetCurrentConversationDataQuery = {
  __typename?: 'Query';
  ZRM_getConversationById: {
    __typename?: 'ZRM_Conversation';
    conversationId: string;
    isConversationBlockedByZillow: boolean;
    hasQuickResponses?: Maybe<boolean>;
    inquiry?: Maybe<{ __typename?: 'ZRM_Inquiry'; id: string; isPhoneLead?: Maybe<boolean> }>;
    status: { __typename?: 'ZRM_ConversationStatus'; isArchived: boolean; isSpam: boolean; isFavorite: boolean };
    statusLabel?: Maybe<{ __typename?: 'ZRM_StatusLabel'; text: string; linkId: string }>;
    quickResponses?: Maybe<{
      __typename?: 'ZRM_QuickResponses';
      prediction?: Maybe<string>;
      suggestions?: Maybe<
        Array<Maybe<{ __typename?: 'ZRM_QuickResponses_Suggestions'; id?: Maybe<string>; text?: Maybe<string> }>>
      >;
    }>;
  };
};

export type ConversationList_GetConversationsQueryVariables = Exact<{
  conversationId?: Maybe<Scalars['String']>;
  paginationStartIndex?: Maybe<Scalars['String']>;
  listingAlias?: Maybe<Scalars['String']>;
  daysBack?: Maybe<Scalars['Int']>;
  clientTimeZone?: Maybe<Scalars['String']>;
  folder?: Maybe<Folder>;
  readRepliedStatus?: Maybe<ReadRepliedStatus>;
  renterProgressStatus?: Maybe<RenterProgressStatus>;
}>;

export type ConversationList_GetConversationsQuery = {
  __typename?: 'Query';
  ZRM_getLatestConversationsV2: {
    __typename?: 'ZRM_ConversationResponse';
    conversations: Array<{
      __typename?: 'ZRM_Conversation';
      address?: Maybe<string>;
      conversationId: string;
      hasUnreadMessage: boolean;
      lastReadTimestampMs?: Maybe<string>;
      listingAlias: string;
      referenceEmail?: Maybe<string>;
      referenceName?: Maybe<string>;
      isApplicationsAllowed: boolean;
      isConversationBlockedByZillow: boolean;
      applicationCompleted?: Maybe<boolean>;
      isActive: boolean;
      isApplicationsAccepted: boolean;
      notRepliedTo: boolean;
      propertyTypeCode?: Maybe<number>;
      applicationAlreadySent?: Maybe<boolean>;
      activeParticipantsInConversation: Array<{ __typename?: 'ZRM_ConversationParticipant'; name: string }>;
      conversation: Array<{
        __typename?: 'ZRM_Message';
        aiAutoResponseType?: Maybe<SatelliteAiAutoResponseType>;
        conversationId?: Maybe<string>;
        isMessageOwner?: Maybe<boolean>;
        messagePreview?: Maybe<string>;
        messageDateMs: string;
        messageId?: Maybe<string>;
        messageType: string;
        senderName?: Maybe<string>;
        uiTreatmentType?: Maybe<string>;
      }>;
      inquiry?: Maybe<{
        __typename?: 'ZRM_Inquiry';
        id: string;
        isPhoneLead?: Maybe<boolean>;
        name?: Maybe<string>;
        phone?: Maybe<string>;
        state?: Maybe<string>;
      }>;
      status: { __typename?: 'ZRM_ConversationStatus'; isArchived: boolean; isSpam: boolean; isFavorite: boolean };
      statusLabel?: Maybe<{ __typename?: 'ZRM_StatusLabel'; text: string; linkId: string }>;
      note: { __typename?: 'ZRM_Note'; conversationId?: Maybe<string>; note?: Maybe<string> };
      attributes?: Maybe<{
        __typename?: 'ZRM_ConversationAttributes';
        applicationMarkedSent?: Maybe<boolean>;
        tourScheduledTimestampMs?: Maybe<string>;
      }>;
      touring: { __typename?: 'ZRM_Touring'; hasZrmToursEnabled: boolean };
    }>;
    pagination?: Maybe<{
      __typename?: 'ZRM_Pagination';
      queryFullMessageCount?: Maybe<number>;
      pageStartIndex?: Maybe<number>;
      hasNextPage?: Maybe<boolean>;
      pageConversationCount?: Maybe<number>;
    }>;
  };
};

export type ConversationListDataFragment = {
  __typename?: 'ZRM_ConversationResponse';
  conversations: Array<{
    __typename?: 'ZRM_Conversation';
    address?: Maybe<string>;
    conversationId: string;
    hasUnreadMessage: boolean;
    lastReadTimestampMs?: Maybe<string>;
    listingAlias: string;
    referenceEmail?: Maybe<string>;
    referenceName?: Maybe<string>;
    isApplicationsAllowed: boolean;
    isConversationBlockedByZillow: boolean;
    applicationCompleted?: Maybe<boolean>;
    isActive: boolean;
    isApplicationsAccepted: boolean;
    notRepliedTo: boolean;
    propertyTypeCode?: Maybe<number>;
    applicationAlreadySent?: Maybe<boolean>;
    activeParticipantsInConversation: Array<{ __typename?: 'ZRM_ConversationParticipant'; name: string }>;
    conversation: Array<{
      __typename?: 'ZRM_Message';
      aiAutoResponseType?: Maybe<SatelliteAiAutoResponseType>;
      conversationId?: Maybe<string>;
      isMessageOwner?: Maybe<boolean>;
      messagePreview?: Maybe<string>;
      messageDateMs: string;
      messageId?: Maybe<string>;
      messageType: string;
      senderName?: Maybe<string>;
      uiTreatmentType?: Maybe<string>;
    }>;
    inquiry?: Maybe<{
      __typename?: 'ZRM_Inquiry';
      id: string;
      isPhoneLead?: Maybe<boolean>;
      name?: Maybe<string>;
      phone?: Maybe<string>;
      state?: Maybe<string>;
    }>;
    status: { __typename?: 'ZRM_ConversationStatus'; isArchived: boolean; isSpam: boolean; isFavorite: boolean };
    statusLabel?: Maybe<{ __typename?: 'ZRM_StatusLabel'; text: string; linkId: string }>;
    note: { __typename?: 'ZRM_Note'; conversationId?: Maybe<string>; note?: Maybe<string> };
    attributes?: Maybe<{
      __typename?: 'ZRM_ConversationAttributes';
      applicationMarkedSent?: Maybe<boolean>;
      tourScheduledTimestampMs?: Maybe<string>;
    }>;
    touring: { __typename?: 'ZRM_Touring'; hasZrmToursEnabled: boolean };
  }>;
  pagination?: Maybe<{
    __typename?: 'ZRM_Pagination';
    queryFullMessageCount?: Maybe<number>;
    pageStartIndex?: Maybe<number>;
    hasNextPage?: Maybe<boolean>;
    pageConversationCount?: Maybe<number>;
  }>;
};

export type NavigationDataFragment = {
  __typename?: 'ZRM_Conversation';
  conversationId: string;
  isConversationBlockedByZillow: boolean;
  referenceName?: Maybe<string>;
  activeParticipantsInConversation: Array<{ __typename?: 'ZRM_ConversationParticipant'; name: string }>;
  inquiry?: Maybe<{
    __typename?: 'ZRM_Inquiry';
    isPhoneLead?: Maybe<boolean>;
    name?: Maybe<string>;
    phone?: Maybe<string>;
    id: string;
  }>;
  status: { __typename?: 'ZRM_ConversationStatus'; isArchived: boolean; isSpam: boolean; isFavorite: boolean };
};

export type StatusFragment = {
  __typename?: 'ZRM_Conversation';
  status: { __typename?: 'ZRM_ConversationStatus'; isArchived: boolean; isSpam: boolean; isFavorite: boolean };
};

export type ConversationNav_GetConversationQueryVariables = Exact<{
  conversationId: Scalars['String'];
  listingAlias: Scalars['String'];
}>;

export type ConversationNav_GetConversationQuery = {
  __typename?: 'Query';
  ZRM_getConversationById: {
    __typename?: 'ZRM_Conversation';
    conversationId: string;
    isConversationBlockedByZillow: boolean;
    referenceName?: Maybe<string>;
    activeParticipantsInConversation: Array<{ __typename?: 'ZRM_ConversationParticipant'; name: string }>;
    inquiry?: Maybe<{
      __typename?: 'ZRM_Inquiry';
      isPhoneLead?: Maybe<boolean>;
      name?: Maybe<string>;
      phone?: Maybe<string>;
      id: string;
    }>;
    status: { __typename?: 'ZRM_ConversationStatus'; isArchived: boolean; isSpam: boolean; isFavorite: boolean };
  };
};

export type ConversationSearchBar_GetConversationSearchResultQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  listingAlias?: Maybe<Scalars['String']>;
  searchText: Scalars['String'];
  startTimestampMs: Scalars['String'];
  endTimestampMs: Scalars['String'];
}>;

export type ConversationSearchBar_GetConversationSearchResultQuery = {
  __typename?: 'Query';
  ZRM_getConversationSearchResult: {
    __typename?: 'ZRM_getConversationSearchResultResponse';
    hasMore: boolean;
    searchResult: Array<
      Maybe<{
        __typename?: 'ZRM_ConversationSearchResult';
        conversationId?: Maybe<string>;
        folder?: Maybe<string>;
        listingAlias?: Maybe<string>;
        renterName?: Maybe<string>;
        renterPhoneNumber?: Maybe<string>;
        streetAddress?: Maybe<string>;
      }>
    >;
  };
};

export type RenterProfile_GetAttachmentsByConversationIdQueryVariables = Exact<{
  conversationId: Scalars['String'];
}>;

export type RenterProfile_GetAttachmentsByConversationIdQuery = {
  __typename?: 'Query';
  ZRM_getAttachmentsByConversationId: {
    __typename?: 'ZRM_getAttachmentsByConversationIdResponse';
    attachments: Array<{
      __typename?: 'ZRM_Attachment';
      attachmentAddedMs?: Maybe<string>;
      attachmentMetadataStatus?: Maybe<string>;
      downloadUrl?: Maybe<string>;
      fileName?: Maybe<string>;
      fileSizeBytes?: Maybe<number>;
      fileType?: Maybe<string>;
      isAttachmentDeleted?: Maybe<boolean>;
      isAttachmentExpired?: Maybe<boolean>;
      previewUrl?: Maybe<string>;
      zDocId?: Maybe<string>;
    }>;
  };
};

export type ContactActionsDataFragment = {
  __typename?: 'ZRM_Conversation';
  referenceEmail?: Maybe<string>;
  inquiry?: Maybe<{ __typename?: 'ZRM_Inquiry'; id: string; name?: Maybe<string>; phone?: Maybe<string> }>;
};

export type RenterProfileContactActionsDataQueryVariables = Exact<{
  conversationId: Scalars['String'];
  listingAlias: Scalars['String'];
}>;

export type RenterProfileContactActionsDataQuery = {
  __typename?: 'Query';
  ZRM_getConversationById: {
    __typename?: 'ZRM_Conversation';
    referenceEmail?: Maybe<string>;
    inquiry?: Maybe<{ __typename?: 'ZRM_Inquiry'; id: string; name?: Maybe<string>; phone?: Maybe<string> }>;
  };
};

export type ExpiredRenterProfileDataQueryVariables = Exact<{
  conversationId: Scalars['String'];
  listingAlias: Scalars['String'];
}>;

export type ExpiredRenterProfileDataQuery = {
  __typename?: 'Query';
  ZRM_getConversationById: {
    __typename?: 'ZRM_Conversation';
    renterProfile?: Maybe<{ __typename?: 'ZRM_RenterProfile'; isRenterProfileHidden?: Maybe<boolean> }>;
  };
};

export type RenterProfileHeaderDataFragment = {
  __typename?: 'ZRM_Conversation';
  address?: Maybe<string>;
  isActive: boolean;
  referenceName?: Maybe<string>;
  inquiry?: Maybe<{
    __typename?: 'ZRM_Inquiry';
    name?: Maybe<string>;
    phone?: Maybe<string>;
    isPhoneLead?: Maybe<boolean>;
    id: string;
  }>;
};

export type RenterProfileHeaderDataQueryVariables = Exact<{
  conversationId: Scalars['String'];
  listingAlias: Scalars['String'];
}>;

export type RenterProfileHeaderDataQuery = {
  __typename?: 'Query';
  ZRM_getConversationById: {
    __typename?: 'ZRM_Conversation';
    address?: Maybe<string>;
    isActive: boolean;
    referenceName?: Maybe<string>;
    inquiry?: Maybe<{
      __typename?: 'ZRM_Inquiry';
      name?: Maybe<string>;
      phone?: Maybe<string>;
      isPhoneLead?: Maybe<boolean>;
      id: string;
    }>;
  };
};

export type RenterProfileHeader_GetConnectedExperienceQueryVariables = Exact<{
  listingAlias: Scalars['String'];
}>;

export type RenterProfileHeader_GetConnectedExperienceQuery = {
  __typename?: 'Query';
  ZRM_getConnectedExperience: { __typename?: 'ZRM_connectedExperience'; isConnectedExperience?: Maybe<boolean> };
};

export type NextStepDataQueryVariables = Exact<{
  conversationId: Scalars['String'];
  listingAlias: Scalars['String'];
}>;

export type NextStepDataQuery = {
  __typename?: 'Query';
  ZRM_getConversationById: {
    __typename?: 'ZRM_Conversation';
    conversationId: string;
    isApplicationsAllowed: boolean;
    isApplicationsAccepted: boolean;
    referenceEmail?: Maybe<string>;
    inquiry?: Maybe<{
      __typename?: 'ZRM_Inquiry';
      name?: Maybe<string>;
      isPhoneLead?: Maybe<boolean>;
      phone?: Maybe<string>;
      id: string;
    }>;
  };
};

export type NotesSectionDataFragment = {
  __typename?: 'ZRM_Conversation';
  applicationAlreadySent?: Maybe<boolean>;
  conversationId: string;
  referenceName?: Maybe<string>;
  note: { __typename?: 'ZRM_Note'; conversationId?: Maybe<string>; note?: Maybe<string> };
  attributes?: Maybe<{
    __typename?: 'ZRM_ConversationAttributes';
    applicationMarkedSent?: Maybe<boolean>;
    tourScheduledTimestampMs?: Maybe<string>;
  }>;
  touring: { __typename?: 'ZRM_Touring'; hasZrmToursEnabled: boolean };
};

export type RenterProfileNotesDataQueryVariables = Exact<{
  conversationId: Scalars['String'];
  listingAlias: Scalars['String'];
}>;

export type RenterProfileNotesDataQuery = {
  __typename?: 'Query';
  ZRM_getConversationById: {
    __typename?: 'ZRM_Conversation';
    applicationAlreadySent?: Maybe<boolean>;
    conversationId: string;
    referenceName?: Maybe<string>;
    note: { __typename?: 'ZRM_Note'; conversationId?: Maybe<string>; note?: Maybe<string> };
    attributes?: Maybe<{
      __typename?: 'ZRM_ConversationAttributes';
      applicationMarkedSent?: Maybe<boolean>;
      tourScheduledTimestampMs?: Maybe<string>;
    }>;
    touring: { __typename?: 'ZRM_Touring'; hasZrmToursEnabled: boolean };
  };
};

export type RenterProfileAttributesFragment = {
  __typename?: 'ZRM_Conversation';
  conversationId: string;
  renterProfile?: Maybe<{
    __typename?: 'ZRM_RenterProfile';
    isRenterProfileHidden?: Maybe<boolean>;
    shouldShowRequestRenterProfileCta?: Maybe<boolean>;
    attributes?: Maybe<{
      __typename?: 'ZRM_RenterProfile_Attributes';
      credit?: Maybe<string>;
      desiredParking?: Maybe<string>;
      incomeYearly?: Maybe<string>;
      incomeYearlyRange?: Maybe<string>;
      voucherAmountMonthly?: Maybe<string>;
      introduction?: Maybe<string>;
      isSmoker?: Maybe<string>;
      isSmokerBoolean?: Maybe<boolean>;
      jobTitle?: Maybe<string>;
      leaseLengthMonths?: Maybe<string>;
      moveInDate?: Maybe<string>;
      numBedrooms?: Maybe<string>;
      numOccupants?: Maybe<string>;
      reasonForMoving?: Maybe<string>;
      updatedAtMs?: Maybe<string>;
      petDetails?: Maybe<
        Array<
          Maybe<{
            __typename?: 'ZRM_RenterProfile_PetDetails';
            breed?: Maybe<string>;
            description?: Maybe<string>;
            size?: Maybe<string>;
            type?: Maybe<string>;
            weightPounds?: Maybe<string>;
          }>
        >
      >;
    }>;
  }>;
};

export type RenterProfileAttributesDataQueryVariables = Exact<{
  conversationId: Scalars['String'];
  listingAlias: Scalars['String'];
}>;

export type RenterProfileAttributesDataQuery = {
  __typename?: 'Query';
  ZRM_getConversationById: {
    __typename?: 'ZRM_Conversation';
    conversationId: string;
    renterProfile?: Maybe<{
      __typename?: 'ZRM_RenterProfile';
      isRenterProfileHidden?: Maybe<boolean>;
      shouldShowRequestRenterProfileCta?: Maybe<boolean>;
      attributes?: Maybe<{
        __typename?: 'ZRM_RenterProfile_Attributes';
        credit?: Maybe<string>;
        desiredParking?: Maybe<string>;
        incomeYearly?: Maybe<string>;
        incomeYearlyRange?: Maybe<string>;
        voucherAmountMonthly?: Maybe<string>;
        introduction?: Maybe<string>;
        isSmoker?: Maybe<string>;
        isSmokerBoolean?: Maybe<boolean>;
        jobTitle?: Maybe<string>;
        leaseLengthMonths?: Maybe<string>;
        moveInDate?: Maybe<string>;
        numBedrooms?: Maybe<string>;
        numOccupants?: Maybe<string>;
        reasonForMoving?: Maybe<string>;
        updatedAtMs?: Maybe<string>;
        petDetails?: Maybe<
          Array<
            Maybe<{
              __typename?: 'ZRM_RenterProfile_PetDetails';
              breed?: Maybe<string>;
              description?: Maybe<string>;
              size?: Maybe<string>;
              type?: Maybe<string>;
              weightPounds?: Maybe<string>;
            }>
          >
        >;
      }>;
    }>;
  };
};

export type RenterProfileDataFragment = {
  __typename?: 'ZRM_Conversation';
  address?: Maybe<string>;
  applicationCompleted?: Maybe<boolean>;
  conversationId: string;
  isActive: boolean;
  listingAlias: string;
  isApplicationsAllowed: boolean;
  isApplicationsAccepted: boolean;
  notRepliedTo: boolean;
  propertyTypeCode?: Maybe<number>;
  referenceName?: Maybe<string>;
  referenceEmail?: Maybe<string>;
  applicationAlreadySent?: Maybe<boolean>;
  status: { __typename?: 'ZRM_ConversationStatus'; isArchived: boolean; isSpam: boolean };
  inquiry?: Maybe<{
    __typename?: 'ZRM_Inquiry';
    id: string;
    isPhoneLead?: Maybe<boolean>;
    name?: Maybe<string>;
    state?: Maybe<string>;
    phone?: Maybe<string>;
  }>;
  note: { __typename?: 'ZRM_Note'; conversationId?: Maybe<string>; note?: Maybe<string> };
  attributes?: Maybe<{
    __typename?: 'ZRM_ConversationAttributes';
    applicationMarkedSent?: Maybe<boolean>;
    tourScheduledTimestampMs?: Maybe<string>;
  }>;
  touring: { __typename?: 'ZRM_Touring'; hasZrmToursEnabled: boolean };
};

export type LeadManagementSearchBar_GetSearchResultQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  listingAlias: Scalars['String'];
  searchText: Scalars['String'];
  startTimestampMs: Scalars['String'];
  endTimestampMs: Scalars['String'];
}>;

export type LeadManagementSearchBar_GetSearchResultQuery = {
  __typename?: 'Query';
  ZRM_getLeadManagementSearchResult: {
    __typename?: 'ZRM_getLeadManagementSearchResultResponse';
    hasMore: boolean;
    responseEntries: Array<
      Maybe<{
        __typename?: 'ZRM_getLeadManagementSearchResultResponseEntry';
        conversationId: string;
        searchEntry: {
          __typename?: 'ZRM_LeadManagementSearchEntry';
          conversationId?: Maybe<string>;
          folder?: Maybe<string>;
          listingAlias?: Maybe<string>;
          renterName?: Maybe<string>;
          renterPhoneNumber?: Maybe<string>;
          streetAddress?: Maybe<string>;
        };
        screeningCriteria: {
          __typename?: 'ZRM_LeadManagementSearchScreeningCriteria';
          numCriteriaSelectedByLandlord?: Maybe<number>;
          criteriaMatchedDisplay?: Maybe<string>;
          numRequiredOrNegotiableCriteriaSelectedByLandlordThatMatch?: Maybe<number>;
        };
      }>
    >;
  };
};

export type LeadManagementTable_GetLeadsQueryVariables = Exact<{
  clientTimeZone: Scalars['String'];
  listingAlias?: Maybe<Scalars['String']>;
  conversationId?: Maybe<Scalars['String']>;
  folder: Folder;
  minCriteriaMatches?: Maybe<Scalars['Int']>;
  readRepliedStatus: ReadRepliedStatus;
  renterProgressStatus: RenterProgressStatus;
  start?: Maybe<Scalars['Int']>;
}>;

export type LeadManagementTable_GetLeadsQuery = {
  __typename?: 'Query';
  ZRM_getLeadManagementLeads: {
    __typename?: 'ZRM_getLeadManagementLeadsResponse';
    totalLeadCount?: Maybe<number>;
    hasNextPage?: Maybe<boolean>;
    leads: Array<{
      __typename?: 'ZRM_LeadManagementLead';
      conversationId: string;
      renterInfo: {
        __typename?: 'ZRM_LeadManagementRenterInfo';
        renterName?: Maybe<string>;
        renterPhoneNumber?: Maybe<string>;
        renterRelayEmailAddress?: Maybe<string>;
        firstContactDateMs: string;
      };
      screeningCriteria: {
        __typename?: 'ZRM_LeadManagementScreeningCriteria';
        numCriteriaSelectedByLandlord?: Maybe<number>;
        criteriaMatchedDisplay: string;
        hasSubmittedProfile: boolean;
        hasScreeningCriteria: boolean;
        shouldShowRequestRenterProfileCta: boolean;
        numRequiredOrNegotiableCriteriaSelectedByLandlordThatMatch?: Maybe<number>;
        criteria: Array<{
          __typename?: 'ZRM_LeadManagementCriterion';
          screeningCriteriaType: string;
          hasMatchingCriterion: boolean;
          rentersCriterionSubmittedDisplay?: Maybe<string>;
          renterDataToolTipText?: Maybe<string>;
          isCriterionSet: boolean;
          screeningCriterionDisplay?: Maybe<string>;
          isNegotiable: boolean;
        }>;
      };
      statusLabel?: Maybe<{ __typename?: 'ZRM_StatusLabel'; text: string; linkId: string; linkData?: Maybe<string> }>;
      latestContact: {
        __typename?: 'ZRM_LeadManagementLatestContact';
        aiAutoResponseType?: Maybe<SatelliteAiAutoResponseType>;
        hasAttachments: boolean;
        isMessageOwner: boolean;
        isPhoneLead: boolean;
        isNew: boolean;
        isRead: boolean;
        messageDateMs: string;
        messageText?: Maybe<string>;
        messageType: string;
        senderName?: Maybe<string>;
      };
      nextStep: {
        __typename?: 'ZRM_LeadManagementNextStep';
        nextStepType: string;
        link: { __typename?: 'ZRM_LeadManagementNextStepLink'; linkId: string; text: string; url?: Maybe<string> };
      };
      status: {
        __typename?: 'ZRM_LeadManagementConversationStatus';
        isArchived: boolean;
        isSpam: boolean;
        isScheduled: boolean;
        applicationMarkedSent: boolean;
        isFavorite: boolean;
        isConversationBlockedByZillow: boolean;
      };
      applicationInfo: {
        __typename?: 'ZRM_LeadManagementApplicationInfo';
        isApplicationsAccepted: boolean;
        isApplicationCompleted: boolean;
      };
      renterProfile?: Maybe<{
        __typename?: 'ZRM_RenterProfile';
        isRenterProfileHidden?: Maybe<boolean>;
        leadIntentValue?: Maybe<string>;
        renterProfileCompleteness?: Maybe<string>;
        shouldShowRequestRenterProfileCta?: Maybe<boolean>;
        attributes?: Maybe<{
          __typename?: 'ZRM_RenterProfile_Attributes';
          credit?: Maybe<string>;
          desiredParking?: Maybe<string>;
          incomeYearly?: Maybe<string>;
          incomeYearlyRange?: Maybe<string>;
          voucherAmountMonthly?: Maybe<string>;
          introduction?: Maybe<string>;
          isSmoker?: Maybe<string>;
          jobTitle?: Maybe<string>;
          leaseLengthMonths?: Maybe<string>;
          moveInDate?: Maybe<string>;
          numBedrooms?: Maybe<string>;
          numOccupants?: Maybe<string>;
          reasonForMoving?: Maybe<string>;
          updatedAtMs?: Maybe<string>;
          petDetails?: Maybe<
            Array<
              Maybe<{
                __typename?: 'ZRM_RenterProfile_PetDetails';
                breed?: Maybe<string>;
                description?: Maybe<string>;
                size?: Maybe<string>;
                type?: Maybe<string>;
                weightPounds?: Maybe<string>;
              }>
            >
          >;
        }>;
      }>;
      renterProgressBar: {
        __typename?: 'ZRM_LeadManagementRenterProgressBar';
        inquiry: { __typename?: 'ZRM_LeadManagementProgressBarStatus'; statusType: string; hasStatusLabel: boolean };
        tour: { __typename?: 'ZRM_LeadManagementProgressBarStatus'; statusType: string; hasStatusLabel: boolean };
        application: {
          __typename?: 'ZRM_LeadManagementProgressBarStatus';
          statusType: string;
          hasStatusLabel: boolean;
        };
        lease: { __typename?: 'ZRM_LeadManagementProgressBarStatus'; statusType: string; hasStatusLabel: boolean };
      };
      touring: { __typename?: 'ZRM_Touring'; hasZrmToursEnabled: boolean };
    }>;
    listingDetails?: Maybe<{
      __typename?: 'ZRM_LeadManagementListingDetail';
      listingAlias: string;
      listingAddress: string;
    }>;
    screeningCriteriaDetails?: Maybe<{
      __typename?: 'ZRM_LeadManagementScreeningCriteriaDetail';
      isScreeningCriteriaIncomplete: boolean;
    }>;
  };
};

export type LeadSummaryCounts_GetListingPerformanceQueryVariables = Exact<{
  startDayYyyyMmDd: Scalars['String'];
  endDayYyyyMmDd: Scalars['String'];
  listingAlias?: Maybe<Scalars['String']>;
}>;

export type LeadSummaryCounts_GetListingPerformanceQuery = {
  __typename?: 'Query';
  ZRM_getListingPerformance: {
    __typename?: 'ZRM_getListingPerformanceResponse';
    analytics: Array<Maybe<{ __typename?: 'ListingAnalytics'; clickCount: number; leadCount: number }>>;
    insights: { __typename?: 'ZRM_Insights'; portfolioClickCount: number; portfolioLeadsTotal: number };
  };
};

export type LeadsTable_GetConversationsQueryVariables = Exact<{
  clientTimeZone?: Maybe<Scalars['String']>;
  endDateYyyyMmDd?: Maybe<Scalars['String']>;
  folder?: Maybe<Folder>;
  limit?: Maybe<Scalars['Int']>;
  listingAlias?: Maybe<Scalars['String']>;
  readRepliedStatus?: Maybe<ReadRepliedStatus>;
  renterProgressStatus?: Maybe<RenterProgressStatus>;
  startDateYyyyMmDd?: Maybe<Scalars['String']>;
  startIndex?: Maybe<Scalars['Int']>;
}>;

export type LeadsTable_GetConversationsQuery = {
  __typename?: 'Query';
  ZRM_getLatestConversationsV2: {
    __typename?: 'ZRM_ConversationResponse';
    conversations: Array<{
      __typename?: 'ZRM_Conversation';
      address?: Maybe<string>;
      applicationAlreadySent?: Maybe<boolean>;
      conversationId: string;
      listingAlias: string;
      referenceName?: Maybe<string>;
      applicationCompleted?: Maybe<boolean>;
      isApplicationsAccepted: boolean;
      isApplicationsAllowed: boolean;
      isConversationBlockedByZillow: boolean;
      referenceEmail?: Maybe<string>;
      attributes?: Maybe<{
        __typename?: 'ZRM_ConversationAttributes';
        applicationMarkedSent?: Maybe<boolean>;
        tourScheduledTimestampMs?: Maybe<string>;
      }>;
      conversation: Array<{
        __typename?: 'ZRM_Message';
        conversationId?: Maybe<string>;
        messagePreview?: Maybe<string>;
        messageId?: Maybe<string>;
        messageDateMs: string;
        senderName?: Maybe<string>;
      }>;
      inquiry?: Maybe<{
        __typename?: 'ZRM_Inquiry';
        email?: Maybe<string>;
        id: string;
        isPhoneLead?: Maybe<boolean>;
        name?: Maybe<string>;
        phone?: Maybe<string>;
      }>;
      note: {
        __typename?: 'ZRM_Note';
        conversationId?: Maybe<string>;
        note?: Maybe<string>;
        lastUpdatedMs?: Maybe<string>;
      };
      renterProfile?: Maybe<{
        __typename?: 'ZRM_RenterProfile';
        leadIntentValue?: Maybe<string>;
        renterProfileCompleteness?: Maybe<string>;
        isRenterProfileHidden?: Maybe<boolean>;
        shouldShowRequestRenterProfileCta?: Maybe<boolean>;
        attributes?: Maybe<{
          __typename?: 'ZRM_RenterProfile_Attributes';
          credit?: Maybe<string>;
          desiredParking?: Maybe<string>;
          incomeYearly?: Maybe<string>;
          incomeYearlyRange?: Maybe<string>;
          voucherAmountMonthly?: Maybe<string>;
          introduction?: Maybe<string>;
          isSmoker?: Maybe<string>;
          isSmokerBoolean?: Maybe<boolean>;
          jobTitle?: Maybe<string>;
          leaseLengthMonths?: Maybe<string>;
          moveInDate?: Maybe<string>;
          numBedrooms?: Maybe<string>;
          numOccupants?: Maybe<string>;
          reasonForMoving?: Maybe<string>;
          updatedAtMs?: Maybe<string>;
          petDetails?: Maybe<
            Array<
              Maybe<{
                __typename?: 'ZRM_RenterProfile_PetDetails';
                breed?: Maybe<string>;
                description?: Maybe<string>;
                size?: Maybe<string>;
                type?: Maybe<string>;
                weightPounds?: Maybe<string>;
              }>
            >
          >;
        }>;
      }>;
      status: { __typename?: 'ZRM_ConversationStatus'; isArchived: boolean; isSpam: boolean; isFavorite: boolean };
    }>;
    pagination?: Maybe<{
      __typename?: 'ZRM_Pagination';
      pageStartIndex?: Maybe<number>;
      hasNextPage?: Maybe<boolean>;
      pageConversationCount?: Maybe<number>;
    }>;
  };
};

export type ApplicationRequest_GetDataQueryVariables = Exact<{
  conversationId: Scalars['String'];
  listingAlias: Scalars['String'];
}>;

export type ApplicationRequest_GetDataQuery = {
  __typename?: 'Query';
  ZRM_getConversationById: {
    __typename?: 'ZRM_Conversation';
    conversationId: string;
    referenceEmail?: Maybe<string>;
    referenceName?: Maybe<string>;
    applicationAlreadySent?: Maybe<boolean>;
    isApplicationsAccepted: boolean;
    inquiry?: Maybe<{ __typename?: 'ZRM_Inquiry'; id: string; phone?: Maybe<string> }>;
  };
};

export type MessagesPaginationFragment = {
  __typename?: 'ZRM_Conversation';
  pagination?: Maybe<{
    __typename?: 'ZRM_Pagination';
    pageConversationCount?: Maybe<number>;
    pageStartIndex?: Maybe<number>;
    queryFullMessageCount?: Maybe<number>;
  }>;
};

export type MessageItemDataFragment = {
  __typename?: 'ZRM_Message';
  aiAutoResponseType?: Maybe<SatelliteAiAutoResponseType>;
  conversationId?: Maybe<string>;
  isMessageOwner?: Maybe<boolean>;
  message?: Maybe<string>;
  messagePreview?: Maybe<string>;
  messageDateMs: string;
  messageId?: Maybe<string>;
  messageType: string;
  senderName?: Maybe<string>;
  uiTreatmentType?: Maybe<string>;
  title?: Maybe<string>;
  attachments: Array<{
    __typename?: 'ZRM_Attachment';
    attachmentMetadataStatus?: Maybe<string>;
    downloadUrl?: Maybe<string>;
    fileName?: Maybe<string>;
    fileSizeBytes?: Maybe<number>;
    fileType?: Maybe<string>;
    isAttachmentDeleted?: Maybe<boolean>;
    isAttachmentExpired?: Maybe<boolean>;
    previewUrl?: Maybe<string>;
    zDocId?: Maybe<string>;
  }>;
  messageLink?: Maybe<{ __typename?: 'ZRM_CTA_Link'; url?: Maybe<string>; text: string }>;
};

export type MessageItemAttachmentDataFragment = {
  __typename?: 'ZRM_Attachment';
  attachmentMetadataStatus?: Maybe<string>;
  downloadUrl?: Maybe<string>;
  fileName?: Maybe<string>;
  fileSizeBytes?: Maybe<number>;
  fileType?: Maybe<string>;
  isAttachmentDeleted?: Maybe<boolean>;
  isAttachmentExpired?: Maybe<boolean>;
  previewUrl?: Maybe<string>;
  zDocId?: Maybe<string>;
};

export type QuickResponseFragment = {
  __typename?: 'ZRM_Conversation';
  quickResponses?: Maybe<{
    __typename?: 'ZRM_QuickResponses';
    prediction?: Maybe<string>;
    suggestions?: Maybe<
      Array<Maybe<{ __typename?: 'ZRM_QuickResponses_Suggestions'; id?: Maybe<string>; text?: Maybe<string> }>>
    >;
  }>;
};

export type MessageList_FetchPaginatedMessagesQueryVariables = Exact<{
  conversationId: Scalars['String'];
  listingAlias: Scalars['String'];
  paginationStartIndex?: Maybe<Scalars['String']>;
  clientTimeZone: Scalars['String'];
}>;

export type MessageList_FetchPaginatedMessagesQuery = {
  __typename?: 'Query';
  ZRM_getConversationById: {
    __typename?: 'ZRM_Conversation';
    conversationId: string;
    conversation: Array<{
      __typename?: 'ZRM_Message';
      aiAutoResponseType?: Maybe<SatelliteAiAutoResponseType>;
      conversationId?: Maybe<string>;
      isMessageOwner?: Maybe<boolean>;
      message?: Maybe<string>;
      messagePreview?: Maybe<string>;
      messageDateMs: string;
      messageId?: Maybe<string>;
      messageType: string;
      senderName?: Maybe<string>;
      uiTreatmentType?: Maybe<string>;
      title?: Maybe<string>;
      attachments: Array<{
        __typename?: 'ZRM_Attachment';
        attachmentMetadataStatus?: Maybe<string>;
        downloadUrl?: Maybe<string>;
        fileName?: Maybe<string>;
        fileSizeBytes?: Maybe<number>;
        fileType?: Maybe<string>;
        isAttachmentDeleted?: Maybe<boolean>;
        isAttachmentExpired?: Maybe<boolean>;
        previewUrl?: Maybe<string>;
        zDocId?: Maybe<string>;
      }>;
      messageLink?: Maybe<{ __typename?: 'ZRM_CTA_Link'; url?: Maybe<string>; text: string }>;
    }>;
    pagination?: Maybe<{
      __typename?: 'ZRM_Pagination';
      pageConversationCount?: Maybe<number>;
      pageStartIndex?: Maybe<number>;
      queryFullMessageCount?: Maybe<number>;
    }>;
  };
};

export type MessageList_GetConversationQueryVariables = Exact<{
  conversationId: Scalars['String'];
  listingAlias?: Maybe<Scalars['String']>;
  paginationStartIndex?: Maybe<Scalars['String']>;
  clientTimeZone: Scalars['String'];
}>;

export type MessageList_GetConversationQuery = {
  __typename?: 'Query';
  ZRM_getConversationById: {
    __typename?: 'ZRM_Conversation';
    applicationAlreadySent?: Maybe<boolean>;
    conversationId: string;
    propertyTypeCode?: Maybe<number>;
    hasUnreadMessage: boolean;
    referenceEmail?: Maybe<string>;
    hasQuickResponses?: Maybe<boolean>;
    address?: Maybe<string>;
    applicationCompleted?: Maybe<boolean>;
    isActive: boolean;
    listingAlias: string;
    isApplicationsAllowed: boolean;
    isApplicationsAccepted: boolean;
    notRepliedTo: boolean;
    referenceName?: Maybe<string>;
    isConversationBlockedByZillow: boolean;
    activeParticipantsInConversation: Array<{ __typename?: 'ZRM_ConversationParticipant'; name: string }>;
    conversation: Array<{
      __typename?: 'ZRM_Message';
      aiAutoResponseType?: Maybe<SatelliteAiAutoResponseType>;
      conversationId?: Maybe<string>;
      isMessageOwner?: Maybe<boolean>;
      message?: Maybe<string>;
      messagePreview?: Maybe<string>;
      messageDateMs: string;
      messageId?: Maybe<string>;
      messageType: string;
      senderName?: Maybe<string>;
      uiTreatmentType?: Maybe<string>;
      title?: Maybe<string>;
      attachments: Array<{
        __typename?: 'ZRM_Attachment';
        attachmentMetadataStatus?: Maybe<string>;
        downloadUrl?: Maybe<string>;
        fileName?: Maybe<string>;
        fileSizeBytes?: Maybe<number>;
        fileType?: Maybe<string>;
        isAttachmentDeleted?: Maybe<boolean>;
        isAttachmentExpired?: Maybe<boolean>;
        previewUrl?: Maybe<string>;
        zDocId?: Maybe<string>;
      }>;
      messageLink?: Maybe<{ __typename?: 'ZRM_CTA_Link'; url?: Maybe<string>; text: string }>;
    }>;
    pagination?: Maybe<{
      __typename?: 'ZRM_Pagination';
      pageConversationCount?: Maybe<number>;
      pageStartIndex?: Maybe<number>;
      queryFullMessageCount?: Maybe<number>;
    }>;
    renterProfile?: Maybe<{
      __typename?: 'ZRM_RenterProfile';
      isRenterProfileHidden?: Maybe<boolean>;
      shouldShowRequestRenterProfileCta?: Maybe<boolean>;
      attributes?: Maybe<{
        __typename?: 'ZRM_RenterProfile_Attributes';
        credit?: Maybe<string>;
        desiredParking?: Maybe<string>;
        incomeYearly?: Maybe<string>;
        incomeYearlyRange?: Maybe<string>;
        voucherAmountMonthly?: Maybe<string>;
        introduction?: Maybe<string>;
        isSmoker?: Maybe<string>;
        isSmokerBoolean?: Maybe<boolean>;
        jobTitle?: Maybe<string>;
        leaseLengthMonths?: Maybe<string>;
        moveInDate?: Maybe<string>;
        numBedrooms?: Maybe<string>;
        numOccupants?: Maybe<string>;
        reasonForMoving?: Maybe<string>;
        updatedAtMs?: Maybe<string>;
        petDetails?: Maybe<
          Array<
            Maybe<{
              __typename?: 'ZRM_RenterProfile_PetDetails';
              breed?: Maybe<string>;
              description?: Maybe<string>;
              size?: Maybe<string>;
              type?: Maybe<string>;
              weightPounds?: Maybe<string>;
            }>
          >
        >;
      }>;
    }>;
    status: { __typename?: 'ZRM_ConversationStatus'; isArchived: boolean; isSpam: boolean; isFavorite: boolean };
    inquiry?: Maybe<{
      __typename?: 'ZRM_Inquiry';
      id: string;
      isPhoneLead?: Maybe<boolean>;
      name?: Maybe<string>;
      state?: Maybe<string>;
      phone?: Maybe<string>;
    }>;
    quickResponses?: Maybe<{
      __typename?: 'ZRM_QuickResponses';
      prediction?: Maybe<string>;
      suggestions?: Maybe<
        Array<Maybe<{ __typename?: 'ZRM_QuickResponses_Suggestions'; id?: Maybe<string>; text?: Maybe<string> }>>
      >;
    }>;
    note: { __typename?: 'ZRM_Note'; conversationId?: Maybe<string>; note?: Maybe<string> };
    attributes?: Maybe<{
      __typename?: 'ZRM_ConversationAttributes';
      applicationMarkedSent?: Maybe<boolean>;
      tourScheduledTimestampMs?: Maybe<string>;
    }>;
    touring: { __typename?: 'ZRM_Touring'; hasZrmToursEnabled: boolean };
  };
};

export type MessageListActions_GetConversationDataQueryVariables = Exact<{
  conversationId: Scalars['String'];
  listingAlias: Scalars['String'];
  clientTimeZone: Scalars['String'];
}>;

export type MessageListActions_GetConversationDataQuery = {
  __typename?: 'Query';
  ZRM_getConversationById: {
    __typename?: 'ZRM_Conversation';
    conversationId: string;
    isConversationBlockedByZillow: boolean;
    referenceName?: Maybe<string>;
    inquiry?: Maybe<{ __typename?: 'ZRM_Inquiry'; id: string; isPhoneLead?: Maybe<boolean>; name?: Maybe<string> }>;
    renterProfile?: Maybe<{ __typename?: 'ZRM_RenterProfile'; shouldShowRequestRenterProfileCta?: Maybe<boolean> }>;
    status: { __typename?: 'ZRM_ConversationStatus'; isArchived: boolean; isSpam: boolean; isFavorite: boolean };
  };
};

export type ApplicationsUpsellModal_EnableApplicationsMutationVariables = Exact<{
  listingAlias: Scalars['String'];
}>;

export type ApplicationsUpsellModal_EnableApplicationsMutation = {
  __typename?: 'Mutation';
  ZRM_applicationsAccepted?: Maybe<{ __typename?: 'ZRM_SuccessStatusResponse'; success: boolean }>;
};

export type RenterProfileModal_GetRenterProfileDataQueryVariables = Exact<{
  conversationId: Scalars['String'];
  listingAlias: Scalars['String'];
}>;

export type RenterProfileModal_GetRenterProfileDataQuery = {
  __typename?: 'Query';
  ZRM_getConversationById: {
    __typename?: 'ZRM_Conversation';
    conversationId: string;
    inquiry?: Maybe<{ __typename?: 'ZRM_Inquiry'; name?: Maybe<string> }>;
    renterProfile?: Maybe<{
      __typename?: 'ZRM_RenterProfile';
      isRenterProfileHidden?: Maybe<boolean>;
      shouldShowRequestRenterProfileCta?: Maybe<boolean>;
      attributes?: Maybe<{
        __typename?: 'ZRM_RenterProfile_Attributes';
        credit?: Maybe<string>;
        desiredParking?: Maybe<string>;
        incomeYearly?: Maybe<string>;
        incomeYearlyRange?: Maybe<string>;
        voucherAmountMonthly?: Maybe<string>;
        introduction?: Maybe<string>;
        isSmoker?: Maybe<string>;
        isSmokerBoolean?: Maybe<boolean>;
        jobTitle?: Maybe<string>;
        leaseLengthMonths?: Maybe<string>;
        moveInDate?: Maybe<string>;
        numBedrooms?: Maybe<string>;
        numOccupants?: Maybe<string>;
        reasonForMoving?: Maybe<string>;
        updatedAtMs?: Maybe<string>;
        petDetails?: Maybe<
          Array<
            Maybe<{
              __typename?: 'ZRM_RenterProfile_PetDetails';
              breed?: Maybe<string>;
              description?: Maybe<string>;
              size?: Maybe<string>;
              type?: Maybe<string>;
              weightPounds?: Maybe<string>;
            }>
          >
        >;
      }>;
    }>;
  };
};

export type SendApplicationConfirmationModal_GetModalDataQueryVariables = Exact<{
  conversationId: Scalars['String'];
  listingAlias: Scalars['String'];
}>;

export type SendApplicationConfirmationModal_GetModalDataQuery = {
  __typename?: 'Query';
  ZRM_getConversationById: {
    __typename?: 'ZRM_Conversation';
    conversationId: string;
    inquiry?: Maybe<{ __typename?: 'ZRM_Inquiry'; id: string; name?: Maybe<string> }>;
  };
};

export type SendMessageModal_AddMessageToConversationV2MutationVariables = Exact<{
  conversationId: Scalars['String'];
  listingAlias: Scalars['String'];
  message: Scalars['String'];
  zDocIds: Array<Scalars['String']> | Scalars['String'];
}>;

export type SendMessageModal_AddMessageToConversationV2Mutation = {
  __typename?: 'Mutation';
  ZRM_addMessageToConversationV2: {
    __typename?: 'ZRM_Message';
    aiAutoResponseType?: Maybe<SatelliteAiAutoResponseType>;
    conversationId?: Maybe<string>;
    isMessageOwner?: Maybe<boolean>;
    message?: Maybe<string>;
    messagePreview?: Maybe<string>;
    messageDateMs: string;
    messageId?: Maybe<string>;
    messageType: string;
    senderName?: Maybe<string>;
    uiTreatmentType?: Maybe<string>;
    title?: Maybe<string>;
    attachments: Array<{
      __typename?: 'ZRM_Attachment';
      attachmentMetadataStatus?: Maybe<string>;
      downloadUrl?: Maybe<string>;
      fileName?: Maybe<string>;
      fileSizeBytes?: Maybe<number>;
      fileType?: Maybe<string>;
      isAttachmentDeleted?: Maybe<boolean>;
      isAttachmentExpired?: Maybe<boolean>;
      previewUrl?: Maybe<string>;
      zDocId?: Maybe<string>;
    }>;
    messageLink?: Maybe<{ __typename?: 'ZRM_CTA_Link'; url?: Maybe<string>; text: string }>;
  };
};

export type SendMessageModal_GetConversationDataQueryVariables = Exact<{
  clientTimeZone: Scalars['String'];
  conversationId: Scalars['String'];
  listingAlias: Scalars['String'];
}>;

export type SendMessageModal_GetConversationDataQuery = {
  __typename?: 'Query';
  ZRM_getConversationById: {
    __typename?: 'ZRM_Conversation';
    conversationId: string;
    referenceName?: Maybe<string>;
    conversation: Array<{
      __typename?: 'ZRM_Message';
      conversationId?: Maybe<string>;
      messagePreview?: Maybe<string>;
      messageId?: Maybe<string>;
      messageDateMs: string;
      senderName?: Maybe<string>;
    }>;
    inquiry?: Maybe<{ __typename?: 'ZRM_Inquiry'; id: string; name?: Maybe<string> }>;
    status: { __typename?: 'ZRM_ConversationStatus'; isArchived: boolean; isSpam: boolean; isFavorite: boolean };
  };
};

export type SendMessageModal_GetAttachmentsByConversationIdQueryVariables = Exact<{
  conversationId: Scalars['String'];
}>;

export type SendMessageModal_GetAttachmentsByConversationIdQuery = {
  __typename?: 'Query';
  ZRM_getAttachmentsByConversationId: {
    __typename?: 'ZRM_getAttachmentsByConversationIdResponse';
    attachments: Array<{ __typename?: 'ZRM_Attachment'; zDocId?: Maybe<string> }>;
  };
};

export type TourCancellationModalRenterDetailsQueryVariables = Exact<{
  conversationId: Scalars['String'];
  listingAlias: Scalars['String'];
}>;

export type TourCancellationModalRenterDetailsQuery = {
  __typename?: 'Query';
  ZRM_getConversationById: { __typename?: 'ZRM_Conversation'; conversationId: string; referenceName?: Maybe<string> };
};

export type NotesModal_GetNotesDataQueryVariables = Exact<{
  conversationId: Scalars['String'];
  listingAlias: Scalars['String'];
}>;

export type NotesModal_GetNotesDataQuery = {
  __typename?: 'Query';
  ZRM_getConversationById: {
    __typename?: 'ZRM_Conversation';
    applicationAlreadySent?: Maybe<boolean>;
    conversationId: string;
    referenceName?: Maybe<string>;
    inquiry?: Maybe<{
      __typename?: 'ZRM_Inquiry';
      isPhoneLead?: Maybe<boolean>;
      name?: Maybe<string>;
      phone?: Maybe<string>;
    }>;
    note: { __typename?: 'ZRM_Note'; conversationId?: Maybe<string>; note?: Maybe<string> };
    attributes?: Maybe<{
      __typename?: 'ZRM_ConversationAttributes';
      applicationMarkedSent?: Maybe<boolean>;
      tourScheduledTimestampMs?: Maybe<string>;
    }>;
    touring: { __typename?: 'ZRM_Touring'; hasZrmToursEnabled: boolean };
  };
};

export type NotesModal_GetNewStatusLabelsQueryVariables = Exact<{
  conversationId: Scalars['String'];
  listingAlias: Scalars['String'];
  clientTimeZone: Scalars['String'];
}>;

export type NotesModal_GetNewStatusLabelsQuery = {
  __typename?: 'Query';
  ZRM_getLatestConversationsV2: {
    __typename?: 'ZRM_ConversationResponse';
    conversations: Array<{
      __typename?: 'ZRM_Conversation';
      conversationId: string;
      statusLabel?: Maybe<{ __typename?: 'ZRM_StatusLabel'; text: string; linkId: string }>;
    }>;
  };
};

export type StatusLabelFragment = {
  __typename?: 'ZRM_Conversation';
  statusLabel?: Maybe<{ __typename?: 'ZRM_StatusLabel'; text: string; linkId: string }>;
};

export type NotesBar_GetInboxPageDataQueryVariables = Exact<{
  conversationId: Scalars['String'];
  listingAlias: Scalars['String'];
  clientTimeZone: Scalars['String'];
}>;

export type NotesBar_GetInboxPageDataQuery = {
  __typename?: 'Query';
  ZRM_getConversationById: {
    __typename?: 'ZRM_Conversation';
    applicationAlreadySent?: Maybe<boolean>;
    conversationId: string;
    referenceName?: Maybe<string>;
    statusLabel?: Maybe<{ __typename?: 'ZRM_StatusLabel'; text: string; linkId: string }>;
    note: { __typename?: 'ZRM_Note'; conversationId?: Maybe<string>; note?: Maybe<string> };
    attributes?: Maybe<{
      __typename?: 'ZRM_ConversationAttributes';
      applicationMarkedSent?: Maybe<boolean>;
      tourScheduledTimestampMs?: Maybe<string>;
    }>;
    touring: { __typename?: 'ZRM_Touring'; hasZrmToursEnabled: boolean };
  };
};

export type RentalJourneyFilters_GetConversationToLoadQueryVariables = Exact<{
  folder?: Maybe<Folder>;
  daysBack?: Maybe<Scalars['Int']>;
  listingAlias?: Maybe<Scalars['String']>;
  renterProgressStatus?: Maybe<RenterProgressStatus>;
}>;

export type RentalJourneyFilters_GetConversationToLoadQuery = {
  __typename?: 'Query';
  ZRM_getLatestConversationsV2: {
    __typename?: 'ZRM_ConversationResponse';
    conversations: Array<{ __typename?: 'ZRM_Conversation'; conversationId: string; listingAlias: string }>;
  };
};

export type RenterProfileInlineDataQueryVariables = Exact<{
  conversationId: Scalars['String'];
  listingAlias: Scalars['String'];
}>;

export type RenterProfileInlineDataQuery = {
  __typename?: 'Query';
  ZRM_getConversationById: {
    __typename?: 'ZRM_Conversation';
    conversationId: string;
    conversation: Array<{ __typename?: 'ZRM_Message'; conversationId?: Maybe<string>; senderName?: Maybe<string> }>;
    renterProfile?: Maybe<{
      __typename?: 'ZRM_RenterProfile';
      isRenterProfileHidden?: Maybe<boolean>;
      shouldShowRequestRenterProfileCta?: Maybe<boolean>;
      attributes?: Maybe<{
        __typename?: 'ZRM_RenterProfile_Attributes';
        credit?: Maybe<string>;
        desiredParking?: Maybe<string>;
        incomeYearly?: Maybe<string>;
        incomeYearlyRange?: Maybe<string>;
        voucherAmountMonthly?: Maybe<string>;
        introduction?: Maybe<string>;
        isSmoker?: Maybe<string>;
        isSmokerBoolean?: Maybe<boolean>;
        jobTitle?: Maybe<string>;
        leaseLengthMonths?: Maybe<string>;
        moveInDate?: Maybe<string>;
        numBedrooms?: Maybe<string>;
        numOccupants?: Maybe<string>;
        reasonForMoving?: Maybe<string>;
        updatedAtMs?: Maybe<string>;
        petDetails?: Maybe<
          Array<
            Maybe<{
              __typename?: 'ZRM_RenterProfile_PetDetails';
              breed?: Maybe<string>;
              description?: Maybe<string>;
              size?: Maybe<string>;
              type?: Maybe<string>;
              weightPounds?: Maybe<string>;
            }>
          >
        >;
      }>;
    }>;
  };
};

export type LeadManagementStats_GetStatsQueryVariables = Exact<{
  listingAlias: Scalars['String'];
}>;

export type LeadManagementStats_GetStatsQuery = {
  __typename?: 'Query';
  ZRM_getLeadManagementStats: {
    __typename?: 'ZRM_getLeadManagementStatsResponse';
    leadsQualifiedForCriteriaTotal: number;
    hasCriteriaSet: boolean;
    listingAddress: string;
    stats: Array<
      Maybe<{
        __typename?: 'ZRM_LeadManagementStats';
        screeningCriteriaType: string;
        criterionMatchedCount: number;
        percentageMatched: string;
        isNegotiable: boolean;
        screeningCriterionNameDisplay: string;
        screeningCriterionDisplay?: Maybe<string>;
        isCriterionSet: boolean;
      }>
    >;
  };
};

export type InviteToApplyDataFragment = {
  __typename?: 'ZRM_Conversation';
  applicationAlreadySent?: Maybe<boolean>;
  applicationCompleted?: Maybe<boolean>;
  conversationId: string;
  isApplicationsAccepted: boolean;
  isApplicationsAllowed: boolean;
  isConversationBlockedByZillow: boolean;
  referenceEmail?: Maybe<string>;
  referenceName?: Maybe<string>;
  attributes?: Maybe<{ __typename?: 'ZRM_ConversationAttributes'; applicationMarkedSent?: Maybe<boolean> }>;
  inquiry?: Maybe<{ __typename?: 'ZRM_Inquiry'; name?: Maybe<string>; id: string }>;
  status: { __typename?: 'ZRM_ConversationStatus'; isArchived: boolean; isSpam: boolean };
};

export type ConversationActionsHook_UpdateConversationStatusMutationVariables = Exact<{
  conversationId: Scalars['String'];
  isArchived?: Maybe<Scalars['Boolean']>;
  reportReasonType?: Maybe<ReportConversationReason>;
  userReportComment?: Maybe<Scalars['String']>;
}>;

export type ConversationActionsHook_UpdateConversationStatusMutation = {
  __typename?: 'Mutation';
  ZRM_updateConversationStatusV2: { __typename?: 'ZRM_SuccessStatusResponse'; success: boolean };
};

export type ConversationActionsHook_MarkConversationAsReadMutationVariables = Exact<{
  conversationId: Scalars['String'];
  lastReadMs: Scalars['String'];
}>;

export type ConversationActionsHook_MarkConversationAsReadMutation = {
  __typename?: 'Mutation';
  ZRM_updateConversationStatusV2: { __typename?: 'ZRM_SuccessStatusResponse'; success: boolean };
};

export type InviteToApplyHook_InviteToApplyMutationVariables = Exact<{
  listingId: Scalars['String'];
  renterFirstName: Scalars['String'];
  renterLastName: Scalars['String'];
  toEmail: Scalars['String'];
  resendEmail: Scalars['Boolean'];
}>;

export type InviteToApplyHook_InviteToApplyMutation = {
  __typename?: 'Mutation';
  ZRM_inviteToApply: { __typename?: 'ZRM_InviteResponse'; response: string };
};

export type InboxPageRouterHook_GetConversationToLoadQueryVariables = Exact<{
  folder?: Maybe<Folder>;
  daysBack?: Maybe<Scalars['Int']>;
  listingAlias?: Maybe<Scalars['String']>;
  renterProgressStatus?: Maybe<RenterProgressStatus>;
  readRepliedStatus?: Maybe<ReadRepliedStatus>;
}>;

export type InboxPageRouterHook_GetConversationToLoadQuery = {
  __typename?: 'Query';
  ZRM_getLatestConversationsV2: {
    __typename?: 'ZRM_ConversationResponse';
    conversations: Array<{ __typename?: 'ZRM_Conversation'; conversationId: string; listingAlias: string }>;
  };
};

export type InboxPage_GetFeatureFlagsQueryVariables = Exact<{ [key: string]: never }>;

export type InboxPage_GetFeatureFlagsQuery = {
  __typename?: 'Query';
  getFeatureFlags?: Maybe<{
    __typename?: 'FeatureFlagResponse';
    enableLeadMessaging?: Maybe<boolean>;
    enableQuickResponse?: Maybe<boolean>;
    enableUserObjectOptimization?: Maybe<boolean>;
    enableWebsocketIntegration?: Maybe<boolean>;
    enableMessageLinkInSLW?: Maybe<boolean>;
    enableMessageToolbar?: Maybe<boolean>;
    canAccessBlockedUserModalFromRJSModule?: Maybe<boolean>;
  }>;
};

export type PropertyFilterHook_GetPropertyAddressQueryVariables = Exact<{
  listingAlias: Scalars['String'];
}>;

export type PropertyFilterHook_GetPropertyAddressQuery = {
  __typename?: 'Query';
  ZRM_getPropertyAddress: {
    __typename?: 'ZRM_GetPropertyAddressResponse';
    city?: Maybe<string>;
    state?: Maybe<string>;
    street?: Maybe<string>;
    unit?: Maybe<string>;
    zip?: Maybe<string>;
  };
};

export type InviteToApplyHook_GetConversationDataQueryVariables = Exact<{
  conversationId: Scalars['String'];
  listingAlias: Scalars['String'];
}>;

export type InviteToApplyHook_GetConversationDataQuery = {
  __typename?: 'Query';
  ZRM_getConversationById: {
    __typename?: 'ZRM_Conversation';
    applicationAlreadySent?: Maybe<boolean>;
    applicationCompleted?: Maybe<boolean>;
    conversationId: string;
    isApplicationsAccepted: boolean;
    isApplicationsAllowed: boolean;
    isConversationBlockedByZillow: boolean;
    referenceEmail?: Maybe<string>;
    referenceName?: Maybe<string>;
    attributes?: Maybe<{ __typename?: 'ZRM_ConversationAttributes'; applicationMarkedSent?: Maybe<boolean> }>;
    inquiry?: Maybe<{ __typename?: 'ZRM_Inquiry'; name?: Maybe<string>; id: string }>;
    status: { __typename?: 'ZRM_ConversationStatus'; isArchived: boolean; isSpam: boolean };
  };
};

export type Experiment_GetTreatmentQueryVariables = Exact<{
  featureName: Scalars['String'];
  listingAlias?: Maybe<Scalars['String']>;
}>;

export type Experiment_GetTreatmentQuery = {
  __typename?: 'Query';
  ZRM_getExperimentTreatment: {
    __typename?: 'ZRM_getExperimentTreatmentResponse';
    featureName?: Maybe<string>;
    treatment?: Maybe<string>;
  };
};

export const StatusFragmentDoc = gql`
  fragment Status on ZRM_Conversation {
    status {
      isArchived
      isSpam
      isFavorite
    }
  }
`;
export const StatusLabelFragmentDoc = gql`
  fragment StatusLabel on ZRM_Conversation {
    statusLabel {
      text
      linkId
    }
  }
`;
export const NavigationDataFragmentDoc = gql`
  fragment NavigationData on ZRM_Conversation {
    activeParticipantsInConversation {
      name
    }
    conversationId
    inquiry {
      isPhoneLead
      name
      phone
      id
    }
    isConversationBlockedByZillow
    referenceName
    ...Status
  }
  ${StatusFragmentDoc}
`;
export const NotesSectionDataFragmentDoc = gql`
  fragment NotesSectionData on ZRM_Conversation {
    applicationAlreadySent
    conversationId
    note {
      conversationId
      note
    }
    attributes {
      applicationMarkedSent
      tourScheduledTimestampMs
    }
    referenceName
    touring {
      hasZrmToursEnabled
    }
  }
`;
export const ContactActionsDataFragmentDoc = gql`
  fragment ContactActionsData on ZRM_Conversation {
    inquiry {
      id
      name
      phone
    }
    referenceEmail
  }
`;
export const RenterProfileHeaderDataFragmentDoc = gql`
  fragment RenterProfileHeaderData on ZRM_Conversation {
    address
    inquiry {
      name
      phone
      isPhoneLead
      id
    }
    isActive
    referenceName
  }
`;
export const RenterProfileDataFragmentDoc = gql`
  fragment RenterProfileData on ZRM_Conversation {
    address
    applicationCompleted
    conversationId
    isActive
    listingAlias
    isApplicationsAllowed
    isApplicationsAccepted
    notRepliedTo
    propertyTypeCode
    referenceName
    referenceEmail
    status {
      isArchived
      isSpam
    }
    inquiry {
      id
      isPhoneLead
      name
      state
      phone
    }
    ...NotesSectionData
    ...ContactActionsData
    ...RenterProfileHeaderData
  }
  ${NotesSectionDataFragmentDoc}
  ${ContactActionsDataFragmentDoc}
  ${RenterProfileHeaderDataFragmentDoc}
`;
export const ConversationListDataFragmentDoc = gql`
  fragment ConversationListData on ZRM_ConversationResponse {
    conversations {
      activeParticipantsInConversation {
        name
      }
      address
      conversation {
        aiAutoResponseType
        conversationId
        isMessageOwner
        messagePreview
        messageDateMs
        messageId
        messageType
        senderName
        uiTreatmentType
      }
      conversationId
      hasUnreadMessage
      inquiry {
        id
        isPhoneLead
        name
        phone
      }
      lastReadTimestampMs
      listingAlias
      referenceEmail
      referenceName
      ...Status
      ...StatusLabel
      isApplicationsAllowed
      ...NavigationData
      ...RenterProfileData
    }
    pagination {
      queryFullMessageCount
      pageStartIndex
      hasNextPage
      pageConversationCount
    }
  }
  ${StatusFragmentDoc}
  ${StatusLabelFragmentDoc}
  ${NavigationDataFragmentDoc}
  ${RenterProfileDataFragmentDoc}
`;
export const RenterProfileAttributesFragmentDoc = gql`
  fragment RenterProfileAttributes on ZRM_Conversation {
    conversationId
    renterProfile {
      attributes {
        credit
        desiredParking
        incomeYearly
        incomeYearlyRange
        voucherAmountMonthly
        introduction
        isSmoker
        isSmokerBoolean
        jobTitle
        leaseLengthMonths
        moveInDate
        numBedrooms
        numOccupants
        petDetails {
          breed
          description
          size
          type
          weightPounds
        }
        reasonForMoving
        updatedAtMs
      }
      isRenterProfileHidden
      shouldShowRequestRenterProfileCta
    }
  }
`;
export const MessagesPaginationFragmentDoc = gql`
  fragment MessagesPagination on ZRM_Conversation {
    pagination {
      pageConversationCount
      pageStartIndex
      queryFullMessageCount
    }
  }
`;
export const MessageItemAttachmentDataFragmentDoc = gql`
  fragment MessageItemAttachmentData on ZRM_Attachment {
    attachmentMetadataStatus
    downloadUrl
    fileName
    fileSizeBytes
    fileType
    isAttachmentDeleted
    isAttachmentExpired
    previewUrl
    zDocId
  }
`;
export const MessageItemDataFragmentDoc = gql`
  fragment MessageItemData on ZRM_Message {
    aiAutoResponseType
    attachments {
      ...MessageItemAttachmentData
    }
    conversationId
    isMessageOwner
    message
    messagePreview
    messageDateMs
    messageId
    messageType
    senderName
    messageLink {
      url
      text
    }
    uiTreatmentType
    title
  }
  ${MessageItemAttachmentDataFragmentDoc}
`;
export const QuickResponseFragmentDoc = gql`
  fragment QuickResponse on ZRM_Conversation {
    quickResponses {
      prediction
      suggestions {
        id
        text
      }
    }
  }
`;
export const InviteToApplyDataFragmentDoc = gql`
  fragment InviteToApplyData on ZRM_Conversation {
    applicationAlreadySent
    applicationCompleted
    attributes {
      applicationMarkedSent
    }
    conversationId
    inquiry {
      name
      id
    }
    isApplicationsAccepted
    isApplicationsAllowed
    isConversationBlockedByZillow
    referenceEmail
    referenceName
    status {
      isArchived
      isSpam
    }
  }
`;
export const AddMessage_AddMessageToConversationV2Document = gql`
  mutation AddMessage_addMessageToConversationV2(
    $conversationId: String!
    $listingAlias: String
    $message: String!
    $zDocIds: [String!]!
    $quickResponseSuggestionId: String
  ) {
    ZRM_addMessageToConversationV2(
      conversationId: $conversationId
      listingAlias: $listingAlias
      message: $message
      zDocIds: $zDocIds
      quickResponseSuggestionId: $quickResponseSuggestionId
    ) {
      ...MessageItemData
    }
  }
  ${MessageItemDataFragmentDoc}
`;
export type AddMessage_AddMessageToConversationV2MutationFn = Apollo.MutationFunction<
  AddMessage_AddMessageToConversationV2Mutation,
  AddMessage_AddMessageToConversationV2MutationVariables
>;

/**
 * __useAddMessage_AddMessageToConversationV2Mutation__
 *
 * To run a mutation, you first call `useAddMessage_AddMessageToConversationV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMessage_AddMessageToConversationV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMessageAddMessageToConversationV2Mutation, { data, loading, error }] = useAddMessage_AddMessageToConversationV2Mutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      listingAlias: // value for 'listingAlias'
 *      message: // value for 'message'
 *      zDocIds: // value for 'zDocIds'
 *      quickResponseSuggestionId: // value for 'quickResponseSuggestionId'
 *   },
 * });
 */
export function useAddMessage_AddMessageToConversationV2Mutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddMessage_AddMessageToConversationV2Mutation,
    AddMessage_AddMessageToConversationV2MutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddMessage_AddMessageToConversationV2Mutation,
    AddMessage_AddMessageToConversationV2MutationVariables
  >(AddMessage_AddMessageToConversationV2Document, options);
}
export type AddMessage_AddMessageToConversationV2MutationHookResult = ReturnType<
  typeof useAddMessage_AddMessageToConversationV2Mutation
>;
export type AddMessage_AddMessageToConversationV2MutationOptions = Apollo.BaseMutationOptions<
  AddMessage_AddMessageToConversationV2Mutation,
  AddMessage_AddMessageToConversationV2MutationVariables
>;
export const AddMessage_GetCurrentConversationDataDocument = gql`
  query AddMessage_getCurrentConversationData(
    $conversationId: String!
    $listingAlias: String!
    $clientTimeZone: String!
  ) {
    ZRM_getConversationById(
      conversationId: $conversationId
      listingAlias: $listingAlias
      clientTimeZone: $clientTimeZone
    ) {
      conversationId
      inquiry {
        id
        isPhoneLead
      }
      isConversationBlockedByZillow
      hasQuickResponses
      ...Status
      ...StatusLabel
      ...QuickResponse
    }
  }
  ${StatusFragmentDoc}
  ${StatusLabelFragmentDoc}
  ${QuickResponseFragmentDoc}
`;

/**
 * __useAddMessage_GetCurrentConversationDataQuery__
 *
 * To run a query within a React component, call `useAddMessage_GetCurrentConversationDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddMessage_GetCurrentConversationDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddMessage_GetCurrentConversationDataQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      listingAlias: // value for 'listingAlias'
 *      clientTimeZone: // value for 'clientTimeZone'
 *   },
 * });
 */
export function useAddMessage_GetCurrentConversationDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    AddMessage_GetCurrentConversationDataQuery,
    AddMessage_GetCurrentConversationDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AddMessage_GetCurrentConversationDataQuery,
    AddMessage_GetCurrentConversationDataQueryVariables
  >(AddMessage_GetCurrentConversationDataDocument, options);
}
export function useAddMessage_GetCurrentConversationDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AddMessage_GetCurrentConversationDataQuery,
    AddMessage_GetCurrentConversationDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AddMessage_GetCurrentConversationDataQuery,
    AddMessage_GetCurrentConversationDataQueryVariables
  >(AddMessage_GetCurrentConversationDataDocument, options);
}
export type AddMessage_GetCurrentConversationDataQueryHookResult = ReturnType<
  typeof useAddMessage_GetCurrentConversationDataQuery
>;
export type AddMessage_GetCurrentConversationDataLazyQueryHookResult = ReturnType<
  typeof useAddMessage_GetCurrentConversationDataLazyQuery
>;
export function refetchAddMessage_GetCurrentConversationDataQuery(
  variables?: AddMessage_GetCurrentConversationDataQueryVariables,
) {
  return { query: AddMessage_GetCurrentConversationDataDocument, variables: variables };
}
export const ConversationList_GetConversationsDocument = gql`
  query ConversationList_GetConversations(
    $conversationId: String
    $paginationStartIndex: String
    $listingAlias: String
    $daysBack: Int
    $clientTimeZone: String
    $folder: Folder
    $readRepliedStatus: ReadRepliedStatus
    $renterProgressStatus: RenterProgressStatus
  ) {
    ZRM_getLatestConversationsV2(
      conversationId: $conversationId
      paginationStartIndex: $paginationStartIndex
      listingAlias: $listingAlias
      daysBack: $daysBack
      includeStatusLabels: true
      clientTimeZone: $clientTimeZone
      folder: $folder
      readRepliedStatus: $readRepliedStatus
      renterProgressStatus: $renterProgressStatus
      excludeNote: false
    ) {
      ...ConversationListData
    }
  }
  ${ConversationListDataFragmentDoc}
`;

/**
 * __useConversationList_GetConversationsQuery__
 *
 * To run a query within a React component, call `useConversationList_GetConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversationList_GetConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationList_GetConversationsQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      paginationStartIndex: // value for 'paginationStartIndex'
 *      listingAlias: // value for 'listingAlias'
 *      daysBack: // value for 'daysBack'
 *      clientTimeZone: // value for 'clientTimeZone'
 *      folder: // value for 'folder'
 *      readRepliedStatus: // value for 'readRepliedStatus'
 *      renterProgressStatus: // value for 'renterProgressStatus'
 *   },
 * });
 */
export function useConversationList_GetConversationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConversationList_GetConversationsQuery,
    ConversationList_GetConversationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ConversationList_GetConversationsQuery, ConversationList_GetConversationsQueryVariables>(
    ConversationList_GetConversationsDocument,
    options,
  );
}
export function useConversationList_GetConversationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConversationList_GetConversationsQuery,
    ConversationList_GetConversationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ConversationList_GetConversationsQuery, ConversationList_GetConversationsQueryVariables>(
    ConversationList_GetConversationsDocument,
    options,
  );
}
export type ConversationList_GetConversationsQueryHookResult = ReturnType<
  typeof useConversationList_GetConversationsQuery
>;
export type ConversationList_GetConversationsLazyQueryHookResult = ReturnType<
  typeof useConversationList_GetConversationsLazyQuery
>;
export function refetchConversationList_GetConversationsQuery(
  variables?: ConversationList_GetConversationsQueryVariables,
) {
  return { query: ConversationList_GetConversationsDocument, variables: variables };
}
export const ConversationNav_GetConversationDocument = gql`
  query ConversationNav_GetConversation($conversationId: String!, $listingAlias: String!) {
    ZRM_getConversationById(conversationId: $conversationId, listingAlias: $listingAlias, includeInquiryInfo: true) {
      ...NavigationData
    }
  }
  ${NavigationDataFragmentDoc}
`;

/**
 * __useConversationNav_GetConversationQuery__
 *
 * To run a query within a React component, call `useConversationNav_GetConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversationNav_GetConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationNav_GetConversationQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      listingAlias: // value for 'listingAlias'
 *   },
 * });
 */
export function useConversationNav_GetConversationQuery(
  baseOptions: Apollo.QueryHookOptions<
    ConversationNav_GetConversationQuery,
    ConversationNav_GetConversationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ConversationNav_GetConversationQuery, ConversationNav_GetConversationQueryVariables>(
    ConversationNav_GetConversationDocument,
    options,
  );
}
export function useConversationNav_GetConversationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConversationNav_GetConversationQuery,
    ConversationNav_GetConversationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ConversationNav_GetConversationQuery, ConversationNav_GetConversationQueryVariables>(
    ConversationNav_GetConversationDocument,
    options,
  );
}
export type ConversationNav_GetConversationQueryHookResult = ReturnType<typeof useConversationNav_GetConversationQuery>;
export type ConversationNav_GetConversationLazyQueryHookResult = ReturnType<
  typeof useConversationNav_GetConversationLazyQuery
>;
export function refetchConversationNav_GetConversationQuery(variables?: ConversationNav_GetConversationQueryVariables) {
  return { query: ConversationNav_GetConversationDocument, variables: variables };
}
export const ConversationSearchBar_GetConversationSearchResultDocument = gql`
  query ConversationSearchBar_getConversationSearchResult(
    $offset: Int!
    $limit: Int!
    $listingAlias: String
    $searchText: String!
    $startTimestampMs: String!
    $endTimestampMs: String!
  ) {
    ZRM_getConversationSearchResult(
      offset: $offset
      limit: $limit
      listingAlias: $listingAlias
      searchText: $searchText
      startTimestampMs: $startTimestampMs
      endTimestampMs: $endTimestampMs
    ) {
      searchResult {
        conversationId
        folder
        listingAlias
        renterName
        renterPhoneNumber
        streetAddress
      }
      hasMore
    }
  }
`;

/**
 * __useConversationSearchBar_GetConversationSearchResultQuery__
 *
 * To run a query within a React component, call `useConversationSearchBar_GetConversationSearchResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversationSearchBar_GetConversationSearchResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationSearchBar_GetConversationSearchResultQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      listingAlias: // value for 'listingAlias'
 *      searchText: // value for 'searchText'
 *      startTimestampMs: // value for 'startTimestampMs'
 *      endTimestampMs: // value for 'endTimestampMs'
 *   },
 * });
 */
export function useConversationSearchBar_GetConversationSearchResultQuery(
  baseOptions: Apollo.QueryHookOptions<
    ConversationSearchBar_GetConversationSearchResultQuery,
    ConversationSearchBar_GetConversationSearchResultQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConversationSearchBar_GetConversationSearchResultQuery,
    ConversationSearchBar_GetConversationSearchResultQueryVariables
  >(ConversationSearchBar_GetConversationSearchResultDocument, options);
}
export function useConversationSearchBar_GetConversationSearchResultLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConversationSearchBar_GetConversationSearchResultQuery,
    ConversationSearchBar_GetConversationSearchResultQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConversationSearchBar_GetConversationSearchResultQuery,
    ConversationSearchBar_GetConversationSearchResultQueryVariables
  >(ConversationSearchBar_GetConversationSearchResultDocument, options);
}
export type ConversationSearchBar_GetConversationSearchResultQueryHookResult = ReturnType<
  typeof useConversationSearchBar_GetConversationSearchResultQuery
>;
export type ConversationSearchBar_GetConversationSearchResultLazyQueryHookResult = ReturnType<
  typeof useConversationSearchBar_GetConversationSearchResultLazyQuery
>;
export function refetchConversationSearchBar_GetConversationSearchResultQuery(
  variables?: ConversationSearchBar_GetConversationSearchResultQueryVariables,
) {
  return { query: ConversationSearchBar_GetConversationSearchResultDocument, variables: variables };
}
export const RenterProfile_GetAttachmentsByConversationIdDocument = gql`
  query RenterProfile_getAttachmentsByConversationId($conversationId: String!) {
    ZRM_getAttachmentsByConversationId(conversationId: $conversationId) {
      attachments {
        attachmentAddedMs
        attachmentMetadataStatus
        downloadUrl
        fileName
        fileSizeBytes
        fileType
        isAttachmentDeleted
        isAttachmentExpired
        previewUrl
        zDocId
      }
    }
  }
`;

/**
 * __useRenterProfile_GetAttachmentsByConversationIdQuery__
 *
 * To run a query within a React component, call `useRenterProfile_GetAttachmentsByConversationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useRenterProfile_GetAttachmentsByConversationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRenterProfile_GetAttachmentsByConversationIdQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useRenterProfile_GetAttachmentsByConversationIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    RenterProfile_GetAttachmentsByConversationIdQuery,
    RenterProfile_GetAttachmentsByConversationIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    RenterProfile_GetAttachmentsByConversationIdQuery,
    RenterProfile_GetAttachmentsByConversationIdQueryVariables
  >(RenterProfile_GetAttachmentsByConversationIdDocument, options);
}
export function useRenterProfile_GetAttachmentsByConversationIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RenterProfile_GetAttachmentsByConversationIdQuery,
    RenterProfile_GetAttachmentsByConversationIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RenterProfile_GetAttachmentsByConversationIdQuery,
    RenterProfile_GetAttachmentsByConversationIdQueryVariables
  >(RenterProfile_GetAttachmentsByConversationIdDocument, options);
}
export type RenterProfile_GetAttachmentsByConversationIdQueryHookResult = ReturnType<
  typeof useRenterProfile_GetAttachmentsByConversationIdQuery
>;
export type RenterProfile_GetAttachmentsByConversationIdLazyQueryHookResult = ReturnType<
  typeof useRenterProfile_GetAttachmentsByConversationIdLazyQuery
>;
export function refetchRenterProfile_GetAttachmentsByConversationIdQuery(
  variables?: RenterProfile_GetAttachmentsByConversationIdQueryVariables,
) {
  return { query: RenterProfile_GetAttachmentsByConversationIdDocument, variables: variables };
}
export const RenterProfileContactActionsDataDocument = gql`
  query RenterProfileContactActionsData($conversationId: String!, $listingAlias: String!) {
    ZRM_getConversationById(
      conversationId: $conversationId
      includeInquiryInfo: true
      includeUserLeadAttributes: true
      listingAlias: $listingAlias
    ) {
      ...ContactActionsData
    }
  }
  ${ContactActionsDataFragmentDoc}
`;

/**
 * __useRenterProfileContactActionsDataQuery__
 *
 * To run a query within a React component, call `useRenterProfileContactActionsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useRenterProfileContactActionsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRenterProfileContactActionsDataQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      listingAlias: // value for 'listingAlias'
 *   },
 * });
 */
export function useRenterProfileContactActionsDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    RenterProfileContactActionsDataQuery,
    RenterProfileContactActionsDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RenterProfileContactActionsDataQuery, RenterProfileContactActionsDataQueryVariables>(
    RenterProfileContactActionsDataDocument,
    options,
  );
}
export function useRenterProfileContactActionsDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RenterProfileContactActionsDataQuery,
    RenterProfileContactActionsDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RenterProfileContactActionsDataQuery, RenterProfileContactActionsDataQueryVariables>(
    RenterProfileContactActionsDataDocument,
    options,
  );
}
export type RenterProfileContactActionsDataQueryHookResult = ReturnType<typeof useRenterProfileContactActionsDataQuery>;
export type RenterProfileContactActionsDataLazyQueryHookResult = ReturnType<
  typeof useRenterProfileContactActionsDataLazyQuery
>;
export function refetchRenterProfileContactActionsDataQuery(variables?: RenterProfileContactActionsDataQueryVariables) {
  return { query: RenterProfileContactActionsDataDocument, variables: variables };
}
export const ExpiredRenterProfileDataDocument = gql`
  query ExpiredRenterProfileData($conversationId: String!, $listingAlias: String!) {
    ZRM_getConversationById(conversationId: $conversationId, listingAlias: $listingAlias) {
      renterProfile {
        isRenterProfileHidden
      }
    }
  }
`;

/**
 * __useExpiredRenterProfileDataQuery__
 *
 * To run a query within a React component, call `useExpiredRenterProfileDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpiredRenterProfileDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpiredRenterProfileDataQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      listingAlias: // value for 'listingAlias'
 *   },
 * });
 */
export function useExpiredRenterProfileDataQuery(
  baseOptions: Apollo.QueryHookOptions<ExpiredRenterProfileDataQuery, ExpiredRenterProfileDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ExpiredRenterProfileDataQuery, ExpiredRenterProfileDataQueryVariables>(
    ExpiredRenterProfileDataDocument,
    options,
  );
}
export function useExpiredRenterProfileDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ExpiredRenterProfileDataQuery, ExpiredRenterProfileDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ExpiredRenterProfileDataQuery, ExpiredRenterProfileDataQueryVariables>(
    ExpiredRenterProfileDataDocument,
    options,
  );
}
export type ExpiredRenterProfileDataQueryHookResult = ReturnType<typeof useExpiredRenterProfileDataQuery>;
export type ExpiredRenterProfileDataLazyQueryHookResult = ReturnType<typeof useExpiredRenterProfileDataLazyQuery>;
export function refetchExpiredRenterProfileDataQuery(variables?: ExpiredRenterProfileDataQueryVariables) {
  return { query: ExpiredRenterProfileDataDocument, variables: variables };
}
export const RenterProfileHeaderDataDocument = gql`
  query RenterProfileHeaderData($conversationId: String!, $listingAlias: String!) {
    ZRM_getConversationById(
      conversationId: $conversationId
      includeInquiryInfo: true
      includeUserLeadAttributes: true
      listingAlias: $listingAlias
    ) {
      ...RenterProfileHeaderData
    }
  }
  ${RenterProfileHeaderDataFragmentDoc}
`;

/**
 * __useRenterProfileHeaderDataQuery__
 *
 * To run a query within a React component, call `useRenterProfileHeaderDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useRenterProfileHeaderDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRenterProfileHeaderDataQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      listingAlias: // value for 'listingAlias'
 *   },
 * });
 */
export function useRenterProfileHeaderDataQuery(
  baseOptions: Apollo.QueryHookOptions<RenterProfileHeaderDataQuery, RenterProfileHeaderDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RenterProfileHeaderDataQuery, RenterProfileHeaderDataQueryVariables>(
    RenterProfileHeaderDataDocument,
    options,
  );
}
export function useRenterProfileHeaderDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<RenterProfileHeaderDataQuery, RenterProfileHeaderDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RenterProfileHeaderDataQuery, RenterProfileHeaderDataQueryVariables>(
    RenterProfileHeaderDataDocument,
    options,
  );
}
export type RenterProfileHeaderDataQueryHookResult = ReturnType<typeof useRenterProfileHeaderDataQuery>;
export type RenterProfileHeaderDataLazyQueryHookResult = ReturnType<typeof useRenterProfileHeaderDataLazyQuery>;
export function refetchRenterProfileHeaderDataQuery(variables?: RenterProfileHeaderDataQueryVariables) {
  return { query: RenterProfileHeaderDataDocument, variables: variables };
}
export const RenterProfileHeader_GetConnectedExperienceDocument = gql`
  query RenterProfileHeader_getConnectedExperience($listingAlias: String!) {
    ZRM_getConnectedExperience(propertyId: $listingAlias) {
      isConnectedExperience
    }
  }
`;

/**
 * __useRenterProfileHeader_GetConnectedExperienceQuery__
 *
 * To run a query within a React component, call `useRenterProfileHeader_GetConnectedExperienceQuery` and pass it any options that fit your needs.
 * When your component renders, `useRenterProfileHeader_GetConnectedExperienceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRenterProfileHeader_GetConnectedExperienceQuery({
 *   variables: {
 *      listingAlias: // value for 'listingAlias'
 *   },
 * });
 */
export function useRenterProfileHeader_GetConnectedExperienceQuery(
  baseOptions: Apollo.QueryHookOptions<
    RenterProfileHeader_GetConnectedExperienceQuery,
    RenterProfileHeader_GetConnectedExperienceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    RenterProfileHeader_GetConnectedExperienceQuery,
    RenterProfileHeader_GetConnectedExperienceQueryVariables
  >(RenterProfileHeader_GetConnectedExperienceDocument, options);
}
export function useRenterProfileHeader_GetConnectedExperienceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RenterProfileHeader_GetConnectedExperienceQuery,
    RenterProfileHeader_GetConnectedExperienceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RenterProfileHeader_GetConnectedExperienceQuery,
    RenterProfileHeader_GetConnectedExperienceQueryVariables
  >(RenterProfileHeader_GetConnectedExperienceDocument, options);
}
export type RenterProfileHeader_GetConnectedExperienceQueryHookResult = ReturnType<
  typeof useRenterProfileHeader_GetConnectedExperienceQuery
>;
export type RenterProfileHeader_GetConnectedExperienceLazyQueryHookResult = ReturnType<
  typeof useRenterProfileHeader_GetConnectedExperienceLazyQuery
>;
export function refetchRenterProfileHeader_GetConnectedExperienceQuery(
  variables?: RenterProfileHeader_GetConnectedExperienceQueryVariables,
) {
  return { query: RenterProfileHeader_GetConnectedExperienceDocument, variables: variables };
}
export const NextStepDataDocument = gql`
  query NextStepData($conversationId: String!, $listingAlias: String!) {
    ZRM_getConversationById(conversationId: $conversationId, includeInquiryInfo: true, listingAlias: $listingAlias) {
      conversationId
      isApplicationsAllowed
      isApplicationsAccepted
      inquiry {
        name
        isPhoneLead
        phone
        id
      }
      referenceEmail
    }
  }
`;

/**
 * __useNextStepDataQuery__
 *
 * To run a query within a React component, call `useNextStepDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useNextStepDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNextStepDataQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      listingAlias: // value for 'listingAlias'
 *   },
 * });
 */
export function useNextStepDataQuery(
  baseOptions: Apollo.QueryHookOptions<NextStepDataQuery, NextStepDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<NextStepDataQuery, NextStepDataQueryVariables>(NextStepDataDocument, options);
}
export function useNextStepDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<NextStepDataQuery, NextStepDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<NextStepDataQuery, NextStepDataQueryVariables>(NextStepDataDocument, options);
}
export type NextStepDataQueryHookResult = ReturnType<typeof useNextStepDataQuery>;
export type NextStepDataLazyQueryHookResult = ReturnType<typeof useNextStepDataLazyQuery>;
export function refetchNextStepDataQuery(variables?: NextStepDataQueryVariables) {
  return { query: NextStepDataDocument, variables: variables };
}
export const RenterProfileNotesDataDocument = gql`
  query RenterProfileNotesData($conversationId: String!, $listingAlias: String!) {
    ZRM_getConversationById(
      conversationId: $conversationId
      includeInquiryInfo: true
      includeUserLeadAttributes: true
      listingAlias: $listingAlias
    ) {
      applicationAlreadySent
      ...NotesSectionData
    }
  }
  ${NotesSectionDataFragmentDoc}
`;

/**
 * __useRenterProfileNotesDataQuery__
 *
 * To run a query within a React component, call `useRenterProfileNotesDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useRenterProfileNotesDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRenterProfileNotesDataQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      listingAlias: // value for 'listingAlias'
 *   },
 * });
 */
export function useRenterProfileNotesDataQuery(
  baseOptions: Apollo.QueryHookOptions<RenterProfileNotesDataQuery, RenterProfileNotesDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RenterProfileNotesDataQuery, RenterProfileNotesDataQueryVariables>(
    RenterProfileNotesDataDocument,
    options,
  );
}
export function useRenterProfileNotesDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<RenterProfileNotesDataQuery, RenterProfileNotesDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RenterProfileNotesDataQuery, RenterProfileNotesDataQueryVariables>(
    RenterProfileNotesDataDocument,
    options,
  );
}
export type RenterProfileNotesDataQueryHookResult = ReturnType<typeof useRenterProfileNotesDataQuery>;
export type RenterProfileNotesDataLazyQueryHookResult = ReturnType<typeof useRenterProfileNotesDataLazyQuery>;
export function refetchRenterProfileNotesDataQuery(variables?: RenterProfileNotesDataQueryVariables) {
  return { query: RenterProfileNotesDataDocument, variables: variables };
}
export const RenterProfileAttributesDataDocument = gql`
  query RenterProfileAttributesData($conversationId: String!, $listingAlias: String!) {
    ZRM_getConversationById(conversationId: $conversationId, includeRenterProfile: true, listingAlias: $listingAlias) {
      ...RenterProfileAttributes
    }
  }
  ${RenterProfileAttributesFragmentDoc}
`;

/**
 * __useRenterProfileAttributesDataQuery__
 *
 * To run a query within a React component, call `useRenterProfileAttributesDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useRenterProfileAttributesDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRenterProfileAttributesDataQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      listingAlias: // value for 'listingAlias'
 *   },
 * });
 */
export function useRenterProfileAttributesDataQuery(
  baseOptions: Apollo.QueryHookOptions<RenterProfileAttributesDataQuery, RenterProfileAttributesDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RenterProfileAttributesDataQuery, RenterProfileAttributesDataQueryVariables>(
    RenterProfileAttributesDataDocument,
    options,
  );
}
export function useRenterProfileAttributesDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RenterProfileAttributesDataQuery,
    RenterProfileAttributesDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RenterProfileAttributesDataQuery, RenterProfileAttributesDataQueryVariables>(
    RenterProfileAttributesDataDocument,
    options,
  );
}
export type RenterProfileAttributesDataQueryHookResult = ReturnType<typeof useRenterProfileAttributesDataQuery>;
export type RenterProfileAttributesDataLazyQueryHookResult = ReturnType<typeof useRenterProfileAttributesDataLazyQuery>;
export function refetchRenterProfileAttributesDataQuery(variables?: RenterProfileAttributesDataQueryVariables) {
  return { query: RenterProfileAttributesDataDocument, variables: variables };
}
export const LeadManagementSearchBar_GetSearchResultDocument = gql`
  query LeadManagementSearchBar_getSearchResult(
    $offset: Int!
    $limit: Int!
    $listingAlias: String!
    $searchText: String!
    $startTimestampMs: String!
    $endTimestampMs: String!
  ) {
    ZRM_getLeadManagementSearchResult(
      offset: $offset
      limit: $limit
      listingAlias: $listingAlias
      searchText: $searchText
      startTimestampMs: $startTimestampMs
      endTimestampMs: $endTimestampMs
    ) {
      responseEntries {
        searchEntry {
          conversationId
          folder
          listingAlias
          renterName
          renterPhoneNumber
          streetAddress
        }
        screeningCriteria {
          numCriteriaSelectedByLandlord
          criteriaMatchedDisplay
          numRequiredOrNegotiableCriteriaSelectedByLandlordThatMatch
        }
        conversationId
      }
      hasMore
    }
  }
`;

/**
 * __useLeadManagementSearchBar_GetSearchResultQuery__
 *
 * To run a query within a React component, call `useLeadManagementSearchBar_GetSearchResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeadManagementSearchBar_GetSearchResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeadManagementSearchBar_GetSearchResultQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      listingAlias: // value for 'listingAlias'
 *      searchText: // value for 'searchText'
 *      startTimestampMs: // value for 'startTimestampMs'
 *      endTimestampMs: // value for 'endTimestampMs'
 *   },
 * });
 */
export function useLeadManagementSearchBar_GetSearchResultQuery(
  baseOptions: Apollo.QueryHookOptions<
    LeadManagementSearchBar_GetSearchResultQuery,
    LeadManagementSearchBar_GetSearchResultQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    LeadManagementSearchBar_GetSearchResultQuery,
    LeadManagementSearchBar_GetSearchResultQueryVariables
  >(LeadManagementSearchBar_GetSearchResultDocument, options);
}
export function useLeadManagementSearchBar_GetSearchResultLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LeadManagementSearchBar_GetSearchResultQuery,
    LeadManagementSearchBar_GetSearchResultQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LeadManagementSearchBar_GetSearchResultQuery,
    LeadManagementSearchBar_GetSearchResultQueryVariables
  >(LeadManagementSearchBar_GetSearchResultDocument, options);
}
export type LeadManagementSearchBar_GetSearchResultQueryHookResult = ReturnType<
  typeof useLeadManagementSearchBar_GetSearchResultQuery
>;
export type LeadManagementSearchBar_GetSearchResultLazyQueryHookResult = ReturnType<
  typeof useLeadManagementSearchBar_GetSearchResultLazyQuery
>;
export function refetchLeadManagementSearchBar_GetSearchResultQuery(
  variables?: LeadManagementSearchBar_GetSearchResultQueryVariables,
) {
  return { query: LeadManagementSearchBar_GetSearchResultDocument, variables: variables };
}
export const LeadManagementTable_GetLeadsDocument = gql`
  query LeadManagementTable_getLeads(
    $clientTimeZone: String!
    $listingAlias: String
    $conversationId: String
    $folder: Folder!
    $minCriteriaMatches: Int
    $readRepliedStatus: ReadRepliedStatus!
    $renterProgressStatus: RenterProgressStatus!
    $start: Int
  ) {
    ZRM_getLeadManagementLeads(
      clientTimeZone: $clientTimeZone
      listingAlias: $listingAlias
      conversationId: $conversationId
      folder: $folder
      minCriteriaMatches: $minCriteriaMatches
      readRepliedStatus: $readRepliedStatus
      renterProgressStatus: $renterProgressStatus
      start: $start
    ) {
      leads {
        renterInfo {
          renterName
          renterPhoneNumber
          renterRelayEmailAddress
          firstContactDateMs
        }
        screeningCriteria {
          criteria {
            screeningCriteriaType
            hasMatchingCriterion
            rentersCriterionSubmittedDisplay
            renterDataToolTipText
            isCriterionSet
            screeningCriterionDisplay
            isNegotiable
          }
          numCriteriaSelectedByLandlord
          criteriaMatchedDisplay
          hasSubmittedProfile
          hasScreeningCriteria
          shouldShowRequestRenterProfileCta
          numRequiredOrNegotiableCriteriaSelectedByLandlordThatMatch
        }
        statusLabel {
          text
          linkId
          linkData
        }
        latestContact {
          aiAutoResponseType
          hasAttachments
          isMessageOwner
          isPhoneLead
          isNew
          isRead
          messageDateMs
          messageText
          messageType
          senderName
        }
        nextStep {
          nextStepType
          link {
            linkId
            text
            url
          }
        }
        status {
          isArchived
          isSpam
          isScheduled
          applicationMarkedSent
          isFavorite
          isConversationBlockedByZillow
        }
        applicationInfo {
          isApplicationsAccepted
          isApplicationCompleted
        }
        renterProfile {
          attributes {
            credit
            desiredParking
            incomeYearly
            incomeYearlyRange
            voucherAmountMonthly
            introduction
            isSmoker
            jobTitle
            leaseLengthMonths
            moveInDate
            numBedrooms
            numOccupants
            petDetails {
              breed
              description
              size
              type
              weightPounds
            }
            reasonForMoving
            updatedAtMs
          }
          isRenterProfileHidden
          leadIntentValue
          renterProfileCompleteness
          shouldShowRequestRenterProfileCta
        }
        renterProgressBar {
          inquiry {
            statusType
            hasStatusLabel
          }
          tour {
            statusType
            hasStatusLabel
          }
          application {
            statusType
            hasStatusLabel
          }
          lease {
            statusType
            hasStatusLabel
          }
        }
        conversationId
        touring {
          hasZrmToursEnabled
        }
      }
      listingDetails {
        listingAlias
        listingAddress
      }
      screeningCriteriaDetails {
        isScreeningCriteriaIncomplete
      }
      totalLeadCount
      hasNextPage
    }
  }
`;

/**
 * __useLeadManagementTable_GetLeadsQuery__
 *
 * To run a query within a React component, call `useLeadManagementTable_GetLeadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeadManagementTable_GetLeadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeadManagementTable_GetLeadsQuery({
 *   variables: {
 *      clientTimeZone: // value for 'clientTimeZone'
 *      listingAlias: // value for 'listingAlias'
 *      conversationId: // value for 'conversationId'
 *      folder: // value for 'folder'
 *      minCriteriaMatches: // value for 'minCriteriaMatches'
 *      readRepliedStatus: // value for 'readRepliedStatus'
 *      renterProgressStatus: // value for 'renterProgressStatus'
 *      start: // value for 'start'
 *   },
 * });
 */
export function useLeadManagementTable_GetLeadsQuery(
  baseOptions: Apollo.QueryHookOptions<LeadManagementTable_GetLeadsQuery, LeadManagementTable_GetLeadsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LeadManagementTable_GetLeadsQuery, LeadManagementTable_GetLeadsQueryVariables>(
    LeadManagementTable_GetLeadsDocument,
    options,
  );
}
export function useLeadManagementTable_GetLeadsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LeadManagementTable_GetLeadsQuery,
    LeadManagementTable_GetLeadsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LeadManagementTable_GetLeadsQuery, LeadManagementTable_GetLeadsQueryVariables>(
    LeadManagementTable_GetLeadsDocument,
    options,
  );
}
export type LeadManagementTable_GetLeadsQueryHookResult = ReturnType<typeof useLeadManagementTable_GetLeadsQuery>;
export type LeadManagementTable_GetLeadsLazyQueryHookResult = ReturnType<
  typeof useLeadManagementTable_GetLeadsLazyQuery
>;
export function refetchLeadManagementTable_GetLeadsQuery(variables?: LeadManagementTable_GetLeadsQueryVariables) {
  return { query: LeadManagementTable_GetLeadsDocument, variables: variables };
}
export const LeadSummaryCounts_GetListingPerformanceDocument = gql`
  query LeadSummaryCounts_getListingPerformance(
    $startDayYyyyMmDd: String!
    $endDayYyyyMmDd: String!
    $listingAlias: String
  ) {
    ZRM_getListingPerformance(
      startDayYyyyMmDd: $startDayYyyyMmDd
      endDayYyyyMmDd: $endDayYyyyMmDd
      includeMarketInsights: false
      listingAlias: $listingAlias
    ) {
      analytics {
        clickCount
        leadCount
      }
      insights {
        portfolioClickCount
        portfolioLeadsTotal
      }
    }
  }
`;

/**
 * __useLeadSummaryCounts_GetListingPerformanceQuery__
 *
 * To run a query within a React component, call `useLeadSummaryCounts_GetListingPerformanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeadSummaryCounts_GetListingPerformanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeadSummaryCounts_GetListingPerformanceQuery({
 *   variables: {
 *      startDayYyyyMmDd: // value for 'startDayYyyyMmDd'
 *      endDayYyyyMmDd: // value for 'endDayYyyyMmDd'
 *      listingAlias: // value for 'listingAlias'
 *   },
 * });
 */
export function useLeadSummaryCounts_GetListingPerformanceQuery(
  baseOptions: Apollo.QueryHookOptions<
    LeadSummaryCounts_GetListingPerformanceQuery,
    LeadSummaryCounts_GetListingPerformanceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    LeadSummaryCounts_GetListingPerformanceQuery,
    LeadSummaryCounts_GetListingPerformanceQueryVariables
  >(LeadSummaryCounts_GetListingPerformanceDocument, options);
}
export function useLeadSummaryCounts_GetListingPerformanceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LeadSummaryCounts_GetListingPerformanceQuery,
    LeadSummaryCounts_GetListingPerformanceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LeadSummaryCounts_GetListingPerformanceQuery,
    LeadSummaryCounts_GetListingPerformanceQueryVariables
  >(LeadSummaryCounts_GetListingPerformanceDocument, options);
}
export type LeadSummaryCounts_GetListingPerformanceQueryHookResult = ReturnType<
  typeof useLeadSummaryCounts_GetListingPerformanceQuery
>;
export type LeadSummaryCounts_GetListingPerformanceLazyQueryHookResult = ReturnType<
  typeof useLeadSummaryCounts_GetListingPerformanceLazyQuery
>;
export function refetchLeadSummaryCounts_GetListingPerformanceQuery(
  variables?: LeadSummaryCounts_GetListingPerformanceQueryVariables,
) {
  return { query: LeadSummaryCounts_GetListingPerformanceDocument, variables: variables };
}
export const LeadsTable_GetConversationsDocument = gql`
  query LeadsTable_GetConversations(
    $clientTimeZone: String
    $endDateYyyyMmDd: String
    $folder: Folder
    $limit: Int
    $listingAlias: String
    $readRepliedStatus: ReadRepliedStatus
    $renterProgressStatus: RenterProgressStatus
    $startDateYyyyMmDd: String
    $startIndex: Int
  ) {
    ZRM_getLatestConversationsV2(
      clientTimeZone: $clientTimeZone
      endDateYyyyMmDd: $endDateYyyyMmDd
      excludeNote: false
      folder: $folder
      includeRenterProfile: true
      limit: $limit
      listingAlias: $listingAlias
      readRepliedStatus: $readRepliedStatus
      renterProgressStatus: $renterProgressStatus
      startDateYyyyMmDd: $startDateYyyyMmDd
      startIndex: $startIndex
    ) {
      conversations {
        address
        applicationAlreadySent
        attributes {
          applicationMarkedSent
          tourScheduledTimestampMs
        }
        conversation {
          conversationId
          messagePreview
          messageId
          messageDateMs
          senderName
        }
        conversationId
        inquiry {
          email
          id
          isPhoneLead
          name
          phone
        }
        listingAlias
        note {
          conversationId
          note
          lastUpdatedMs
        }
        referenceName
        renterProfile {
          leadIntentValue
          renterProfileCompleteness
        }
        ...InviteToApplyData
        ...RenterProfileAttributes
        ...Status
      }
      pagination {
        pageStartIndex
        hasNextPage
        pageConversationCount
      }
    }
  }
  ${InviteToApplyDataFragmentDoc}
  ${RenterProfileAttributesFragmentDoc}
  ${StatusFragmentDoc}
`;

/**
 * __useLeadsTable_GetConversationsQuery__
 *
 * To run a query within a React component, call `useLeadsTable_GetConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeadsTable_GetConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeadsTable_GetConversationsQuery({
 *   variables: {
 *      clientTimeZone: // value for 'clientTimeZone'
 *      endDateYyyyMmDd: // value for 'endDateYyyyMmDd'
 *      folder: // value for 'folder'
 *      limit: // value for 'limit'
 *      listingAlias: // value for 'listingAlias'
 *      readRepliedStatus: // value for 'readRepliedStatus'
 *      renterProgressStatus: // value for 'renterProgressStatus'
 *      startDateYyyyMmDd: // value for 'startDateYyyyMmDd'
 *      startIndex: // value for 'startIndex'
 *   },
 * });
 */
export function useLeadsTable_GetConversationsQuery(
  baseOptions?: Apollo.QueryHookOptions<LeadsTable_GetConversationsQuery, LeadsTable_GetConversationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LeadsTable_GetConversationsQuery, LeadsTable_GetConversationsQueryVariables>(
    LeadsTable_GetConversationsDocument,
    options,
  );
}
export function useLeadsTable_GetConversationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LeadsTable_GetConversationsQuery,
    LeadsTable_GetConversationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LeadsTable_GetConversationsQuery, LeadsTable_GetConversationsQueryVariables>(
    LeadsTable_GetConversationsDocument,
    options,
  );
}
export type LeadsTable_GetConversationsQueryHookResult = ReturnType<typeof useLeadsTable_GetConversationsQuery>;
export type LeadsTable_GetConversationsLazyQueryHookResult = ReturnType<typeof useLeadsTable_GetConversationsLazyQuery>;
export function refetchLeadsTable_GetConversationsQuery(variables?: LeadsTable_GetConversationsQueryVariables) {
  return { query: LeadsTable_GetConversationsDocument, variables: variables };
}
export const ApplicationRequest_GetDataDocument = gql`
  query ApplicationRequest_GetData($conversationId: String!, $listingAlias: String!) {
    ZRM_getConversationById(conversationId: $conversationId, listingAlias: $listingAlias) {
      conversationId
      inquiry {
        id
        phone
      }
      referenceEmail
      referenceName
      applicationAlreadySent
      isApplicationsAccepted
    }
  }
`;

/**
 * __useApplicationRequest_GetDataQuery__
 *
 * To run a query within a React component, call `useApplicationRequest_GetDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationRequest_GetDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationRequest_GetDataQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      listingAlias: // value for 'listingAlias'
 *   },
 * });
 */
export function useApplicationRequest_GetDataQuery(
  baseOptions: Apollo.QueryHookOptions<ApplicationRequest_GetDataQuery, ApplicationRequest_GetDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ApplicationRequest_GetDataQuery, ApplicationRequest_GetDataQueryVariables>(
    ApplicationRequest_GetDataDocument,
    options,
  );
}
export function useApplicationRequest_GetDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ApplicationRequest_GetDataQuery, ApplicationRequest_GetDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ApplicationRequest_GetDataQuery, ApplicationRequest_GetDataQueryVariables>(
    ApplicationRequest_GetDataDocument,
    options,
  );
}
export type ApplicationRequest_GetDataQueryHookResult = ReturnType<typeof useApplicationRequest_GetDataQuery>;
export type ApplicationRequest_GetDataLazyQueryHookResult = ReturnType<typeof useApplicationRequest_GetDataLazyQuery>;
export function refetchApplicationRequest_GetDataQuery(variables?: ApplicationRequest_GetDataQueryVariables) {
  return { query: ApplicationRequest_GetDataDocument, variables: variables };
}
export const MessageList_FetchPaginatedMessagesDocument = gql`
  query MessageList_fetchPaginatedMessages(
    $conversationId: String!
    $listingAlias: String!
    $paginationStartIndex: String
    $clientTimeZone: String!
  ) {
    ZRM_getConversationById(
      conversationId: $conversationId
      listingAlias: $listingAlias
      paginationStartIndex: $paginationStartIndex
      includeAttachmentsMetadata: true
      includeSystemMessages: true
      clientTimeZone: $clientTimeZone
    ) {
      conversationId
      conversation {
        ...MessageItemData
      }
      ...MessagesPagination
    }
  }
  ${MessageItemDataFragmentDoc}
  ${MessagesPaginationFragmentDoc}
`;

/**
 * __useMessageList_FetchPaginatedMessagesQuery__
 *
 * To run a query within a React component, call `useMessageList_FetchPaginatedMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageList_FetchPaginatedMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageList_FetchPaginatedMessagesQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      listingAlias: // value for 'listingAlias'
 *      paginationStartIndex: // value for 'paginationStartIndex'
 *      clientTimeZone: // value for 'clientTimeZone'
 *   },
 * });
 */
export function useMessageList_FetchPaginatedMessagesQuery(
  baseOptions: Apollo.QueryHookOptions<
    MessageList_FetchPaginatedMessagesQuery,
    MessageList_FetchPaginatedMessagesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MessageList_FetchPaginatedMessagesQuery, MessageList_FetchPaginatedMessagesQueryVariables>(
    MessageList_FetchPaginatedMessagesDocument,
    options,
  );
}
export function useMessageList_FetchPaginatedMessagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MessageList_FetchPaginatedMessagesQuery,
    MessageList_FetchPaginatedMessagesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MessageList_FetchPaginatedMessagesQuery, MessageList_FetchPaginatedMessagesQueryVariables>(
    MessageList_FetchPaginatedMessagesDocument,
    options,
  );
}
export type MessageList_FetchPaginatedMessagesQueryHookResult = ReturnType<
  typeof useMessageList_FetchPaginatedMessagesQuery
>;
export type MessageList_FetchPaginatedMessagesLazyQueryHookResult = ReturnType<
  typeof useMessageList_FetchPaginatedMessagesLazyQuery
>;
export function refetchMessageList_FetchPaginatedMessagesQuery(
  variables?: MessageList_FetchPaginatedMessagesQueryVariables,
) {
  return { query: MessageList_FetchPaginatedMessagesDocument, variables: variables };
}
export const MessageList_GetConversationDocument = gql`
  query MessageList_GetConversation(
    $conversationId: String!
    $listingAlias: String
    $paginationStartIndex: String
    $clientTimeZone: String!
  ) {
    ZRM_getConversationById(
      conversationId: $conversationId
      listingAlias: $listingAlias
      paginationStartIndex: $paginationStartIndex
      includeAttachmentsMetadata: true
      includeInquiryInfo: true
      includeUserLeadAttributes: true
      includeRenterProfile: true
      includeSystemMessages: true
      clientTimeZone: $clientTimeZone
    ) {
      activeParticipantsInConversation {
        name
      }
      applicationAlreadySent
      conversationId
      conversation {
        ...MessageItemData
      }
      propertyTypeCode
      hasUnreadMessage
      referenceEmail
      hasQuickResponses
      ...MessagesPagination
      ...RenterProfileAttributes
      ...RenterProfileData
      ...QuickResponse
      ...NavigationData
    }
  }
  ${MessageItemDataFragmentDoc}
  ${MessagesPaginationFragmentDoc}
  ${RenterProfileAttributesFragmentDoc}
  ${RenterProfileDataFragmentDoc}
  ${QuickResponseFragmentDoc}
  ${NavigationDataFragmentDoc}
`;

/**
 * __useMessageList_GetConversationQuery__
 *
 * To run a query within a React component, call `useMessageList_GetConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageList_GetConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageList_GetConversationQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      listingAlias: // value for 'listingAlias'
 *      paginationStartIndex: // value for 'paginationStartIndex'
 *      clientTimeZone: // value for 'clientTimeZone'
 *   },
 * });
 */
export function useMessageList_GetConversationQuery(
  baseOptions: Apollo.QueryHookOptions<MessageList_GetConversationQuery, MessageList_GetConversationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MessageList_GetConversationQuery, MessageList_GetConversationQueryVariables>(
    MessageList_GetConversationDocument,
    options,
  );
}
export function useMessageList_GetConversationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MessageList_GetConversationQuery,
    MessageList_GetConversationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MessageList_GetConversationQuery, MessageList_GetConversationQueryVariables>(
    MessageList_GetConversationDocument,
    options,
  );
}
export type MessageList_GetConversationQueryHookResult = ReturnType<typeof useMessageList_GetConversationQuery>;
export type MessageList_GetConversationLazyQueryHookResult = ReturnType<typeof useMessageList_GetConversationLazyQuery>;
export function refetchMessageList_GetConversationQuery(variables?: MessageList_GetConversationQueryVariables) {
  return { query: MessageList_GetConversationDocument, variables: variables };
}
export const MessageListActions_GetConversationDataDocument = gql`
  query MessageListActions_getConversationData(
    $conversationId: String!
    $listingAlias: String!
    $clientTimeZone: String!
  ) {
    ZRM_getConversationById(
      conversationId: $conversationId
      listingAlias: $listingAlias
      includeRenterProfile: true
      clientTimeZone: $clientTimeZone
    ) {
      conversationId
      inquiry {
        id
        isPhoneLead
        name
      }
      isConversationBlockedByZillow
      referenceName
      renterProfile {
        shouldShowRequestRenterProfileCta
      }
      ...Status
    }
  }
  ${StatusFragmentDoc}
`;

/**
 * __useMessageListActions_GetConversationDataQuery__
 *
 * To run a query within a React component, call `useMessageListActions_GetConversationDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageListActions_GetConversationDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageListActions_GetConversationDataQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      listingAlias: // value for 'listingAlias'
 *      clientTimeZone: // value for 'clientTimeZone'
 *   },
 * });
 */
export function useMessageListActions_GetConversationDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    MessageListActions_GetConversationDataQuery,
    MessageListActions_GetConversationDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    MessageListActions_GetConversationDataQuery,
    MessageListActions_GetConversationDataQueryVariables
  >(MessageListActions_GetConversationDataDocument, options);
}
export function useMessageListActions_GetConversationDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MessageListActions_GetConversationDataQuery,
    MessageListActions_GetConversationDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MessageListActions_GetConversationDataQuery,
    MessageListActions_GetConversationDataQueryVariables
  >(MessageListActions_GetConversationDataDocument, options);
}
export type MessageListActions_GetConversationDataQueryHookResult = ReturnType<
  typeof useMessageListActions_GetConversationDataQuery
>;
export type MessageListActions_GetConversationDataLazyQueryHookResult = ReturnType<
  typeof useMessageListActions_GetConversationDataLazyQuery
>;
export function refetchMessageListActions_GetConversationDataQuery(
  variables?: MessageListActions_GetConversationDataQueryVariables,
) {
  return { query: MessageListActions_GetConversationDataDocument, variables: variables };
}
export const ApplicationsUpsellModal_EnableApplicationsDocument = gql`
  mutation ApplicationsUpsellModal_enableApplications($listingAlias: String!) {
    ZRM_applicationsAccepted(listingAlias: $listingAlias, applicationsAccepted: true) {
      success
    }
  }
`;
export type ApplicationsUpsellModal_EnableApplicationsMutationFn = Apollo.MutationFunction<
  ApplicationsUpsellModal_EnableApplicationsMutation,
  ApplicationsUpsellModal_EnableApplicationsMutationVariables
>;

/**
 * __useApplicationsUpsellModal_EnableApplicationsMutation__
 *
 * To run a mutation, you first call `useApplicationsUpsellModal_EnableApplicationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplicationsUpsellModal_EnableApplicationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applicationsUpsellModalEnableApplicationsMutation, { data, loading, error }] = useApplicationsUpsellModal_EnableApplicationsMutation({
 *   variables: {
 *      listingAlias: // value for 'listingAlias'
 *   },
 * });
 */
export function useApplicationsUpsellModal_EnableApplicationsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApplicationsUpsellModal_EnableApplicationsMutation,
    ApplicationsUpsellModal_EnableApplicationsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ApplicationsUpsellModal_EnableApplicationsMutation,
    ApplicationsUpsellModal_EnableApplicationsMutationVariables
  >(ApplicationsUpsellModal_EnableApplicationsDocument, options);
}
export type ApplicationsUpsellModal_EnableApplicationsMutationHookResult = ReturnType<
  typeof useApplicationsUpsellModal_EnableApplicationsMutation
>;
export type ApplicationsUpsellModal_EnableApplicationsMutationOptions = Apollo.BaseMutationOptions<
  ApplicationsUpsellModal_EnableApplicationsMutation,
  ApplicationsUpsellModal_EnableApplicationsMutationVariables
>;
export const RenterProfileModal_GetRenterProfileDataDocument = gql`
  query RenterProfileModal_getRenterProfileData($conversationId: String!, $listingAlias: String!) {
    ZRM_getConversationById(conversationId: $conversationId, listingAlias: $listingAlias) {
      inquiry {
        name
      }
      ...RenterProfileAttributes
    }
  }
  ${RenterProfileAttributesFragmentDoc}
`;

/**
 * __useRenterProfileModal_GetRenterProfileDataQuery__
 *
 * To run a query within a React component, call `useRenterProfileModal_GetRenterProfileDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useRenterProfileModal_GetRenterProfileDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRenterProfileModal_GetRenterProfileDataQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      listingAlias: // value for 'listingAlias'
 *   },
 * });
 */
export function useRenterProfileModal_GetRenterProfileDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    RenterProfileModal_GetRenterProfileDataQuery,
    RenterProfileModal_GetRenterProfileDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    RenterProfileModal_GetRenterProfileDataQuery,
    RenterProfileModal_GetRenterProfileDataQueryVariables
  >(RenterProfileModal_GetRenterProfileDataDocument, options);
}
export function useRenterProfileModal_GetRenterProfileDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RenterProfileModal_GetRenterProfileDataQuery,
    RenterProfileModal_GetRenterProfileDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RenterProfileModal_GetRenterProfileDataQuery,
    RenterProfileModal_GetRenterProfileDataQueryVariables
  >(RenterProfileModal_GetRenterProfileDataDocument, options);
}
export type RenterProfileModal_GetRenterProfileDataQueryHookResult = ReturnType<
  typeof useRenterProfileModal_GetRenterProfileDataQuery
>;
export type RenterProfileModal_GetRenterProfileDataLazyQueryHookResult = ReturnType<
  typeof useRenterProfileModal_GetRenterProfileDataLazyQuery
>;
export function refetchRenterProfileModal_GetRenterProfileDataQuery(
  variables?: RenterProfileModal_GetRenterProfileDataQueryVariables,
) {
  return { query: RenterProfileModal_GetRenterProfileDataDocument, variables: variables };
}
export const SendApplicationConfirmationModal_GetModalDataDocument = gql`
  query SendApplicationConfirmationModal_getModalData($conversationId: String!, $listingAlias: String!) {
    ZRM_getConversationById(conversationId: $conversationId, includeInquiryInfo: true, listingAlias: $listingAlias) {
      conversationId
      inquiry {
        id
        name
      }
    }
  }
`;

/**
 * __useSendApplicationConfirmationModal_GetModalDataQuery__
 *
 * To run a query within a React component, call `useSendApplicationConfirmationModal_GetModalDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendApplicationConfirmationModal_GetModalDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendApplicationConfirmationModal_GetModalDataQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      listingAlias: // value for 'listingAlias'
 *   },
 * });
 */
export function useSendApplicationConfirmationModal_GetModalDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    SendApplicationConfirmationModal_GetModalDataQuery,
    SendApplicationConfirmationModal_GetModalDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SendApplicationConfirmationModal_GetModalDataQuery,
    SendApplicationConfirmationModal_GetModalDataQueryVariables
  >(SendApplicationConfirmationModal_GetModalDataDocument, options);
}
export function useSendApplicationConfirmationModal_GetModalDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SendApplicationConfirmationModal_GetModalDataQuery,
    SendApplicationConfirmationModal_GetModalDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SendApplicationConfirmationModal_GetModalDataQuery,
    SendApplicationConfirmationModal_GetModalDataQueryVariables
  >(SendApplicationConfirmationModal_GetModalDataDocument, options);
}
export type SendApplicationConfirmationModal_GetModalDataQueryHookResult = ReturnType<
  typeof useSendApplicationConfirmationModal_GetModalDataQuery
>;
export type SendApplicationConfirmationModal_GetModalDataLazyQueryHookResult = ReturnType<
  typeof useSendApplicationConfirmationModal_GetModalDataLazyQuery
>;
export function refetchSendApplicationConfirmationModal_GetModalDataQuery(
  variables?: SendApplicationConfirmationModal_GetModalDataQueryVariables,
) {
  return { query: SendApplicationConfirmationModal_GetModalDataDocument, variables: variables };
}
export const SendMessageModal_AddMessageToConversationV2Document = gql`
  mutation SendMessageModal_addMessageToConversationV2(
    $conversationId: String!
    $listingAlias: String!
    $message: String!
    $zDocIds: [String!]!
  ) {
    ZRM_addMessageToConversationV2(
      conversationId: $conversationId
      listingAlias: $listingAlias
      message: $message
      zDocIds: $zDocIds
    ) {
      ...MessageItemData
    }
  }
  ${MessageItemDataFragmentDoc}
`;
export type SendMessageModal_AddMessageToConversationV2MutationFn = Apollo.MutationFunction<
  SendMessageModal_AddMessageToConversationV2Mutation,
  SendMessageModal_AddMessageToConversationV2MutationVariables
>;

/**
 * __useSendMessageModal_AddMessageToConversationV2Mutation__
 *
 * To run a mutation, you first call `useSendMessageModal_AddMessageToConversationV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageModal_AddMessageToConversationV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageModalAddMessageToConversationV2Mutation, { data, loading, error }] = useSendMessageModal_AddMessageToConversationV2Mutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      listingAlias: // value for 'listingAlias'
 *      message: // value for 'message'
 *      zDocIds: // value for 'zDocIds'
 *   },
 * });
 */
export function useSendMessageModal_AddMessageToConversationV2Mutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendMessageModal_AddMessageToConversationV2Mutation,
    SendMessageModal_AddMessageToConversationV2MutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendMessageModal_AddMessageToConversationV2Mutation,
    SendMessageModal_AddMessageToConversationV2MutationVariables
  >(SendMessageModal_AddMessageToConversationV2Document, options);
}
export type SendMessageModal_AddMessageToConversationV2MutationHookResult = ReturnType<
  typeof useSendMessageModal_AddMessageToConversationV2Mutation
>;
export type SendMessageModal_AddMessageToConversationV2MutationOptions = Apollo.BaseMutationOptions<
  SendMessageModal_AddMessageToConversationV2Mutation,
  SendMessageModal_AddMessageToConversationV2MutationVariables
>;
export const SendMessageModal_GetConversationDataDocument = gql`
  query SendMessageModal_getConversationData(
    $clientTimeZone: String!
    $conversationId: String!
    $listingAlias: String!
  ) {
    ZRM_getConversationById(
      clientTimeZone: $clientTimeZone
      conversationId: $conversationId
      listingAlias: $listingAlias
    ) {
      conversation {
        conversationId
        messagePreview
        messageId
        messageDateMs
        senderName
      }
      conversationId
      inquiry {
        id
        name
      }
      referenceName
      ...Status
    }
  }
  ${StatusFragmentDoc}
`;

/**
 * __useSendMessageModal_GetConversationDataQuery__
 *
 * To run a query within a React component, call `useSendMessageModal_GetConversationDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendMessageModal_GetConversationDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendMessageModal_GetConversationDataQuery({
 *   variables: {
 *      clientTimeZone: // value for 'clientTimeZone'
 *      conversationId: // value for 'conversationId'
 *      listingAlias: // value for 'listingAlias'
 *   },
 * });
 */
export function useSendMessageModal_GetConversationDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    SendMessageModal_GetConversationDataQuery,
    SendMessageModal_GetConversationDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SendMessageModal_GetConversationDataQuery, SendMessageModal_GetConversationDataQueryVariables>(
    SendMessageModal_GetConversationDataDocument,
    options,
  );
}
export function useSendMessageModal_GetConversationDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SendMessageModal_GetConversationDataQuery,
    SendMessageModal_GetConversationDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SendMessageModal_GetConversationDataQuery,
    SendMessageModal_GetConversationDataQueryVariables
  >(SendMessageModal_GetConversationDataDocument, options);
}
export type SendMessageModal_GetConversationDataQueryHookResult = ReturnType<
  typeof useSendMessageModal_GetConversationDataQuery
>;
export type SendMessageModal_GetConversationDataLazyQueryHookResult = ReturnType<
  typeof useSendMessageModal_GetConversationDataLazyQuery
>;
export function refetchSendMessageModal_GetConversationDataQuery(
  variables?: SendMessageModal_GetConversationDataQueryVariables,
) {
  return { query: SendMessageModal_GetConversationDataDocument, variables: variables };
}
export const SendMessageModal_GetAttachmentsByConversationIdDocument = gql`
  query SendMessageModal_getAttachmentsByConversationId($conversationId: String!) {
    ZRM_getAttachmentsByConversationId(conversationId: $conversationId) {
      attachments {
        zDocId
      }
    }
  }
`;

/**
 * __useSendMessageModal_GetAttachmentsByConversationIdQuery__
 *
 * To run a query within a React component, call `useSendMessageModal_GetAttachmentsByConversationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendMessageModal_GetAttachmentsByConversationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendMessageModal_GetAttachmentsByConversationIdQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useSendMessageModal_GetAttachmentsByConversationIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    SendMessageModal_GetAttachmentsByConversationIdQuery,
    SendMessageModal_GetAttachmentsByConversationIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SendMessageModal_GetAttachmentsByConversationIdQuery,
    SendMessageModal_GetAttachmentsByConversationIdQueryVariables
  >(SendMessageModal_GetAttachmentsByConversationIdDocument, options);
}
export function useSendMessageModal_GetAttachmentsByConversationIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SendMessageModal_GetAttachmentsByConversationIdQuery,
    SendMessageModal_GetAttachmentsByConversationIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SendMessageModal_GetAttachmentsByConversationIdQuery,
    SendMessageModal_GetAttachmentsByConversationIdQueryVariables
  >(SendMessageModal_GetAttachmentsByConversationIdDocument, options);
}
export type SendMessageModal_GetAttachmentsByConversationIdQueryHookResult = ReturnType<
  typeof useSendMessageModal_GetAttachmentsByConversationIdQuery
>;
export type SendMessageModal_GetAttachmentsByConversationIdLazyQueryHookResult = ReturnType<
  typeof useSendMessageModal_GetAttachmentsByConversationIdLazyQuery
>;
export function refetchSendMessageModal_GetAttachmentsByConversationIdQuery(
  variables?: SendMessageModal_GetAttachmentsByConversationIdQueryVariables,
) {
  return { query: SendMessageModal_GetAttachmentsByConversationIdDocument, variables: variables };
}
export const TourCancellationModalRenterDetailsDocument = gql`
  query TourCancellationModalRenterDetails($conversationId: String!, $listingAlias: String!) {
    ZRM_getConversationById(conversationId: $conversationId, listingAlias: $listingAlias) {
      conversationId
      referenceName
    }
  }
`;

/**
 * __useTourCancellationModalRenterDetailsQuery__
 *
 * To run a query within a React component, call `useTourCancellationModalRenterDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTourCancellationModalRenterDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTourCancellationModalRenterDetailsQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      listingAlias: // value for 'listingAlias'
 *   },
 * });
 */
export function useTourCancellationModalRenterDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    TourCancellationModalRenterDetailsQuery,
    TourCancellationModalRenterDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TourCancellationModalRenterDetailsQuery, TourCancellationModalRenterDetailsQueryVariables>(
    TourCancellationModalRenterDetailsDocument,
    options,
  );
}
export function useTourCancellationModalRenterDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TourCancellationModalRenterDetailsQuery,
    TourCancellationModalRenterDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TourCancellationModalRenterDetailsQuery, TourCancellationModalRenterDetailsQueryVariables>(
    TourCancellationModalRenterDetailsDocument,
    options,
  );
}
export type TourCancellationModalRenterDetailsQueryHookResult = ReturnType<
  typeof useTourCancellationModalRenterDetailsQuery
>;
export type TourCancellationModalRenterDetailsLazyQueryHookResult = ReturnType<
  typeof useTourCancellationModalRenterDetailsLazyQuery
>;
export function refetchTourCancellationModalRenterDetailsQuery(
  variables?: TourCancellationModalRenterDetailsQueryVariables,
) {
  return { query: TourCancellationModalRenterDetailsDocument, variables: variables };
}
export const NotesModal_GetNotesDataDocument = gql`
  query NotesModal_getNotesData($conversationId: String!, $listingAlias: String!) {
    ZRM_getConversationById(
      conversationId: $conversationId
      includeInquiryInfo: true
      includeUserLeadAttributes: true
      listingAlias: $listingAlias
    ) {
      inquiry {
        isPhoneLead
        name
        phone
      }
      ...NotesSectionData
    }
  }
  ${NotesSectionDataFragmentDoc}
`;

/**
 * __useNotesModal_GetNotesDataQuery__
 *
 * To run a query within a React component, call `useNotesModal_GetNotesDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotesModal_GetNotesDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotesModal_GetNotesDataQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      listingAlias: // value for 'listingAlias'
 *   },
 * });
 */
export function useNotesModal_GetNotesDataQuery(
  baseOptions: Apollo.QueryHookOptions<NotesModal_GetNotesDataQuery, NotesModal_GetNotesDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<NotesModal_GetNotesDataQuery, NotesModal_GetNotesDataQueryVariables>(
    NotesModal_GetNotesDataDocument,
    options,
  );
}
export function useNotesModal_GetNotesDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<NotesModal_GetNotesDataQuery, NotesModal_GetNotesDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<NotesModal_GetNotesDataQuery, NotesModal_GetNotesDataQueryVariables>(
    NotesModal_GetNotesDataDocument,
    options,
  );
}
export type NotesModal_GetNotesDataQueryHookResult = ReturnType<typeof useNotesModal_GetNotesDataQuery>;
export type NotesModal_GetNotesDataLazyQueryHookResult = ReturnType<typeof useNotesModal_GetNotesDataLazyQuery>;
export function refetchNotesModal_GetNotesDataQuery(variables?: NotesModal_GetNotesDataQueryVariables) {
  return { query: NotesModal_GetNotesDataDocument, variables: variables };
}
export const NotesModal_GetNewStatusLabelsDocument = gql`
  query NotesModal_getNewStatusLabels($conversationId: String!, $listingAlias: String!, $clientTimeZone: String!) {
    ZRM_getLatestConversationsV2(
      conversationId: $conversationId
      listingAlias: $listingAlias
      clientTimeZone: $clientTimeZone
      includeStatusLabels: true
    ) {
      conversations {
        conversationId
        ...StatusLabel
      }
    }
  }
  ${StatusLabelFragmentDoc}
`;

/**
 * __useNotesModal_GetNewStatusLabelsQuery__
 *
 * To run a query within a React component, call `useNotesModal_GetNewStatusLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotesModal_GetNewStatusLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotesModal_GetNewStatusLabelsQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      listingAlias: // value for 'listingAlias'
 *      clientTimeZone: // value for 'clientTimeZone'
 *   },
 * });
 */
export function useNotesModal_GetNewStatusLabelsQuery(
  baseOptions: Apollo.QueryHookOptions<NotesModal_GetNewStatusLabelsQuery, NotesModal_GetNewStatusLabelsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<NotesModal_GetNewStatusLabelsQuery, NotesModal_GetNewStatusLabelsQueryVariables>(
    NotesModal_GetNewStatusLabelsDocument,
    options,
  );
}
export function useNotesModal_GetNewStatusLabelsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    NotesModal_GetNewStatusLabelsQuery,
    NotesModal_GetNewStatusLabelsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<NotesModal_GetNewStatusLabelsQuery, NotesModal_GetNewStatusLabelsQueryVariables>(
    NotesModal_GetNewStatusLabelsDocument,
    options,
  );
}
export type NotesModal_GetNewStatusLabelsQueryHookResult = ReturnType<typeof useNotesModal_GetNewStatusLabelsQuery>;
export type NotesModal_GetNewStatusLabelsLazyQueryHookResult = ReturnType<
  typeof useNotesModal_GetNewStatusLabelsLazyQuery
>;
export function refetchNotesModal_GetNewStatusLabelsQuery(variables?: NotesModal_GetNewStatusLabelsQueryVariables) {
  return { query: NotesModal_GetNewStatusLabelsDocument, variables: variables };
}
export const NotesBar_GetInboxPageDataDocument = gql`
  query NotesBar_getInboxPageData($conversationId: String!, $listingAlias: String!, $clientTimeZone: String!) {
    ZRM_getConversationById(
      conversationId: $conversationId
      clientTimeZone: $clientTimeZone
      listingAlias: $listingAlias
    ) {
      applicationAlreadySent
      ...StatusLabel
      ...NotesSectionData
    }
  }
  ${StatusLabelFragmentDoc}
  ${NotesSectionDataFragmentDoc}
`;

/**
 * __useNotesBar_GetInboxPageDataQuery__
 *
 * To run a query within a React component, call `useNotesBar_GetInboxPageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotesBar_GetInboxPageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotesBar_GetInboxPageDataQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      listingAlias: // value for 'listingAlias'
 *      clientTimeZone: // value for 'clientTimeZone'
 *   },
 * });
 */
export function useNotesBar_GetInboxPageDataQuery(
  baseOptions: Apollo.QueryHookOptions<NotesBar_GetInboxPageDataQuery, NotesBar_GetInboxPageDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<NotesBar_GetInboxPageDataQuery, NotesBar_GetInboxPageDataQueryVariables>(
    NotesBar_GetInboxPageDataDocument,
    options,
  );
}
export function useNotesBar_GetInboxPageDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<NotesBar_GetInboxPageDataQuery, NotesBar_GetInboxPageDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<NotesBar_GetInboxPageDataQuery, NotesBar_GetInboxPageDataQueryVariables>(
    NotesBar_GetInboxPageDataDocument,
    options,
  );
}
export type NotesBar_GetInboxPageDataQueryHookResult = ReturnType<typeof useNotesBar_GetInboxPageDataQuery>;
export type NotesBar_GetInboxPageDataLazyQueryHookResult = ReturnType<typeof useNotesBar_GetInboxPageDataLazyQuery>;
export function refetchNotesBar_GetInboxPageDataQuery(variables?: NotesBar_GetInboxPageDataQueryVariables) {
  return { query: NotesBar_GetInboxPageDataDocument, variables: variables };
}
export const RentalJourneyFilters_GetConversationToLoadDocument = gql`
  query RentalJourneyFilters_GetConversationToLoad(
    $folder: Folder
    $daysBack: Int
    $listingAlias: String
    $renterProgressStatus: RenterProgressStatus
  ) {
    ZRM_getLatestConversationsV2(
      limit: 1
      folder: $folder
      daysBack: $daysBack
      listingAlias: $listingAlias
      renterProgressStatus: $renterProgressStatus
    ) {
      conversations {
        conversationId
        listingAlias
      }
    }
  }
`;

/**
 * __useRentalJourneyFilters_GetConversationToLoadQuery__
 *
 * To run a query within a React component, call `useRentalJourneyFilters_GetConversationToLoadQuery` and pass it any options that fit your needs.
 * When your component renders, `useRentalJourneyFilters_GetConversationToLoadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRentalJourneyFilters_GetConversationToLoadQuery({
 *   variables: {
 *      folder: // value for 'folder'
 *      daysBack: // value for 'daysBack'
 *      listingAlias: // value for 'listingAlias'
 *      renterProgressStatus: // value for 'renterProgressStatus'
 *   },
 * });
 */
export function useRentalJourneyFilters_GetConversationToLoadQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RentalJourneyFilters_GetConversationToLoadQuery,
    RentalJourneyFilters_GetConversationToLoadQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    RentalJourneyFilters_GetConversationToLoadQuery,
    RentalJourneyFilters_GetConversationToLoadQueryVariables
  >(RentalJourneyFilters_GetConversationToLoadDocument, options);
}
export function useRentalJourneyFilters_GetConversationToLoadLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RentalJourneyFilters_GetConversationToLoadQuery,
    RentalJourneyFilters_GetConversationToLoadQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RentalJourneyFilters_GetConversationToLoadQuery,
    RentalJourneyFilters_GetConversationToLoadQueryVariables
  >(RentalJourneyFilters_GetConversationToLoadDocument, options);
}
export type RentalJourneyFilters_GetConversationToLoadQueryHookResult = ReturnType<
  typeof useRentalJourneyFilters_GetConversationToLoadQuery
>;
export type RentalJourneyFilters_GetConversationToLoadLazyQueryHookResult = ReturnType<
  typeof useRentalJourneyFilters_GetConversationToLoadLazyQuery
>;
export function refetchRentalJourneyFilters_GetConversationToLoadQuery(
  variables?: RentalJourneyFilters_GetConversationToLoadQueryVariables,
) {
  return { query: RentalJourneyFilters_GetConversationToLoadDocument, variables: variables };
}
export const RenterProfileInlineDataDocument = gql`
  query RenterProfileInlineData($conversationId: String!, $listingAlias: String!) {
    ZRM_getConversationById(conversationId: $conversationId, listingAlias: $listingAlias, includeRenterProfile: true) {
      conversation {
        conversationId
        senderName
      }
      ...RenterProfileAttributes
    }
  }
  ${RenterProfileAttributesFragmentDoc}
`;

/**
 * __useRenterProfileInlineDataQuery__
 *
 * To run a query within a React component, call `useRenterProfileInlineDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useRenterProfileInlineDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRenterProfileInlineDataQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      listingAlias: // value for 'listingAlias'
 *   },
 * });
 */
export function useRenterProfileInlineDataQuery(
  baseOptions: Apollo.QueryHookOptions<RenterProfileInlineDataQuery, RenterProfileInlineDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RenterProfileInlineDataQuery, RenterProfileInlineDataQueryVariables>(
    RenterProfileInlineDataDocument,
    options,
  );
}
export function useRenterProfileInlineDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<RenterProfileInlineDataQuery, RenterProfileInlineDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RenterProfileInlineDataQuery, RenterProfileInlineDataQueryVariables>(
    RenterProfileInlineDataDocument,
    options,
  );
}
export type RenterProfileInlineDataQueryHookResult = ReturnType<typeof useRenterProfileInlineDataQuery>;
export type RenterProfileInlineDataLazyQueryHookResult = ReturnType<typeof useRenterProfileInlineDataLazyQuery>;
export function refetchRenterProfileInlineDataQuery(variables?: RenterProfileInlineDataQueryVariables) {
  return { query: RenterProfileInlineDataDocument, variables: variables };
}
export const LeadManagementStats_GetStatsDocument = gql`
  query LeadManagementStats_getStats($listingAlias: String!) {
    ZRM_getLeadManagementStats(listingAlias: $listingAlias) {
      stats {
        screeningCriteriaType
        criterionMatchedCount
        percentageMatched
        isNegotiable
        screeningCriterionNameDisplay
        screeningCriterionDisplay
        isCriterionSet
      }
      leadsQualifiedForCriteriaTotal
      hasCriteriaSet
      listingAddress
    }
  }
`;

/**
 * __useLeadManagementStats_GetStatsQuery__
 *
 * To run a query within a React component, call `useLeadManagementStats_GetStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeadManagementStats_GetStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeadManagementStats_GetStatsQuery({
 *   variables: {
 *      listingAlias: // value for 'listingAlias'
 *   },
 * });
 */
export function useLeadManagementStats_GetStatsQuery(
  baseOptions: Apollo.QueryHookOptions<LeadManagementStats_GetStatsQuery, LeadManagementStats_GetStatsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LeadManagementStats_GetStatsQuery, LeadManagementStats_GetStatsQueryVariables>(
    LeadManagementStats_GetStatsDocument,
    options,
  );
}
export function useLeadManagementStats_GetStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LeadManagementStats_GetStatsQuery,
    LeadManagementStats_GetStatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LeadManagementStats_GetStatsQuery, LeadManagementStats_GetStatsQueryVariables>(
    LeadManagementStats_GetStatsDocument,
    options,
  );
}
export type LeadManagementStats_GetStatsQueryHookResult = ReturnType<typeof useLeadManagementStats_GetStatsQuery>;
export type LeadManagementStats_GetStatsLazyQueryHookResult = ReturnType<
  typeof useLeadManagementStats_GetStatsLazyQuery
>;
export function refetchLeadManagementStats_GetStatsQuery(variables?: LeadManagementStats_GetStatsQueryVariables) {
  return { query: LeadManagementStats_GetStatsDocument, variables: variables };
}
export const ConversationActionsHook_UpdateConversationStatusDocument = gql`
  mutation conversationActionsHook_updateConversationStatus(
    $conversationId: String!
    $isArchived: Boolean
    $reportReasonType: ReportConversationReason
    $userReportComment: String
  ) {
    ZRM_updateConversationStatusV2(
      conversationId: $conversationId
      isArchived: $isArchived
      reportReasonType: $reportReasonType
      userReportComment: $userReportComment
    ) {
      success
    }
  }
`;
export type ConversationActionsHook_UpdateConversationStatusMutationFn = Apollo.MutationFunction<
  ConversationActionsHook_UpdateConversationStatusMutation,
  ConversationActionsHook_UpdateConversationStatusMutationVariables
>;

/**
 * __useConversationActionsHook_UpdateConversationStatusMutation__
 *
 * To run a mutation, you first call `useConversationActionsHook_UpdateConversationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConversationActionsHook_UpdateConversationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [conversationActionsHookUpdateConversationStatusMutation, { data, loading, error }] = useConversationActionsHook_UpdateConversationStatusMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      isArchived: // value for 'isArchived'
 *      reportReasonType: // value for 'reportReasonType'
 *      userReportComment: // value for 'userReportComment'
 *   },
 * });
 */
export function useConversationActionsHook_UpdateConversationStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConversationActionsHook_UpdateConversationStatusMutation,
    ConversationActionsHook_UpdateConversationStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConversationActionsHook_UpdateConversationStatusMutation,
    ConversationActionsHook_UpdateConversationStatusMutationVariables
  >(ConversationActionsHook_UpdateConversationStatusDocument, options);
}
export type ConversationActionsHook_UpdateConversationStatusMutationHookResult = ReturnType<
  typeof useConversationActionsHook_UpdateConversationStatusMutation
>;
export type ConversationActionsHook_UpdateConversationStatusMutationOptions = Apollo.BaseMutationOptions<
  ConversationActionsHook_UpdateConversationStatusMutation,
  ConversationActionsHook_UpdateConversationStatusMutationVariables
>;
export const ConversationActionsHook_MarkConversationAsReadDocument = gql`
  mutation conversationActionsHook_markConversationAsRead($conversationId: String!, $lastReadMs: String!) {
    ZRM_updateConversationStatusV2(conversationId: $conversationId, lastReadMs: $lastReadMs) {
      success
    }
  }
`;
export type ConversationActionsHook_MarkConversationAsReadMutationFn = Apollo.MutationFunction<
  ConversationActionsHook_MarkConversationAsReadMutation,
  ConversationActionsHook_MarkConversationAsReadMutationVariables
>;

/**
 * __useConversationActionsHook_MarkConversationAsReadMutation__
 *
 * To run a mutation, you first call `useConversationActionsHook_MarkConversationAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConversationActionsHook_MarkConversationAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [conversationActionsHookMarkConversationAsReadMutation, { data, loading, error }] = useConversationActionsHook_MarkConversationAsReadMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      lastReadMs: // value for 'lastReadMs'
 *   },
 * });
 */
export function useConversationActionsHook_MarkConversationAsReadMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConversationActionsHook_MarkConversationAsReadMutation,
    ConversationActionsHook_MarkConversationAsReadMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConversationActionsHook_MarkConversationAsReadMutation,
    ConversationActionsHook_MarkConversationAsReadMutationVariables
  >(ConversationActionsHook_MarkConversationAsReadDocument, options);
}
export type ConversationActionsHook_MarkConversationAsReadMutationHookResult = ReturnType<
  typeof useConversationActionsHook_MarkConversationAsReadMutation
>;
export type ConversationActionsHook_MarkConversationAsReadMutationOptions = Apollo.BaseMutationOptions<
  ConversationActionsHook_MarkConversationAsReadMutation,
  ConversationActionsHook_MarkConversationAsReadMutationVariables
>;
export const InviteToApplyHook_InviteToApplyDocument = gql`
  mutation inviteToApplyHook_inviteToApply(
    $listingId: String!
    $renterFirstName: String!
    $renterLastName: String!
    $toEmail: String!
    $resendEmail: Boolean!
  ) {
    ZRM_inviteToApply(
      listingId: $listingId
      renterFirstName: $renterFirstName
      renterLastName: $renterLastName
      toEmail: $toEmail
      resendEmail: $resendEmail
    ) {
      response
    }
  }
`;
export type InviteToApplyHook_InviteToApplyMutationFn = Apollo.MutationFunction<
  InviteToApplyHook_InviteToApplyMutation,
  InviteToApplyHook_InviteToApplyMutationVariables
>;

/**
 * __useInviteToApplyHook_InviteToApplyMutation__
 *
 * To run a mutation, you first call `useInviteToApplyHook_InviteToApplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteToApplyHook_InviteToApplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteToApplyHookInviteToApplyMutation, { data, loading, error }] = useInviteToApplyHook_InviteToApplyMutation({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      renterFirstName: // value for 'renterFirstName'
 *      renterLastName: // value for 'renterLastName'
 *      toEmail: // value for 'toEmail'
 *      resendEmail: // value for 'resendEmail'
 *   },
 * });
 */
export function useInviteToApplyHook_InviteToApplyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InviteToApplyHook_InviteToApplyMutation,
    InviteToApplyHook_InviteToApplyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<InviteToApplyHook_InviteToApplyMutation, InviteToApplyHook_InviteToApplyMutationVariables>(
    InviteToApplyHook_InviteToApplyDocument,
    options,
  );
}
export type InviteToApplyHook_InviteToApplyMutationHookResult = ReturnType<
  typeof useInviteToApplyHook_InviteToApplyMutation
>;
export type InviteToApplyHook_InviteToApplyMutationOptions = Apollo.BaseMutationOptions<
  InviteToApplyHook_InviteToApplyMutation,
  InviteToApplyHook_InviteToApplyMutationVariables
>;
export const InboxPageRouterHook_GetConversationToLoadDocument = gql`
  query InboxPageRouterHook_GetConversationToLoad(
    $folder: Folder
    $daysBack: Int
    $listingAlias: String
    $renterProgressStatus: RenterProgressStatus
    $readRepliedStatus: ReadRepliedStatus
  ) {
    ZRM_getLatestConversationsV2(
      limit: 1
      folder: $folder
      daysBack: $daysBack
      listingAlias: $listingAlias
      renterProgressStatus: $renterProgressStatus
      readRepliedStatus: $readRepliedStatus
    ) {
      conversations {
        conversationId
        listingAlias
      }
    }
  }
`;

/**
 * __useInboxPageRouterHook_GetConversationToLoadQuery__
 *
 * To run a query within a React component, call `useInboxPageRouterHook_GetConversationToLoadQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxPageRouterHook_GetConversationToLoadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxPageRouterHook_GetConversationToLoadQuery({
 *   variables: {
 *      folder: // value for 'folder'
 *      daysBack: // value for 'daysBack'
 *      listingAlias: // value for 'listingAlias'
 *      renterProgressStatus: // value for 'renterProgressStatus'
 *      readRepliedStatus: // value for 'readRepliedStatus'
 *   },
 * });
 */
export function useInboxPageRouterHook_GetConversationToLoadQuery(
  baseOptions?: Apollo.QueryHookOptions<
    InboxPageRouterHook_GetConversationToLoadQuery,
    InboxPageRouterHook_GetConversationToLoadQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    InboxPageRouterHook_GetConversationToLoadQuery,
    InboxPageRouterHook_GetConversationToLoadQueryVariables
  >(InboxPageRouterHook_GetConversationToLoadDocument, options);
}
export function useInboxPageRouterHook_GetConversationToLoadLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InboxPageRouterHook_GetConversationToLoadQuery,
    InboxPageRouterHook_GetConversationToLoadQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    InboxPageRouterHook_GetConversationToLoadQuery,
    InboxPageRouterHook_GetConversationToLoadQueryVariables
  >(InboxPageRouterHook_GetConversationToLoadDocument, options);
}
export type InboxPageRouterHook_GetConversationToLoadQueryHookResult = ReturnType<
  typeof useInboxPageRouterHook_GetConversationToLoadQuery
>;
export type InboxPageRouterHook_GetConversationToLoadLazyQueryHookResult = ReturnType<
  typeof useInboxPageRouterHook_GetConversationToLoadLazyQuery
>;
export function refetchInboxPageRouterHook_GetConversationToLoadQuery(
  variables?: InboxPageRouterHook_GetConversationToLoadQueryVariables,
) {
  return { query: InboxPageRouterHook_GetConversationToLoadDocument, variables: variables };
}
export const InboxPage_GetFeatureFlagsDocument = gql`
  query InboxPage_getFeatureFlags {
    getFeatureFlags(appName: "satellite_web") {
      enableLeadMessaging
      enableQuickResponse
      enableUserObjectOptimization
      enableWebsocketIntegration
      enableMessageLinkInSLW
      enableMessageToolbar
      canAccessBlockedUserModalFromRJSModule
    }
  }
`;

/**
 * __useInboxPage_GetFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useInboxPage_GetFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxPage_GetFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxPage_GetFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useInboxPage_GetFeatureFlagsQuery(
  baseOptions?: Apollo.QueryHookOptions<InboxPage_GetFeatureFlagsQuery, InboxPage_GetFeatureFlagsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<InboxPage_GetFeatureFlagsQuery, InboxPage_GetFeatureFlagsQueryVariables>(
    InboxPage_GetFeatureFlagsDocument,
    options,
  );
}
export function useInboxPage_GetFeatureFlagsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<InboxPage_GetFeatureFlagsQuery, InboxPage_GetFeatureFlagsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<InboxPage_GetFeatureFlagsQuery, InboxPage_GetFeatureFlagsQueryVariables>(
    InboxPage_GetFeatureFlagsDocument,
    options,
  );
}
export type InboxPage_GetFeatureFlagsQueryHookResult = ReturnType<typeof useInboxPage_GetFeatureFlagsQuery>;
export type InboxPage_GetFeatureFlagsLazyQueryHookResult = ReturnType<typeof useInboxPage_GetFeatureFlagsLazyQuery>;
export function refetchInboxPage_GetFeatureFlagsQuery(variables?: InboxPage_GetFeatureFlagsQueryVariables) {
  return { query: InboxPage_GetFeatureFlagsDocument, variables: variables };
}
export const PropertyFilterHook_GetPropertyAddressDocument = gql`
  query PropertyFilterHook_getPropertyAddress($listingAlias: String!) {
    ZRM_getPropertyAddress(propertyId: $listingAlias) {
      city
      state
      street
      unit
      zip
    }
  }
`;

/**
 * __usePropertyFilterHook_GetPropertyAddressQuery__
 *
 * To run a query within a React component, call `usePropertyFilterHook_GetPropertyAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyFilterHook_GetPropertyAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyFilterHook_GetPropertyAddressQuery({
 *   variables: {
 *      listingAlias: // value for 'listingAlias'
 *   },
 * });
 */
export function usePropertyFilterHook_GetPropertyAddressQuery(
  baseOptions: Apollo.QueryHookOptions<
    PropertyFilterHook_GetPropertyAddressQuery,
    PropertyFilterHook_GetPropertyAddressQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PropertyFilterHook_GetPropertyAddressQuery,
    PropertyFilterHook_GetPropertyAddressQueryVariables
  >(PropertyFilterHook_GetPropertyAddressDocument, options);
}
export function usePropertyFilterHook_GetPropertyAddressLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PropertyFilterHook_GetPropertyAddressQuery,
    PropertyFilterHook_GetPropertyAddressQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PropertyFilterHook_GetPropertyAddressQuery,
    PropertyFilterHook_GetPropertyAddressQueryVariables
  >(PropertyFilterHook_GetPropertyAddressDocument, options);
}
export type PropertyFilterHook_GetPropertyAddressQueryHookResult = ReturnType<
  typeof usePropertyFilterHook_GetPropertyAddressQuery
>;
export type PropertyFilterHook_GetPropertyAddressLazyQueryHookResult = ReturnType<
  typeof usePropertyFilterHook_GetPropertyAddressLazyQuery
>;
export function refetchPropertyFilterHook_GetPropertyAddressQuery(
  variables?: PropertyFilterHook_GetPropertyAddressQueryVariables,
) {
  return { query: PropertyFilterHook_GetPropertyAddressDocument, variables: variables };
}
export const InviteToApplyHook_GetConversationDataDocument = gql`
  query inviteToApplyHook_getConversationData($conversationId: String!, $listingAlias: String!) {
    ZRM_getConversationById(
      conversationId: $conversationId
      listingAlias: $listingAlias
      includeInquiryInfo: true
      includeUserLeadAttributes: true
    ) {
      ...InviteToApplyData
    }
  }
  ${InviteToApplyDataFragmentDoc}
`;

/**
 * __useInviteToApplyHook_GetConversationDataQuery__
 *
 * To run a query within a React component, call `useInviteToApplyHook_GetConversationDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useInviteToApplyHook_GetConversationDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInviteToApplyHook_GetConversationDataQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      listingAlias: // value for 'listingAlias'
 *   },
 * });
 */
export function useInviteToApplyHook_GetConversationDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    InviteToApplyHook_GetConversationDataQuery,
    InviteToApplyHook_GetConversationDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    InviteToApplyHook_GetConversationDataQuery,
    InviteToApplyHook_GetConversationDataQueryVariables
  >(InviteToApplyHook_GetConversationDataDocument, options);
}
export function useInviteToApplyHook_GetConversationDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InviteToApplyHook_GetConversationDataQuery,
    InviteToApplyHook_GetConversationDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    InviteToApplyHook_GetConversationDataQuery,
    InviteToApplyHook_GetConversationDataQueryVariables
  >(InviteToApplyHook_GetConversationDataDocument, options);
}
export type InviteToApplyHook_GetConversationDataQueryHookResult = ReturnType<
  typeof useInviteToApplyHook_GetConversationDataQuery
>;
export type InviteToApplyHook_GetConversationDataLazyQueryHookResult = ReturnType<
  typeof useInviteToApplyHook_GetConversationDataLazyQuery
>;
export function refetchInviteToApplyHook_GetConversationDataQuery(
  variables?: InviteToApplyHook_GetConversationDataQueryVariables,
) {
  return { query: InviteToApplyHook_GetConversationDataDocument, variables: variables };
}
export const Experiment_GetTreatmentDocument = gql`
  query Experiment_getTreatment($featureName: String!, $listingAlias: String) {
    ZRM_getExperimentTreatment(featureName: $featureName, listingAlias: $listingAlias) {
      featureName
      treatment
    }
  }
`;

/**
 * __useExperiment_GetTreatmentQuery__
 *
 * To run a query within a React component, call `useExperiment_GetTreatmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useExperiment_GetTreatmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExperiment_GetTreatmentQuery({
 *   variables: {
 *      featureName: // value for 'featureName'
 *      listingAlias: // value for 'listingAlias'
 *   },
 * });
 */
export function useExperiment_GetTreatmentQuery(
  baseOptions: Apollo.QueryHookOptions<Experiment_GetTreatmentQuery, Experiment_GetTreatmentQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Experiment_GetTreatmentQuery, Experiment_GetTreatmentQueryVariables>(
    Experiment_GetTreatmentDocument,
    options,
  );
}
export function useExperiment_GetTreatmentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Experiment_GetTreatmentQuery, Experiment_GetTreatmentQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Experiment_GetTreatmentQuery, Experiment_GetTreatmentQueryVariables>(
    Experiment_GetTreatmentDocument,
    options,
  );
}
export type Experiment_GetTreatmentQueryHookResult = ReturnType<typeof useExperiment_GetTreatmentQuery>;
export type Experiment_GetTreatmentLazyQueryHookResult = ReturnType<typeof useExperiment_GetTreatmentLazyQuery>;
export function refetchExperiment_GetTreatmentQuery(variables?: Experiment_GetTreatmentQueryVariables) {
  return { query: Experiment_GetTreatmentDocument, variables: variables };
}
